(function() {
  'use strict';

  angular
    .module('bbackoffice', [
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ui.router',
        'ui.bootstrap',
        'toastr',
        'daterangepicker',
        'ui.select',
        'angularjs-dropdown-multiselect',
        'currencyFormat',
        'ui.router.tabs',
        'pascalprecht.translate',
        'ngTreetable',
        'jsonFormatter',
        'ui.ace',
        'nvd3',
        'ngFileUpload',
        'NgSwitchery',
        'angular.filter',
        'chart.js'
    ]);

})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .filter('propsFilter', propsFilterFilter);

    /** @ngInject */
    function propsFilterFilter() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                items.forEach(function(item) {
                    var itemMatches = false;

                    var keys = Object.keys(props);
                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .filter('numberFix', numberFixFilter);

    /** @ngInject */
    function numberFixFilter($locale, $sce, currencyFormatService) {
        return function (amount, currencyCode, isColored) {
            if (!currencyCode || Number(amount) != amount) {
                return;
            }

            var formattedCurrency,
                currency = currencyFormatService.getByCode(currencyCode),
                formatedAmount = Math.abs(amount),
                signAmount = amount < 0 ? '-' : '',
                rtl = false;

            // Fraction size

            var currentFractionSize = 0;
            var useUniqSymbol = false;
            var onlyAmount = false;

            formatedAmount = formatedAmount.toFixed(currentFractionSize);

            // Format numeral by locale ID

           // var localeId = 'en_US';
           // var languageOptions = currencyFormatService.getLanguageByCode(localeId);
            var languageOptions = {decimal: ",", "thousands": "."};
            formatedAmount = formatedAmount.split('.').join(languageOptions.decimal);
            formatedAmount = formatedAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languageOptions.thousands);

            // Format currency
            return formatedAmount;
        };
    }
})();



(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .filter('htmlSafe', htmlSafe);

    /** @ngInject */
    function htmlSafe($sce) {
        return function(htmlCode){
            return $sce.trustAsHtml(htmlCode);
        };
    }
})();



(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .filter('currencyFix', currencyFixFilter);

    /** @ngInject */
    function currencyFixFilter($locale, $sce, currencyFormatService) {
        return function (amount, currencyCode, isColored) {
            if (!currencyCode || Number(amount) != amount) {
                return;
            }

          var formattedCurrency,
                currency = currencyFormatService.getByCode(currencyCode),
                formatedAmount = Math.abs(amount),
                signAmount = amount < 0 ? '-' : '',
                rtl = false;

            // Fraction size

            var currentFractionSize = currency.fractionSize;
            var useUniqSymbol = false;
            var onlyAmount = false;

            formatedAmount = formatedAmount.toFixed(currentFractionSize);

            // Format numeral by locale ID

            //var localeId = 'de_DE';
            //var languageOptions = currencyFormatService.getLanguageByCode(localeId);
            var languageOptions = {decimal: ",", "thousands": "."};
            formatedAmount = formatedAmount.split('.').join(languageOptions.decimal);
            formatedAmount = formatedAmount.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languageOptions.thousands);

            // Format currency

            if (onlyAmount) {
                formattedCurrency = signAmount + formatedAmount;
            } else if (!!currency && !useUniqSymbol && !!currency.symbol && !!currency.symbol.template) {
                formattedCurrency = currency.symbol.template.replace('1', formatedAmount);
                formattedCurrency = formattedCurrency.replace('$', currency.symbol.grapheme);
                formattedCurrency = signAmount + formattedCurrency;
                rtl = !!currency.symbol.rtl;
            }
            else if (!!currency && !!useUniqSymbol && !!currency.uniqSymbol && !!currency.uniqSymbol.template) {
                formattedCurrency = currency.uniqSymbol.template.replace('1', formatedAmount);
                formattedCurrency = formattedCurrency.replace('$', currency.uniqSymbol.grapheme);
                formattedCurrency = signAmount + formattedCurrency;
                rtl = !!currency.uniqSymbol.rtl;
            }
            else {
                formattedCurrency = signAmount + formatedAmount + ' ' + currencyCode;
            }

            if ((typeof isColored != "undefined") && (isColored)) {
                if (amount > 0) {
                    return $sce.trustAsHtml('<span class="amount-green">' + formattedCurrency + '</span>');
                } else if (amount == 0) {
                    return $sce.trustAsHtml('<span class="">' + formattedCurrency + '</span>');
                } else {
                    return $sce.trustAsHtml('<span class="amount-red">'+formattedCurrency+'</span>');
                }

            }
            return formattedCurrency;
        };
    }
})();



(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .service('TabService', TabService);

    /** @ngInject */
    function TabService() {
        var vm = this;
        vm.data = [
            {
                heading: '<i>Turnover Report: Today</i>',
                route: 'management.report.account'
            },
            {
                heading: '<i>Turnover Report: Yesterday</i>',
                route: 'management.report.account',
                params:  {
                    currencySet: "disabled"
                }
            },
            {
                heading: '<i>Player Report</i>',
                route: 'management.report.player'
            }
        ];
        return vm;
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .service('NotificationService', NotificationService);

    /** @ngInject */
    function NotificationService() {
        var vm = this;
        vm.notification = {};
        vm.notification.type = 'circle';
        vm.notification.position = 'top-right';

        vm.showNotification = function(title, message, color) {
            var color = 'error'; // Info, Success, Error etc
            var position = vm.notification.position; // Placement of the notification

            switch (vm.notification.type) {
                case 'bar':
                    // Show an bar notification attached to top and bottom of the screen
                    $('body').pgNotification({
                        style: 'bar',
                        message: message,
                        position: position,
                        timeout: 0,
                        type: color
                    }).show();
                    break;
                case 'flip':
                    // Show a flipping notification animated
                    // using CSS3 transforms and animations
                    $('body').pgNotification({
                        style: 'flip',
                        message: message,
                        position: position,
                        timeout: 0,
                        type: color
                    }).show();
                    break;
                case 'circle':
                    // Slide-in a circle notification from sides
                    // You have to provide the HTML for thumbnail
                    $('body').pgNotification({
                        style: 'circle',
                        title: title,
                        message: message,
                        position: position,
                        timeout: 4000,
                        type: color,
                        thumbnail: '<img width="40" height="40" style="display: inline-block;" src="assets/img/icons/favicon-96x96.png" data-src="assets/img/icons/favicon-96x96.png" ui-jq="unveil" data-src-retina="assets/img/icons/favicon-96x96.png" alt="">'
                    }).show();
                    break;
                case 'simple':
                    // Simple notification having bootstrap's .alert class
                    $('body').pgNotification({
                        style: 'simple',
                        message: message,
                        position: position,
                        timeout: 0,
                        type: color
                    }).show();
                    break;
            }

        };

        return vm;
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .service('ApiService', ApiService);

    /** @ngInject */
    function ApiService($http, $cookies, $rootScope, $q, toastr, $state, ACTIONS, ENV) {
        var vm = this;
        vm.pending = [];
        vm.baseApiUrl = ENV.apiUrl;
        vm.apiUrl = vm.baseApiUrl + "/sysapi/v2";
        $http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
        vm.postData = {};
        vm.loginAttempt = 0;
        vm.selectedUser = 0;
        vm.apiPermissions = {};
        vm.selectedAccounts = [];
        vm.currencies = {};

        vm.checkPermission = function (permissionName) {
            // if ((typeof vm.apiPermissions !== "undefined") && (typeof vm.apiPermissions[permissionName] === "undefined")) {
            //     $state.go('auth.login');
            // } else {
            //     return true;
            // }
        };

        vm.add = function (action) {
            vm.pending.push(action);
        };

        vm.remove = function (action) {
            vm.pending = _.filter(vm.pending, function (p) {
                return p.action !== action;
            });
        };


        vm.cancelAll = function () {
            angular.forEach(vm.pending, function (p) {
                p.canceller.resolve();
            });
            vm.pending.length = 0;
        };

        vm.cancel = function (action) {
            angular.forEach(vm.pending, function (p) {
                if (p.action === action) {
                    p.canceller.resolve();
                    vm.remove(action);
                }
            });
        };

        /* Inject token request post data  */
        vm.injectToken = function () {
            var token = $cookies.get('BO_TOKEN');
            if (!token) {
                token = "1";
            }

            if (vm.postData === undefined) {
                vm.postData = {
                    token: token
                };
            }

            vm.postData.token = token;
        };

        /* Set fresh token */
        vm.setToken = function (token) {
            $cookies.put('BO_TOKEN', token);
        };


        /* Call api methods.  */
        vm.call = function (action, parameters, callBack, rejectCallBack) {
            vm.postData = parameters;
            vm.postData.action = action;
            if (vm.selectedUser != 0) {
                vm.postData.selectedUser = vm.selectedUser;
            }
            vm.injectToken();
            var url = vm.apiUrl + '/' + vm.postData.token;
            var canceller = $q.defer();
            vm.add({
                url: url,
                action: action,
                canceller: canceller
            });

            $http
                .post(url, JSON.stringify(vm.postData))
                .then(function (response) {
                    vm.setToken(response.data.Response.token);
                    $rootScope.$broadcast('LoginCheck');
                    if (typeof response.data.Response !== 'undefined' && response.data.Status === true) {

                        vm.currencies = {};
                        if (action === ACTIONS.LOGIN) {
                            toastr.success(response.data.Message, 'Information');
                        }

                        callBack(response.data.Response);

                    } else {
                        throw new Error("API request failed! MSG: " + response.data.Message);
                    }
                })
                .catch(function (err) {
                    toastr.error(err.message, 'Error');
                    if (rejectCallBack && typeof rejectCallBack === "function")
                        rejectCallBack(err);
                })
                .finally(function () {
                    vm.remove(action);
                });
        };

        return vm;
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('SiteGamesController', SiteGamesController);

    /** @ngInject */
    function SiteGamesController(ApiService,ACTIONS,$rootScope,$scope,EVENTS,$filter) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('site_games_access');

        vm.site = null;
        vm.list=[];

        vm.getSiteGamesBySiteId = function () {
            // $scope.main.setLoading(true);

            ApiService.call(ACTIONS.LIST_SITE_GAMES, {site: vm.site, owner:ApiService.selectedAccounts}, function (response) {
                vm.list = response.games;

                // $scope.main.setLoading(false);
            });
        };

        vm.toggleGameStatus = function (game) {
            // $scope.main.setLoading(true);

            var status = game.status == 0 ? 1 : 0;
            ApiService.call(ACTIONS.TOGGLE_SITE_GAME_STATUS, {site: vm.site,gameId:game.game_id,status:status,owner:ApiService.selectedAccounts}, function (response) {
                vm.getSiteGamesBySiteId();
                // $scope.main.setLoading(false);
            });
        };

        vm.bootSystem = function () {
            console.log("SITE GAMES");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_SITE_GAMES');
            vm.site = $scope.main._user.sites[0].id;

            vm.getSiteGamesBySiteId();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);

    }

})();
(function () {
    "use strict";

    angular
        .module("bbackoffice")
        .controller("SeamlessWalletController", SeamlessWalletController)
        .controller("SeamlessWalletGeneratorController", SeamlessWalletGeneratorController)
        .controller("SeamlessWalletTestController", SeamlessWalletTestController);

    /** @ngInject */
    function SeamlessWalletController($rootScope,$filter,ApiService) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('seamless_wallet_access');

        vm.bootSystem = function () {
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_SEAMLESS_WALLET_INTEGRATION');
        };

        vm.bootSystem();
    }

    function SeamlessWalletGeneratorController($filter, $rootScope, $scope, EVENTS, ApiService,ACTIONS) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('seamless_wallet_generator_access');

        vm.tabs = {
            active: 1,
            values: [
                {
                    title: $filter("translate")("SEAMLESS_WALLET_INTEGRATION_GENERATOR_TAB_AUTHENTICATION"),
                    htmlUrl: "app/views/seamless-wallet/generator-tab-content.html",
                    postObj:{}
                },
                {
                    title: $filter("translate")("SEAMLESS_WALLET_INTEGRATION_GENERATOR_TAB_GET_PLAYER_INFORMATION"),
                    htmlUrl: "app/views/seamless-wallet/generator-tab-content.html",
                    postObj:{}
                },
                {
                    title: $filter("translate")("SEAMLESS_WALLET_INTEGRATION_GENERATOR_TAB_GET_PLAYER_BALANCE"),
                    htmlUrl: "app/views/seamless-wallet/generator-tab-content.html",
                    postObj:{}
                },
                {
                    title: $filter("translate")("SEAMLESS_WALLET_INTEGRATION_GENERATOR_TAB_DEBIT_AMOUNT"),
                    htmlUrl: "app/views/seamless-wallet/generator-tab-content.html",
                    postObj:{}
                },
                {
                    title: $filter("translate")("SEAMLESS_WALLET_INTEGRATION_GENERATOR_TAB_CREDIT_AMOUNT"),
                    htmlUrl: "app/views/seamless-wallet/generator-tab-content.html",
                    postObj:{}
                },
                {
                    title: $filter("translate")("SEAMLESS_WALLET_INTEGRATION_GENERATOR_TAB_ROLLBACK_AMOUNT"),
                    htmlUrl: "app/views/seamless-wallet/generator-tab-content.html",
                    postObj:{}
                }
            ]
        };
        vm.generator = {
            domain: "https://",
            url: "",
            originalParameters: [
                {
                    publicKey:'',
                    accessKey:'',
                    privateKey:''
                },
                {
                    action:'',
                    siteId:'',
                    ownerId:'',
                    ownerExternalId:'',
                    playerId:'',
                    playerExternalId:'',
                    playerUsername:'',
                    sessionId:'',
                    sessionType:'',
                    gameId:'',
                    uniqueId:'',
                    timestamp:''
                },
                {
                    action:'',
                    siteId:'',
                    ownerId:'',
                    ownerExternalId:'',
                    playerId:'',
                    playerExternalId:'',
                    playerUsername:'',
                    sessionId:'',
                    sessionType:'',
                    gameId:'',
                    uniqueId:'',
                    timestamp:''
                },
                {
                    action:'',
                    siteId:'',
                    ownerId:'',
                    ownerExternalId:'',
                    playerId:'',
                    playerExternalId:'',
                    playerUsername:'',
                    sessionId:'',
                    sessionType:'',
                    gameId:'',
                    uniqueId:'',
                    transactionId:'',
                    debitAmount:'',
                    debitCurrency:'',
                    roundId:'',
                    timestamp:''
                },
                {
                    action:'',
                    siteId:'',
                    ownerId:'',
                    ownerExternalId:'',
                    playerId:'',
                    playerExternalId:'',
                    playerUsername:'',
                    sessionId:'',
                    sessionType:'',
                    gameId:'',
                    uniqueId:'',
                    transactionId:'',
                    creditAmount:'',
                    creditCurrency:'',
                    roundId:'',
                    timestamp:''
                },
                {
                    action:'',
                    siteId:'',
                    ownerId:'',
                    ownerExternalId:'',
                    playerId:'',
                    playerExternalId:'',
                    playerUsername:'',
                    sessionId:'',
                    sessionType:'',
                    gameId:'',
                    uniqueId:'',
                    transactionId:'',
                    rollbackAmount:'',
                    rollbackCurrency:'',
                    roundId:'',
                    timestamp:''
                }
            ]
        };
        vm.selectedObj = {};
        vm.selectedObjKeys = [];
        vm.postData = {};
        vm.requestData = {};
/*        vm.newParam = {
            key:'',
            value:''
        };*/

        vm.setActiveTab = function (tabKey) {
            vm.tabs.active = tabKey;
            vm.refreshObjectKeys();
        };

        vm.resetPostParameters = function () {
            angular.forEach(vm.generator.originalParameters,function (value, key) {
                vm.tabs.values[key].postObj = angular.copy(value);
            });
            vm.refreshObjectKeys();
        };

        vm.fakePost = function () {
            var activeTabObj = angular.copy(vm.tabs.values[vm.tabs.active].postObj);
            var authenticationObj = angular.copy(vm.tabs.values[0].postObj);

            vm.postData = angular.merge(authenticationObj,activeTabObj);
            vm.requestData = {};
            var url = vm.generator.domain + vm.generator.url;

            $scope.main.setLoading(true);
            ApiService.call(ACTIONS.SEAMLESS_WALLET_INTEGRATION,{url:url,postData:vm.postData},function (response) {
                vm.requestData = response.data;
                $scope.main.setLoading(false);
            });
        };

/*        vm.removeParam = function (key) {
            if(vm.tabs.values[vm.tabs.active].postObj[key] != undefined || vm.tabs.values[vm.tabs.active].postObj[key] != null){
                delete vm.tabs.values[vm.tabs.active].postObj[key];
                vm.refreshObjectKeys();
            }
        };

        vm.addParam = function () {
            if(vm.newParam.key != '' && vm.tabs.values[vm.tabs.active].postObj[vm.newParam.key] == undefined && vm.tabs.values[vm.tabs.active].postObj[vm.newParam.key] == null){
                vm.tabs.values[vm.tabs.active].postObj[vm.newParam.key] = vm.newParam.value;
                vm.newParam = {
                    key:'',
                    value:''
                };
            }
            vm.refreshObjectKeys();
        };*/

        vm.refreshObjectKeys = function () {
            vm.selectedObj = vm.tabs.values[vm.tabs.active].postObj;
            vm.selectedObjKeys = Object.keys(vm.selectedObj);
        };

        vm.bootSystem = function () {
            console.log("SEAMLESS WALLET INTEGRATION GENERATOR");
            vm.resetPostParameters();
            vm.setActiveTab(1);
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on("$destroy", vm.bootFn);
    }

    function SeamlessWalletTestController(ApiService,ACTIONS,$rootScope,$scope,EVENTS) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('seamless_wallet_test_access');

        vm.tester = {
            url:'',
            playerId:0,
            gameId:''
        };
        vm.response={};
        vm.players = [];
        vm.games = [];

        vm.testIt = function () {
            vm.response = {};
            // $scope.main.setLoading(true);
            ApiService.call(ACTIONS.TEST,vm.tester,function (response) {
                vm.response = response.testResult;
                // $scope.main.setLoading(false);
            });
        };

        vm.getPlayers = function () {
            ApiService.call(ACTIONS.PLAYERS,{process:'getPlayers',owner:ApiService.selectedAccounts},function (response) {
               vm.players = response.players;

               var firstPlayer = vm.players[Object.keys(vm.players)[0]];
               vm.tester.playerId = firstPlayer.id;
            });
        };

        vm.bootSystem = function () {
            // setting first game as selected game
            var firstGame = $scope.main._user.games[Object.keys($scope.main._user.games)[0]];
            vm.tester.gameId = firstGame.id;
        };

        vm.accountChangeFn = $rootScope.$on(EVENTS.SELECTED_ACCOUNTS_CHANGED, function (event, accounts) {
            vm.getPlayers();
        });

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET,function (event,params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);

        // destroy accountChangeFn
        $scope.$on('$destroy', vm.accountChangeFn);
    }

})();
(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('ReportController', ReportController);

  /** @ngInject */
  function ReportController(ApiService, ACTIONS, EVENTS, $rootScope, $scope, $filter, ngTreetableParams, $state) {
    var vm = this;

    vm.extraData = {
      accountName: null,
      accountId: null,
      limit: 20,
      page: $state.params.page || 1
    };

    // checking user permission
    ApiService.checkPermission('reports_access');

    vm.records = null;
    vm.currency = $scope.main._user.currency;

    vm.siteRecords = null;
    vm.exportsEnabled = true;
    vm.expandedRecords = new ngTreetableParams({
      getTemplate: function (node) {
        return 'tree_node';
      },
      options: {
        onNodeExpand: function () {
          // console.log('A node was expanded!');
        },
        clickableNodeNames: true
      }
    });
    vm.view = 'list';
    vm.graph = {
      options: {},
      data: []
    };

    vm.setView = function (view) {
      vm.view = view;
    };

    vm.setGraph = function (graph) {
      vm.graph = graph;
    };

    function expendReportRows(level) {

      if (!level) level = 1;

      setTimeout(function () {
        var mustOpenNodes = Array.from(document.querySelectorAll("table tr.isOpened:not(._opened)"));

        angular.forEach(mustOpenNodes, function (value, key) {
          value.classList.add("_opened")
          var firstTD = value.querySelector("td")
          if (firstTD)
            firstTD.click()
        });

        // expend 10 level
        if (level < 10)
          expendReportRows(level + 1)
      }, level * 100)
    }

    vm.recordChanged = function () {
      // empty function
      var queryAccount = $scope.main.filters.queryAccount
      if (queryAccount.enabled && queryAccount.value) {
        expendReportRows(1)
      }
    };

    vm.setRecordChanged = function (fn) {
      vm.recordChanged = fn;
    };

    // set currency
    vm.setCurrency = function (response) {
      if (response.user && response.user.currency)
        vm.currency = response.user.currency;

      if ($scope.main.filters.currencyExchange.value === "disabled" &&
        response.report && response.report.totals && response.report.totals.currency)
        vm.currency = response.report.totals.currency;

    };

    vm.generatePagination = function (records, page, limit) {
      if (!records.totalPages && records.count) {
        records.page = page
        records.totalPages = Math.floor(records.count / limit)
        records.start = 1
        records.end = records.totalPages
      }
    }

    vm.appendSitesNameToReport = function (records) {
      angular.forEach(records.list, function (report, key) {
        if (report.siteId) {
          var len = $scope.main._user.sites.length
          for (var i = 0; i < len; i++) {
            if ($scope.main._user.sites[i] && $scope.main._user.sites[i].id === report.siteId) {
              report.siteName = $scope.main._user.sites[i].domain
            }
          }
        }
      })
    }

    // setting record list
    vm.setRecords = function (records) {
      vm.records = records;
      vm.recordChanged();
    };

    // setting site records
    vm.setSiteRecords = function (records) {
      vm.siteRecords = records;

      angular.forEach(vm.siteRecords.sites, function (value, key) {
        var site = $scope.main.findSite(key);
        if (site !== null) {
          value.info = site;
        } else {
          value.info = {
            domain: ""
          };
        }
      });

      if (vm.siteRecords !== null && vm.siteRecords !== undefined) {
        // getting first site id
        for (var first in vm.siteRecords.sites) break;
        $scope.main.filters.platforms.setValue(first);
        vm.setRecords(vm.siteRecords.sites[first]);
      }
    };

    vm.beforeApplyBtn = function () {
      $scope.main.updateCookiesFilters();
    };

    // getting records by filter
    vm.getReport = function () {
      vm.beforeApplyBtn();
      $scope.main.setLoading(true);

      var merged = angular.merge($scope.main.flatFilters, vm.extraData);
      merged.game = $scope.main.sharedFilters.game || [];
      merged.owner = $scope.main.sharedFilters.owner;
      merged.site = $scope.main.sharedFilters.site || [];
      merged.currencyExchange = $scope.main.sharedFilters.currencyExchange;

      merged.filter = $scope.main.sharedFilters;

      delete merged.filter.accountsList;
      delete merged.filter.game;
      delete merged.filter.owner;
      delete merged.filter.site;
      delete merged.filter.currencyExchange;

      merged.filter = $scope.main.sharedFilters;

      // convert to cent
      if (merged.filter.bet) {
        merged.filter.bet = $scope.main.convertToCent(merged.filter.bet)
      }

      // convert to cent
      if (merged.filter.win) {
        merged.filter.win = $scope.main.convertToCent(merged.filter.win)
      }

      // convert to cent
      if (merged.filter.profit) {
        merged.filter.profit = $scope.main.convertToCent(merged.filter.profit)
      }

      var queryAccount = $scope.main.filters.queryAccount
      if (queryAccount.enabled && queryAccount.value) {
        merged.queryAccount = merged.filter.queryAccount;
      }

      if (merged.filter.sortBy)
        merged.sortBy = merged.filter.sortBy;
      if (merged.filter.sortStyle)
        merged.sortStyle = merged.filter.sortStyle;


      delete merged.filter.queryAccount;
      delete merged.filter.sortBy;
      delete merged.filter.sortStyle;

      ApiService.call(ACTIONS.REPORT, merged, function (response) {
        $scope.report.setCurrency(response);
        switch ($scope.main.flatFilters.viewAs) {
          case 'normal':
            vm.generatePagination(response.report, merged.page, merged.limit)
            if (merged.reportType === "macaw") {
              vm.appendSitesNameToReport(response.report)
            }
            vm.setRecords(response.report);
            break;
          case 'platform':
            vm.setSiteRecords(response.report);
            break;
        }
        $scope.main.setLoading(false);
      }, function () {
        $scope.main.setLoading(false);
      });
    };

    vm.setExpandedRecords = function (newVal) {
      if (newVal != null || newVal != undefined) {
        vm.expandedRecords.getNodes = function (parent) {
          return parent ? parent.subAccs : newVal;
        };
      } else {
        vm.expandedRecords.getNodes = function (parent) {
          return [];
        };
      }
      vm.expandedRecords.refresh();
    };

    vm.resetVariablesFn = $rootScope.$on(EVENTS.ROUTE_CHANGE_START, function (event, toState, toParams, fromState, fromParams, options) {
      // reset variables
      vm.records = null;
      vm.siteRecords = null;
      vm.graph = {
        options: {},
        data: []
      };
      vm.view = 'list';
    });

    vm.exportPdf = function () {
      // empty function
    };

    vm.setExportPdf = function (fn) {
      vm.exportPdf = fn;
    };

    vm.exportExcel = function () {
      // empty function
    };

    vm.setExportExcel = function (fn) {
      vm.exportExcel = fn;
    };

    // system boot function
    vm.bootSystem = function () {
      console.log("REPORT");

      // let subAccountsArray = []
      // angular.forEach($scope.main._selectedUser.subAccs, function (item, id) {
      //   subAccountsArray.push({id: id, value: id, username: item.username, active: item.isChecked})
      // })
      // $scope.main.filters.accountsList.setOptions(subAccountsArray);

      // customize filters
      $scope.main.filters.reportType.setOptions([
        {
          value: 'account',
          label: $filter('translate')('FILTER_REPORT_TYPE_ACCOUNT')
        },
        {
          value: 'player',
          label: $filter('translate')('FILTER_REPORT_TYPE_PLAYER')
        },
        {
          value: 'session',
          label: $filter('translate')('FILTER_REPORT_TYPE_SESSION')
        },
        {
          value: 'rounds',
          label: $filter('translate')('FILTER_REPORT_TYPE_ROUNDS')
        }
      ]);
      $scope.main.filters.reportType.setEvents({
        valueChange: function (reportType) {
          switch (reportType) {
            case 'account':
              $state.go('management.report.account');
              break;
            case 'player':
              $state.go('management.report.player');
              break;
            case 'session':
              $state.go('management.report.session');
              break;
          }
        }
      });

      vm.extraData.accountId = $state.params.accountId || null;
      vm.extraData.accountName = $state.params.accountName || null;
      vm.extraData.page = parseInt($state.params.page) || 1;

      // search button click event
      $scope.main.filters.setApplyFilter(vm.getReport);

      // watch record list and refresh table
      $scope.$watch('report.records.list', function (newVal, oldVal) {
        vm.setExpandedRecords(newVal);
      }, true);
    };

    vm.bootFn = function () {
      // empty function
    };

    vm.setBootFn = function (fn) {
      vm.bootFn = fn;
    };

    vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
      // booting system
      vm.bootSystem();
      vm.bootFn();
    });

    // destroy system bootFn
    $scope.$on('$destroy', vm.bootFn);

    // destroy system bootFn
    $scope.$on('$destroy', vm.resetVariablesFn);


  }
})();

(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('TurnoverReportController', TurnoverReportController);

  /** @ngInject */
  function TurnoverReportController(ApiService, $scope, $filter, $rootScope) {
    var vm = this;

    // checking user permission
    ApiService.checkPermission('turnover_report_access');

    vm.subAccountsCount = 0;

    // setting filters default values
    vm.setFilters = function () {
      // FILTER SETTINGS

      // column filter
      $scope.main.filters.columns.setOptions([
        {
          'id': 0,
          'columnName': $filter('translate')('FILTER_COLUMNS_OWNER_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_OWNER_LABEL'),
          'friendlyName': 'username',
          'active': true
        },
        {
          'id': 1,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_BET_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_BET_LABEL'),
          'friendlyName': 'deposits',
          'active': true
        },
        {
          'id': 2,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_WIN_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_WIN_LABEL'),
          'friendlyName': 'withdraws',
          'active': true
        },
        {
          'id': 3,
          'columnName': $filter('translate')('FILTER_COLUMNS_FR_WIN_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_FR_WIN_LABEL'),
          'friendlyName': 'freeround_withdraws',
          'active': true
        },
        {
          'id': 4,
          'columnName': $filter('translate')('FILTER_COLUMNS_FR_COUNT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_FR_COUNT_LABEL'),
          'friendlyName': 'freeround_count',
          'active': true
        },
        {
          'id': 5,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_RTP_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_RTP_LABEL'),
          'friendlyName': 'rtp',
          'active': true
        },
        {
          'id': 6,
          'columnName': $filter('translate')('FILTER_COLUMNS_FR_RTP_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_FR_RTP_LABEL'),
          'friendlyName': 'freeround_rtp',
          'active': true
        },
        {
          'id': 7,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_JACKPOT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_JACKPOT_LABEL'),
          'friendlyName': 'jackpots',
          'active': true
        },
        {
          'id': 8,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_PROFIT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_PROFIT_LABEL'),
          'friendlyName': 'profit',
          'active': true
        },
      ]);

      // setting report type to account
      $scope.main.filters.reportType.setValue('account');

      // setting filter visibilities
      $scope.main.filters.reportType.setVisible(false);

      $scope.main.filters.username.setVisible(false);
      $scope.main.filters.email.setVisible(false);
      $scope.main.filters.bet.setVisible(false);
      $scope.main.filters.win.setVisible(false);
      $scope.main.filters.profit.setVisible(false);
      $scope.main.filters.con_id.setVisible(false);
      $scope.main.filters.player_id.setVisible(false);
      $scope.main.filters.sortBy.setVisible(false);
      $scope.main.filters.sortStyle.setVisible(false);
      $scope.main.filters.queryAccount.setVisible(true);
    };

    // system boot function
    vm.bootSystem = function () {
      console.log("TURNOVER");
      $scope.main.filters.queryAccount.setValue('');
      $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_TURNOVER');
      // initialize filters
      vm.setFilters();

      $scope.main.setCookieName('REPORT_TURNOVER');

      // getting turnover report filter
      $scope.main.syncFiltersFromCookies();

      $scope.main.filters.applyFilter();
    };

    $scope.report.setBootFn(vm.bootSystem);
  }
})();

(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('TurnoverMacawReportController', MacawReportController);

  /** @ngInject */
  function MacawReportController(ApiService, $scope, $filter, $rootScope) {
    var vm = this;

    // checking user permission
    ApiService.checkPermission('turnover_report_access');

    vm.subAccountsCount = 0;

    var macawColumns = [
      {
        'id': 0,
        'columnName': $filter('translate')('FILTER_COLUMNS_SITE_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_SITE_LABEL'),
        'friendlyName': 'siteId',
        'active': true,
      },
      {
        'id': 1,
        'columnName': $filter('translate')('FILTER_COLUMNS_SITE_NAME_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_SITE_NAME_LABEL'),
        'friendlyName': 'siteName',
        'active': true,
        'styles': 'text-overflow: ellipsis;overflow: hidden;width: 150px;'
      },
      {
        'id': 2,
        'columnName': $filter('translate')('FILTER_COLUMNS_SPINS_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_SPINS_LABEL'),
        'friendlyName': 'spins',
        'active': true
      },
      {
        'id': 3,
        'columnName': $filter('translate')('FILTER_COLUMNS_CURRENCY_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_CURRENCY_LABEL'),
        'friendlyName': 'currency',
        'active': true
      },
      {
        'id': 4,
        'columnName': $filter('translate')('FILTER_COLUMNS_BET_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_BET_LABEL'),
        'friendlyName': 'bet',
        'active': true
      },
      {
        'id': 5,
        'columnName': $filter('translate')('FILTER_COLUMNS_WIN_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_WIN_LABEL'),
        'friendlyName': 'win',
        'active': true
      },
      {
        'id': 6,
        'columnName': $filter('translate')('FILTER_COLUMNS_REFUND_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_REFUND_LABEL'),
        'friendlyName': 'refund',
        'active': true
      },
      {
        'id': 7,
        'columnName': $filter('translate')('FILTER_COLUMNS_MARGIN_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_MARGIN_LABEL'),
        'friendlyName': 'margin',
        'active': true
      },
      {
        'id': 8,
        'columnName': $filter('translate')('FILTER_COLUMNS_PROFIT_TITLE'),
        'selectionName': $filter('translate')('FILTER_COLUMNS_PROFIT_LABEL'),
        'friendlyName': 'profit',
        'active': true
      },
    ];

    // setting filters default values
    vm.setFilters = function () {
      // FILTER SETTINGS

      // column filter
      $scope.main.filters.columns.setOptions(macawColumns);

      // setting report type to account
      $scope.main.filters.reportType.setValue('macaw');

      // setting filter visibilities
      $scope.main.filters.site.setVisible(true);

      $scope.main.filters.username.setVisible(false);
      $scope.main.filters.email.setVisible(false);
      $scope.main.filters.bet.setVisible(false);
      $scope.main.filters.win.setVisible(false);
      $scope.main.filters.profit.setVisible(false);
      $scope.main.filters.con_id.setVisible(false);
      $scope.main.filters.player_id.setVisible(false);
      $scope.main.filters.sortBy.setVisible(false);
      $scope.main.filters.sortStyle.setVisible(false);
      $scope.main.filters.account.setVisible(false);
      $scope.main.filters.accountsList.setVisible(false);
      $scope.main.filters.currencyExchange.setVisible(false);
      $scope.main.filters.queryAccount.setVisible(false);

    };

    // system boot function
    vm.bootSystem = function () {
      console.log("MACAW_TURNOVER");

      $scope.main.filters.queryAccount.setValue('');
      $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_MACAW_TURNOVER');

      // initialize filters
      vm.setFilters();
      $scope.main.setCookieName('REPORT_TURNOVER_MACAW');

      // getting turnover report filter
      $scope.main.syncFiltersFromCookies();

      $scope.main.filters.applyFilter();
    };

    $scope.report.setBootFn(vm.bootSystem);
  }
})();

(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('SessionReportController', SessionReportController);

  /** @ngInject */
  function SessionReportController(ApiService, $scope, $filter, $stateParams, ACTIONS, $rootScope) {
    var vm = this;

    vm.extraData = {
      limit: 20,
      page: 1
    };

    if ($stateParams.page != null) {
      vm.extraData.page = $stateParams.page;
    } else {
      vm.extraData.page = 1;
    }

    // checking user permission
    ApiService.checkPermission('session_report_access');

    // setting filters default values
    vm.setFilters = function () {
      // FILTER SETTINGS

      // columns Filter
      $scope.main.filters.columns.setOptions([
        {
          'id': 0,
          'columnName': $filter('translate')('FILTER_COLUMNS_CON_ID_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_CON_ID_LABEL'),
          'friendlyName': 'conId',
          'active': true
        },
        {
          'id': 1,
          'columnName': $filter('translate')('FILTER_COLUMNS_PLAYER_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_PLAYER_LABEL'),
          'friendlyName': 'playerName',
          'active': true
        },
        {
          'id': 2,
          'columnName': $filter('translate')('FILTER_COLUMNS_GAME_NAME_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_GAME_NAME_LABEL'),
          'friendlyName': 'gameName',
          'active': true
        },
        {
          'id': 3,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_BET_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_BET_LABEL'),
          'friendlyName': 'bet',
          'active': true
        },
        {
          'id': 4,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_WIN_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_WIN_LABEL'),
          'friendlyName': 'win',
          'active': true
        },
        {
          'id': 5,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_FPP_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_FPP_LABEL'),
          'friendlyName': 'fpps',
          'active': true
        },
        {
          'id': 6,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_JACKPOT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_JACKPOT_LABEL'),
          'friendlyName': 'jackpots',
          'active': true
        },
        {
          'id': 7,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_PROFIT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_PROFIT_LABEL'),
          'friendlyName': 'profit',
          'active': true
        },
        {
          'id': 8,
          'columnName': $filter('translate')('FILTER_COLUMNS_CREATED_AT'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_CREATED_AT_LABEL'),
          'friendlyName': 'created_at',
          'active': true
        }
      ]);

      // setting report type to player
      $scope.main.filters.reportType.setValue('session_v2');
      $scope.main.filters.viewAs.setValue('normal');

      // setting filter visibilities
      $scope.main.filters.reportType.setVisible(false);
      $scope.main.filters.viewAs.setEnabled(false);
      if ($stateParams.playerId != null) {
        vm.extraData.playerId = $stateParams.playerId;
        // $scope.main.filters.account.setEnabled(false);
      } else {
        vm.extraData.playerId = 'all';
        $scope.main.filters.account.setEnabled(true);
      }

      $scope.main.filters.sortBy.setOptions([
        {
          value: 'created_at',
          label: $filter('translate')('FILTER_SORT_BY_CREATED_AT')
        },
        {
          value: 'bet',
          label: $filter('translate')('FILTER_SORT_BY_BET')
        },
        {
          value: 'win',
          label: $filter('translate')('FILTER_SORT_BY_WIN')
        },
        {
          value: 'profit',
          label: $filter('translate')('FILTER_SORT_BY_PROFIT')
        },
        {
          value: 'owner_id',
          label: $filter('translate')('FILTER_SORT_BY_OWNER_ID')
        },
        {
          value: 'site_id',
          label: $filter('translate')('FILTER_SORT_BY_SITE_ID')
        },
        {
          value: 'game_id',
          label: $filter('translate')('FILTER_SORT_BY_GAME_ID')
        },
        {
          value: 'username',
          label: $filter('translate')('FILTER_SORT_BY_USERNAME')
        }
      ]);


      $scope.main.filters.username.setVisible(true);
      $scope.main.filters.email.setVisible(false);
      $scope.main.filters.con_id.setVisible(true);
      $scope.main.filters.player_id.setVisible(true);
      $scope.main.filters.player_id.setValue(vm.extraData.playerId || '');
      $scope.main.filters.bet.setVisible(true);
      $scope.main.filters.win.setVisible(true);
      $scope.main.filters.profit.setVisible(true);
      $scope.main.filters.sortBy.setVisible(true);
      $scope.main.filters.sortStyle.setVisible(true);
      $scope.main.filters.site.setVisible(false);
      $scope.main.filters.queryAccount.setVisible(false);
    };

    vm.createGraph = function () {
      var bets = [];
      var wins = [];
      var profits = [];

      if (!$scope.report.records && $scope.report.records.list)
        return;

      angular.forEach($scope.report.records.list, function (node, key) {
        if (!node)
          return;

        var bet = (node.bet / 100);
        bets.push({
          "label": node.conId + '-' + node.currency,
          "value": bet
        });

        var win = (node.win / 100);
        wins.push({
          "label": node.conId + '-' + node.currency,
          "value": (win * -1)
        });

        var profit = win - bet;
        profits.push({
          "label": node.conId + '-' + node.currency,
          "value": profit
        });
      });


      var graph = {
        options: {
          chart: {
            type: 'multiBarHorizontalChart',
            height: 600,
            margin: {
              top: 20,
              right: 20,
              bottom: 60,
              left: 150
            },
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            showControls: true,
            showValues: true,
            duration: 500,
            xAxis: {
              showMaxMin: true
            },
            yAxis: {
              axisLabel: 'Values',
              tickFormat: function (d) {
                return d3.format(',.2f')(d);
              }
            },
            noData: $filter('translate')('THERE_IS_NO_RECORD')
          }
        },
        data: [
          {
            "key": $filter('translate')('CHART_BET'),
            "color": "#0ec9d6",
            "values": bets
          },
          {
            "key": $filter('translate')('CHART_WIN'),
            "color": "#d62728",
            "values": wins
          },
          {
            "key": $filter('translate')('CHART_PROFIT'),
            "color": "#0dd68b",
            "values": profits
          }
        ]
      };

      $scope.report.setGraph(graph);
    };

    // settings graph
    vm.recordChangeFn = function () {
      vm.createGraph();
    };

    // getting records by filter
    vm.getSessionReport = function () {
      $scope.report.beforeApplyBtn();
      $scope.main.setLoading(true);
      var merged = angular.merge($scope.main.flatFilters, vm.extraData);

      merged.game = $scope.main.sharedFilters.game || [];
      merged.owner = $scope.main.sharedFilters.owner;
      merged.site = $scope.main.sharedFilters.site || [];
      merged.currencyExchange = $scope.main.sharedFilters.currencyExchange;

      if ($scope.main.sharedFilters.player_id)
        merged.playerId = $scope.main.sharedFilters.player_id;

      merged.filter = $scope.main.sharedFilters;

      delete merged.filter.accountsList;
      delete merged.filter.game;
      delete merged.filter.owner;
      delete merged.filter.site;
      delete merged.filter.currencyExchange;

      merged.filter = $scope.main.sharedFilters;

      // convert to cent
      if (merged.filter.bet) {
        merged.filter.bet = $scope.main.convertToCent(merged.filter.bet)
      }

      // convert to cent
      if (merged.filter.win) {
        merged.filter.win = $scope.main.convertToCent(merged.filter.win)
      }

      // convert to cent
      if (merged.filter.profit) {
        merged.filter.profit = $scope.main.convertToCent(merged.filter.profit)
      }

      if (merged.filter.sortBy)
        merged.sortBy = merged.filter.sortBy;
      if (merged.filter.sortStyle)
        merged.sortStyle = merged.filter.sortStyle;

      delete merged.filter.sortBy;
      delete merged.filter.sortStyle;

      ApiService.call(ACTIONS.REPORT, merged, function (response) {
        $scope.report.setCurrency(response);
        $scope.report.setRecords(response.report);
        $scope.main.setLoading(false);
      }, function () {
        $scope.main.setLoading(false);
      });
    };

    // system boot function
    vm.bootSystem = function () {
      console.log("SESSION");
      $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_SESSIONS');
      // initialize filters
      vm.setFilters();

      $scope.report.setRecordChanged(vm.recordChangeFn);

      $scope.main.setCookieName('REPORT_SESSIONS');

      // getting sessions report filter
      $scope.main.syncFiltersFromCookies();

      // put params playerId to advanced filters player_id
      if (vm.extraData.playerId)
        $scope.main.filters.player_id.setValue(vm.extraData.playerId || '');

      if (vm.extraData.playerId === "all")
        $scope.main.filters.player_id.setValue('');

      $scope.main.filters.setApplyFilter(vm.getSessionReport);

      $scope.main.filters.applyFilter();
    };

    $scope.report.setBootFn(vm.bootSystem);
  }
})();

(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('SessionRoundsReportController', SessionRoundsReportController);

  /** @ngInject */
  function SessionRoundsReportController(ApiService, $scope, $filter, $stateParams, ACTIONS, $rootScope, $state, $uibModal) {
    var vm = this;

    // checking user permission
    ApiService.checkPermission('session_rounds_report_access');

    vm.extraData = {
      limit: 20,
      page: 1
    };

    // setting filters default values
    vm.setFilters = function () {
      // FILTER SETTINGS

      // columns Filter
      $scope.main.filters.columns.setOptions([
        {
          'id': 0,
          'columnName': "Player",
          'selectionName': "Player",
          'friendlyName': 'player',
          'active': true
        },
        {
          'id': 1,
          'columnName': "Session",
          'selectionName': "Session",
          'friendlyName': 'con_id',
          'active': true
        },
        {
          'id': 2,
          'columnName': "Game",
          'selectionName': "Game",
          'friendlyName': 'game_name',
          'active': true
        },
        {
          'id': 3,
          'columnName': "Platform",
          'selectionName': "Platform",
          'friendlyName': 'platform_name',
          'active': true
        },
        {
          'id': 4,
          'columnName': "Action",
          'selectionName': "Action",
          'friendlyName': 'client_action',
          'active': true
        },
        {
          'id': 5,
          'columnName': "Old Credit",
          'selectionName': "Old Credit",
          'friendlyName': 'old_credit',
          'active': true
        },
        {
          'id': 6,
          'columnName': $filter('translate')('FILTER_COLUMNS_BET_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_BET_LABEL'),
          'friendlyName': 'bet',
          'active': true
        },
        {
          'id': 7,
          'columnName': $filter('translate')('FILTER_COLUMNS_WIN_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_WIN_LABEL'),
          'friendlyName': 'win',
          'active': true
        },
        {
          'id': 8,
          'columnName': $filter('translate')('FILTER_COLUMNS_CREDIT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_CREDIT_LABEL'),
          'friendlyName': 'credit',
          'active': true
        }
      ]);

      $scope.main.filters.sortBy.setOptions([
        {
          value: 'created_at',
          label: $filter('translate')('FILTER_SORT_BY_CREATED_AT')
        },
        {
          value: 'bet',
          label: $filter('translate')('FILTER_SORT_BY_BET')
        },
        {
          value: 'win',
          label: $filter('translate')('FILTER_SORT_BY_WIN')
        },
        {
          value: 'profit',
          label: $filter('translate')('FILTER_SORT_BY_PROFIT')
        },
        {
          value: 'owner_id',
          label: $filter('translate')('FILTER_SORT_BY_OWNER_ID')
        },
        {
          value: 'site_id',
          label: $filter('translate')('FILTER_SORT_BY_SITE_ID')
        },
      ]);

      // setting report type to player
      $scope.main.filters.reportType.setValue('rounds_v2');
      $scope.main.filters.viewAs.setValue('normal');

      // setting filter visibilities
      $scope.main.filters.reportType.setVisible(false);
      $scope.main.filters.viewAs.setEnabled(false);

      if ($stateParams.conId != null) {
        vm.extraData.conId = $stateParams.conId;
        // if ($stateParams.conId !== "all")
        //   $scope.main.filters.account.setEnabled(false);
      } else {
        vm.extraData.conId = 'all';
        $scope.main.filters.account.setEnabled(true);
      }

      if ($stateParams.page != null) {
        vm.extraData.page = $stateParams.page;
      } else {
        vm.extraData.page = 1;
      }

      $scope.main.filters.username.setVisible(false);
      $scope.main.filters.email.setVisible(false);
      $scope.main.filters.con_id.setVisible(true);
      $scope.main.filters.player_id.setVisible(true);
      $scope.main.filters.player_id.setValue('');
      $scope.main.filters.bet.setVisible(true);
      $scope.main.filters.win.setVisible(true);
      $scope.main.filters.profit.setVisible(true);
      $scope.main.filters.sortBy.setVisible(true);
      $scope.main.filters.sortStyle.setVisible(true);
      $scope.main.filters.site.setVisible(false);
      $scope.main.filters.queryAccount.setVisible(false);

    };
    vm.openModal = function (gameId, roundId) {
      $uibModal.open({
        templateUrl: 'app/views/reports/session-round-detail.html',
        controller: 'SessionRoundDetailReportController',
        controllerAs: 'sessionRoundDetailReport',
        size: 'custom-lg',
        resolve: {
          gameId: function () {
            return gameId;
          },
          roundId: function () {
            return roundId;
          }
        }
      });
    };
    vm.createGraph = function () {
      var bets = [];
      var wins = [];
      var profits = [];

      if (!$scope.report.records && $scope.report.records.list)
        return;

      angular.forEach($scope.report.records.list, function (node) {
        if (!node)
          return;

        var bet = (node.bet / 100);
        bets.push({
          "label": node._id + '-' + node.currency,
          "value": bet
        });

        var win = (node.win / 100);
        wins.push({
          "label": node._id + '-' + node.currency,
          "value": (win * -1)
        });

        var profit = win - bet;
        profits.push({
          "label": node._id + '-' + node.currency,
          "value": profit
        });
      });

      var graph = {
        options: {
          chart: {
            type: 'multiBarHorizontalChart',
            height: 600,
            margin: {
              top: 20,
              right: 20,
              bottom: 60,
              left: 150
            },
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            showControls: true,
            showValues: true,
            duration: 500,
            xAxis: {
              showMaxMin: true
            },
            yAxis: {
              axisLabel: 'Values',
              tickFormat: function (d) {
                return d3.format(',.2f')(d);
              }
            },
            noData: $filter('translate')('THERE_IS_NO_RECORD')
          }
        },
        data: [
          {
            "key": $filter('translate')('CHART_BET'),
            "color": "#0ec9d6",
            "values": bets
          },
          {
            "key": $filter('translate')('CHART_WIN'),
            "color": "#d62728",
            "values": wins
          },
          {
            "key": $filter('translate')('CHART_PROFIT'),
            "color": "#0dd68b",
            "values": profits
          }
        ]
      };

      $scope.report.setGraph(graph);
    };

    // settings graph
    vm.recordChangeFn = function () {
      vm.createGraph();
    };

    // getting records by filter
    vm.getSessionReport = function () {
      $scope.report.beforeApplyBtn();
      $scope.main.setLoading(true);

      var merged = angular.merge($scope.main.flatFilters, vm.extraData);

      merged.game = $scope.main.sharedFilters.game || [];
      merged.owner = $scope.main.sharedFilters.owner;
      merged.site = $scope.main.sharedFilters.site || [];
      merged.currencyExchange = $scope.main.sharedFilters.currencyExchange;

      merged.filter = $scope.main.sharedFilters;

      delete merged.filter.accountsList;
      delete merged.filter.game;
      delete merged.filter.owner;
      delete merged.filter.site;
      delete merged.filter.currencyExchange;

      merged.filter = $scope.main.sharedFilters;

      // convert to cent
      if (merged.filter.bet) {
        merged.filter.bet = $scope.main.convertToCent(merged.filter.bet)
      }

      // convert to cent
      if (merged.filter.win) {
        merged.filter.win = $scope.main.convertToCent(merged.filter.win)
      }

      // convert to cent
      if (merged.filter.profit) {
        merged.filter.profit = $scope.main.convertToCent(merged.filter.profit)
      }

      if (merged.filter.sortBy)
        merged.sortBy = merged.filter.sortBy;
      if (merged.filter.sortStyle)
        merged.sortStyle = merged.filter.sortStyle;

      delete merged.filter.sortBy;
      delete merged.filter.sortStyle;

      ApiService.call(ACTIONS.REPORT, merged, function (response) {
        $scope.report.setCurrency(response);
        $scope.report.setRecords(response.report);
        $scope.main.setLoading(false);
      }, function () {
        $scope.main.setLoading(false);
      });
    };

    vm.getFirstPage = function () {
      $scope.report.beforeApplyBtn();
      $state.go('management.report.sessionRounds', {page: 1, conId: vm.extraData.conId}, {reload: true})
    };

    // system boot function
    vm.bootSystem = function () {
      console.log("ROUNDS");
      $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_ROUNDS');
      // initialize filters
      vm.setFilters();

      $scope.report.setRecordChanged(vm.recordChangeFn);

      $scope.main.setCookieName('REPORT_SESSION_ROUNDS');

      // getting session round report filter
      $scope.main.syncFiltersFromCookies();

      $scope.main.filters.setApplyFilter(vm.getSessionReport);

      $scope.main.filters.applyFilter();
    };

    $scope.report.setBootFn(vm.bootSystem);
  }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('SessionRoundDetailReportController', SessionRoundDetailReportController);

    /** @ngInject */
    function SessionRoundDetailReportController(ApiService,$sce,gameId,roundId,$uibModalInstance) {
        var vm = this;
        vm.roundId = roundId;
        // checking user permission
        ApiService.checkPermission('session_round_detail_report_access');
        vm.iframeUrl = $sce.trustAsResourceUrl(ApiService.baseApiUrl+'/gameHistoryDetail?gameId='+gameId+'&id='+roundId);

        vm.closeModal = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('PlayerReportController', PlayerReportController);

  /** @ngInject */
  function PlayerReportController(ApiService, $scope, $filter, $stateParams, $rootScope, EVENTS) {
    var vm = this;

    // checking user permission
    ApiService.checkPermission('player_report_access');

    vm.checkAccountSelect = true;
    // setting filters default values
    vm.setFilters = function () {
      // FILTER SETTINGS

      // columns Filter
      var playerReportColumns = [
        {
          'id': 0,
          'columnName': $filter('translate')('FILTER_COLUMNS_PLAYER_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_PLAYER_LABEL'),
          'friendlyName': 'username',
          'active': true
        },
        {
          'id': 1,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_BET_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_BET_LABEL'),
          'friendlyName': 'bet',
          'active': true
        },
        {
          'id': 2,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_WIN_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_WIN_LABEL'),
          'friendlyName': 'win',
          'active': true
        },
        {
          'id': 3,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_FPP_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_FPP_LABEL'),
          'friendlyName': 'fpp',
          'active': true
        },
        {
          'id': 4,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_JACKPOT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_JACKPOT_LABEL'),
          'friendlyName': 'jackpot',
          'active': true
        },
        {
          'id': 5,
          'columnName': $filter('translate')('FILTER_COLUMNS_TOTAL_PROFIT_TITLE'),
          'selectionName': $filter('translate')('FILTER_COLUMNS_TOTAL_PROFIT_LABEL'),
          'friendlyName': 'profit',
          'active': true
        }
      ];

      $scope.main.filters.columns.setOptions(playerReportColumns);

      // setting report type to player
      $scope.main.filters.reportType.setValue("player_v2");

      // setting filter visibilities
      $scope.main.filters.reportType.setVisible(false);

      if ($stateParams.accountId != null) {

        var owner = [];
        owner.push($stateParams.accountId);
        $scope.main.filters.owner.setValue(owner);
        $scope.main.softSelectedAccountName = $stateParams.accountName;
        $rootScope.$broadcast(EVENTS.SELECTED_ACCOUNTS_CHANGED, owner);

        // $scope.main.filters.account.setEnabled(false);
      } else {
        $scope.main.filters.account.setEnabled(true);
      }

      $scope.main.filters.sortBy.setOptions([
        {
          value: 'created_at',
          label: $filter('translate')('FILTER_SORT_BY_CREATED_AT')
        },
        {
          value: 'bet',
          label: $filter('translate')('FILTER_SORT_BY_BET')
        },
        {
          value: 'win',
          label: $filter('translate')('FILTER_SORT_BY_WIN')
        },
        {
          value: 'profit',
          label: $filter('translate')('FILTER_SORT_BY_PROFIT')
        },
        {
          value: 'owner_id',
          label: $filter('translate')('FILTER_SORT_BY_OWNER_ID')
        },
        {
          value: 'site_id',
          label: $filter('translate')('FILTER_SORT_BY_SITE_ID')
        },
        {
          value: 'username',
          label: $filter('translate')('FILTER_SORT_BY_USERNAME')
        }
      ]);

      $scope.main.filters.username.setVisible(true);
      $scope.main.filters.email.setVisible(false);
      $scope.main.filters.bet.setVisible(true);
      $scope.main.filters.win.setVisible(true);
      $scope.main.filters.profit.setVisible(true);
      $scope.main.filters.con_id.setVisible(false);
      $scope.main.filters.player_id.setVisible(false);
      $scope.main.filters.sortBy.setVisible(true);
      $scope.main.filters.sortStyle.setVisible(true);
      $scope.main.filters.site.setVisible(false);
      $scope.main.filters.queryAccount.setVisible(false);
    };

    vm.createGraph = function () {
      var bets = [];
      var wins = [];
      var profits = [];

      if (!$scope.report.records && $scope.report.records.list)
        return;

      angular.forEach($scope.report.records.list, function (node, key) {
        if (!node)
          return;

        var bet = (node.bet / 100);
        bets.push({
          "label": node.username + '-' + node.currency,
          "value": bet
        });

        var win = (node.win / 100);
        wins.push({
          "label": node.username + '-' + node.currency,
          "value": (win * -1)
        });

        var profit = win - bet;
        profits.push({
          "label": node.username + '-' + node.currency,
          "value": profit
        });
      });


      var graph = {
        options: {
          chart: {
            type: 'multiBarHorizontalChart',
            height: 600,
            margin: {
              top: 20,
              right: 20,
              bottom: 60,
              left: 150
            },
            x: function (d) {
              return d.label;
            },
            y: function (d) {
              return d.value;
            },
            showControls: true,
            showValues: true,
            duration: 500,
            xAxis: {
              showMaxMin: true
            },
            yAxis: {
              axisLabel: 'Values',
              tickFormat: function (d) {
                return d3.format(',.2f')(d);
              }
            },
            noData: $filter('translate')('THERE_IS_NO_RECORD')
          }
        },
        data: [
          {
            "key": $filter('translate')('CHART_BET'),
            "color": "#0ec9d6",
            "values": bets
          },
          {
            "key": $filter('translate')('CHART_WIN'),
            "color": "#d62728",
            "values": wins
          },
          {
            "key": $filter('translate')('CHART_PROFIT'),
            "color": "#0dd68b",
            "values": profits
          }
        ]
      };

      $scope.report.setGraph(graph);
    };

    // settings graph
    vm.recordChangeFn = function () {
      vm.createGraph();
    };

    // system boot function
    vm.bootSystem = function () {
      console.log("PLAYER");
      $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PLAYERS');
      // initialize filters
      vm.setFilters();

      $scope.report.setRecordChanged(vm.recordChangeFn);

      $scope.main.setCookieName('REPORT_PLAYER');

      // getting player report filter
      $scope.main.syncFiltersFromCookies();

      if ($stateParams.accountId != null && vm.checkAccountSelect) {

        $scope.main.selectOneAccountByID($stateParams.accountId, function () {
          $scope.main.filters.applyFilter();
          vm.checkAccountSelect = false;
        });

      } else {
        $scope.main.filters.applyFilter();
      }
    };

    $scope.report.setBootFn(vm.bootSystem);
  }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('ProductHubController', ProductHubController)

        .controller('ProductHubNewsController', ProductHubNewsController)
        .controller('ProductHubNewsListController', ProductHubNewsListController)

        .controller('ProductHubRoadmapController', ProductHubRoadmapController)
        .controller('ProductHubRoadmapListController', ProductHubRoadmapListController)

        .controller('ProductHubMediaPackController', ProductHubMediaPackController)
        .controller('ProductHubMediaPackListController', ProductHubMediaPackListController)

        .controller('ProductHubDemoAreaController', ProductHubDemoAreaController)
        .controller('DemoAreaGamePlayController', DemoAreaGamePlayController);

    function ProductHubController(ApiService, $rootScope, $scope, EVENTS, $filter,$window) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_access');

        vm.goBack = function () {
            $window.history.back();
        };

        vm.bootSystem = function () {
            console.log("PRODUCT HUB");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB');
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function ProductHubNewsController(ApiService, $rootScope, $scope, EVENTS, $filter) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_news_access');

        vm.bootSystem = function () {
            console.log("PRODUCT HUB NEWS");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB_NEWS');
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function ProductHubNewsListController(ApiService, $rootScope, $scope, EVENTS, $filter,$stateParams,ACTIONS) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_news_list_access');

        vm.extraData = {
            limit:20,
            page:1
        };
        vm.list = [];

        if($stateParams.page != null){
            vm.extraData.page = $stateParams.page;
        }else{
            vm.extraData.page = 1;
        }

        vm.getNews = function () {
            ApiService.call(ACTIONS.NEWS,{process:'list',page:vm.extraData.page,limit:vm.extraData.limit},function (response) {
                vm.list = response.news;
            });
        };

        vm.bootSystem = function () {
            console.log("PRODUCT HUB NEWS LIST");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB_NEWS_LIST');

            vm.getNews();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function ProductHubRoadmapController(ApiService, $rootScope, $scope, EVENTS, $filter) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_roadmap_access');

        vm.bootSystem = function () {
            console.log("PRODUCT HUB ROADMAP");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB_ROADMAP');
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function ProductHubRoadmapListController(ApiService, $rootScope, $scope, EVENTS, $filter,$stateParams,ACTIONS) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_roadmap_list_access');

        vm.extraData = {
            limit:20,
            page:1
        };
        vm.list = [];

        if($stateParams.page != null){
            vm.extraData.page = $stateParams.page;
        }else{
            vm.extraData.page = 1;
        }

        vm.getRoadmap = function () {
            ApiService.call(ACTIONS.ROADMAP,{process:'list',page:vm.extraData.page,limit:vm.extraData.limit},function (response) {
                vm.list = response.roadmap;
            });
        };

        vm.bootSystem = function () {
            console.log("PRODUCT HUB ROADMAP LIST");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB_ROADMAP_LIST');

            vm.getRoadmap();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function ProductHubMediaPackController(ApiService, $rootScope, $scope, EVENTS, $filter) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_media_pack_access');

        vm.bootSystem = function () {
            console.log("PRODUCT HUB MEDIA PACK");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB_MEDIA_PACK');
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function ProductHubMediaPackListController(ApiService, $rootScope, $scope, EVENTS, $filter,$stateParams,ACTIONS) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_media_pack_list_access');

        vm.extraData = {
            limit:20,
            page:1
        };
        vm.list = [];
        vm.fileTypes = {
            excel :{
                extensions:['xlsx','xlsm','xlsb','xltx','xltm','xls','xlt','xml','xla','csv','dif','dbf','ods','rtf'],
                icon:'fa-file-excel'
            },
            word :{
                extensions:['docx','doc','dotx','dot','docm','dotm'],
                icon:'fa-file-word'
            },
            pdf :{
                extensions:['pdf'],
                icon:'fa-file-pdf'
            },
            archive :{
                extensions:['rar','zip','iso','bz2','gz','7z','s7z','apk','cab','dmg'],
                icon:'fa-file-archive'
            },
            image :{
                extensions:['bmp','dds','gif','jpg','png','psd','tif','tiff','svg','jpeg'],
                icon:'fa-file-image'
            },
            audio :{
                extensions:['mid','flp','mp3','flac','3ga','mpa','wav','wma'],
                icon:'fa-file-audio'
            },
            video :{
                extensions:['3g2','3gp','avi','m4v','mov','mp4','mpg','wmv','swf'],
                icon:'fa-film'
            },
            txt :{
                extensions:['txt','log','dat','sql','key'],
                icon:'fa-file-alt'
            },
            unknown :{
                extensions:[],
                icon:'fa-file'
            }
        };

        if($stateParams.page != null){
            vm.extraData.page = $stateParams.page;
        }else{
            vm.extraData.page = 1;
        }

        vm.getMediaPack = function () {
            ApiService.call(ACTIONS.MEDIA_PACK,{process:'list',page:vm.extraData.page,limit:vm.extraData.limit},function (response) {
                var mediaPacks = response.mediaPack;
                angular.forEach(mediaPacks.records,function (value,key) {

                    value.extension = value.link.split('.').pop().toLowerCase();
                    var icon = vm.fileTypes.unknown.icon;

                    angular.forEach(vm.fileTypes,function (fileType, fileKey) {
                        if(fileType.extensions.indexOf(value.extension)>-1){
                            icon = fileType.icon;
                        }
                    });

                    value.icon = icon;
                });

                vm.list = mediaPacks;
            });
        };

        vm.bootSystem = function () {
            console.log("PRODUCT HUB MEDIA PACK LIST");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB_MEDIA_PACK_LIST');

            vm.getMediaPack();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function ProductHubDemoAreaController(ApiService, $rootScope, $scope, EVENTS, $filter,$stateParams,ACTIONS,$uibModal) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('product_hub_demo_area_access');

        vm.extraData = {
            limit:12,
            page:1
        };
        vm.list = [];
        vm.demoURL='https://demo.spinmatic.net/Play';

        if($stateParams.page != null){
            vm.extraData.page = $stateParams.page;
        }else{
            vm.extraData.page = 1;
        }

        vm.getGames = function () {
            ApiService.call(ACTIONS.DEMO_GAMES,{process:'list',page:vm.extraData.page,limit:vm.extraData.limit},function (response) {
                vm.list = response.games;
            });
        };

        vm.playGame = function (game) {
            var modalInstance = $uibModal.open({
                animation:true,
                templateUrl:'demoPlayModal.html',
                controller:'DemoAreaGamePlayController',
                controllerAs:'demoAreaGamePlay',
                size:'lg',
                windowTopClass:'demo-modal',
                resolve:{
                    iframeUrl:function () {
                        return vm.demoURL+'/'+game.id
                    },
                    game:function () {
                        return game
                    }
                }
            });

            modalInstance.result.then(function () {
                console.log('ok btn');
            },function () {
                console.log('dismissed');
            });
        };

        vm.bootSystem = function () {
            console.log("PRODUCT HUB DEMO AREA");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PRODUCT_HUB_DEMO_AREA');

            vm.getGames();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }
    
    function DemoAreaGamePlayController($uibModalInstance,$sce, iframeUrl,game) {
        var vm = this;
        vm.iframeUrl = iframeUrl;
        vm.game = game;

        vm.trustSrc = function (src) {
          return $sce.trustAsResourceUrl(src);
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('PlayersController', PlayersController)
        .controller('PlayersListController', PlayersListController)
        .controller('PlayersCreateController', PlayersCreateController)
        .controller('PlayersEditController', PlayersEditController);

    function PlayersController(ApiService, $rootScope, $scope, EVENTS, $filter,$window) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('players_management_access');

        vm.goBack = function () {
            $window.history.back();
        };

        vm.bootSystem = function () {
            console.log("PLAYERS MANAGEMENT");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PLAYERS');
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function PlayersListController(ApiService, $rootScope, $scope, EVENTS, $filter,$stateParams,ACTIONS) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('players_management_list_access');

        vm.extraData = {
            limit:20,
            page:1
        };
        vm.list = [];

        if($stateParams.page != null){
            vm.extraData.page = $stateParams.page;
        }else{
            vm.extraData.page = 1;
        }

        vm.getPlayers = function () {
            ApiService.call(ACTIONS.PLAYERS,{process:'list',page:vm.extraData.page,limit:vm.extraData.limit,owner:[]},function (response) {
                vm.list = response.players;
            });
        };

        vm.bootSystem = function () {
            console.log("PLAYERS MANAGEMENT LIST");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PLAYERS_LIST');

            vm.getPlayers();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function PlayersCreateController(ApiService, $rootScope, $scope, EVENTS, $filter,ACTIONS,$state) {
        var vm = this;
        vm.player = {
            firstname:'',
            lastname:'',
            username:'',
            email:'',
            country:'',
            language:'',
            owner_id:'',
            site_id:'',
            external_id:'',
            status:true,
            password:'',
            passwordCompare:''
        };

        vm.countries = [];
        vm.languages = [];
        vm.sites = [];
        vm.owners = [];

        // checking user permission
        ApiService.checkPermission('players_management_create_access');

        vm.getCountries = function () {
            ApiService.call(ACTIONS.SYSTEM_COUNTRIES,{process:'getCountries'},function (response) {
                vm.countries = response.countries;
            });
        };

        vm.getLanguages = function () {
            ApiService.call(ACTIONS.SYSTEM_LANGUAGES,{process:'getLanguages'},function (response) {
                vm.languages = response.languages;
            });
        };

        vm.getSites = function () {
            ApiService.call(ACTIONS.SITES,{process:'getSites'},function (response) {
                vm.sites = response.sites;
            });
        };

        vm.getOwners = function () {
            ApiService.call(ACTIONS.ACCOUNTS,{process:'getAccounts'},function (response) {
                vm.owners = response.accounts;
                vm.getSites();
            });
        };

        vm.ownerChanged = function () {
            vm.player.site_id = 0;
            angular.forEach(vm.owners,function (value, key) {
                if(value.id == vm.player.owner_id){
                    angular.forEach(vm.sites,function (site, siteKey) {
                        if(site.id == value.site_id){
                            vm.player.site_id = site.id;
                        }
                    });
                }
            });
        };

        vm.savePlayer = function () {
            ApiService.call(ACTIONS.PLAYERS,{process:'create',player:vm.player},function (response) {
                if(response.player != null){
                    $state.go('management.players.list');
                }
            });
        };

        vm.bootSystem = function () {
            console.log("PLAYERS MANAGEMENT CREATE");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PLAYERS_CREATE');

            // getting countries, languages and owners
            vm.getCountries();
            vm.getLanguages();
            vm.getOwners();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

    function PlayersEditController(ApiService, $rootScope, $scope, EVENTS, $filter,ACTIONS,$state,$stateParams) {
        var vm = this;
        vm.player = {
            id:0,
            firstname:'',
            lastname:'',
            username:'',
            email:'',
            country:'',
            language:'',
            owner_id:'',
            site_id:'',
            external_id:'',
            status:false,
            password:'',
            passwordCompare:''
        };

        vm.countries = [];
        vm.languages = [];
        vm.sites = [];
        vm.owners = [];

        // checking user permission
        ApiService.checkPermission('players_management_edit_access');

        vm.getPlayer = function () {
            ApiService.call(ACTIONS.PLAYERS,{process:'getPlayer',player_id:vm.player.id},function (response) {
                vm.player = response.player;

                if(vm.player.status == 1 || vm.player.status == "1"){
                    vm.player.status = true;
                }else{
                    vm.player.status = false;
                }

                vm.player.password = '';
                vm.player.passwordCompare = '';

                // getting countries, languages and owners
                vm.getCountries();
                vm.getLanguages();
                vm.getOwners();
            });
        };

        vm.getCountries = function () {
            ApiService.call(ACTIONS.SYSTEM_COUNTRIES,{process:'getCountries'},function (response) {
                vm.countries = response.countries;
            });
        };

        vm.getLanguages = function () {
            ApiService.call(ACTIONS.SYSTEM_LANGUAGES,{process:'getLanguages'},function (response) {
                vm.languages = response.languages;
            });
        };

        vm.getSites = function () {
            ApiService.call(ACTIONS.SITES,{process:'getSites'},function (response) {
                vm.sites = response.sites;
                vm.ownerChanged();
            });
        };

        vm.getOwners = function () {
            ApiService.call(ACTIONS.ACCOUNTS,{process:'getAccounts'},function (response) {
                vm.owners = response.accounts;
                vm.getSites();
            });
        };

        vm.ownerChanged = function () {
            vm.player.site_id = 0;
            angular.forEach(vm.owners,function (value, key) {
                if(value.id == vm.player.owner_id){
                    angular.forEach(vm.sites,function (site, siteKey) {
                        if(site.id == value.site_id){
                            vm.player.site_id = site.id;
                        }
                    });
                }
            });
        };

        vm.savePlayer = function () {
            ApiService.call(ACTIONS.PLAYERS,{process:'edit',player:vm.player},function (response) {
                if(response.player != null){
                    $state.go('management.players.list');
                }
            });
        };

        vm.bootSystem = function () {
            console.log("PLAYERS MANAGEMENT EDIT");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PLAYERS_EDIT');
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();

            if($stateParams.id != null){
                vm.player.id = $stateParams.id;
                vm.getPlayer();
            }else{
                $state.go('management.players.list');
            }
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

})();
(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('PartnerSystemController', PartnerSystemController);

    function PartnerSystemController(ApiService, $rootScope, $scope, EVENTS, $filter, ACTIONS) {
        var vm = this;
        vm.info = {};
        vm.gameId = 0;

        vm.years = [];
        vm.startYear = '2018';
        vm.selectedYear = vm.startYear;
        vm.statisticDateRange='today';
        vm.isStatsLoading = false;
        vm.statisticDateRanges = [
            {
                title: "TODAY",
                value:'today',
                isSelected: true
            },
            {
                title: "YESTERDAY",
                value:'yesterday',
                isSelected: false
            },
            {
                title: "THIS WEEK",
                value:'thisWeek',
                isSelected: false
            },

            {
                title: "THIS MONTH",
                value:'thisMonth',
                isSelected: false
            }
        ];
        vm.changeStats = function(statKey) {
            for (var i in vm.statisticDateRanges) {
                vm.statisticDateRanges[i].isSelected = (i == statKey);
            }
            vm.statisticDateRange = vm.statisticDateRanges[statKey].value;
            vm.getInfo();
        };
        vm.totalStatistics = [];
        vm.topPlayers = [];
        vm.news = [];

        // checking user permission
        ApiService.checkPermission('partner_system_access');

        vm.getInfo = function () {
            vm.isStatsLoading = true;
            ApiService.call(ACTIONS.PARTNER_SYSTEM, {year: vm.selectedYear, gameId: vm.gameId, dateRange:vm.statisticDateRange}, function (response) {
                vm.info = response.info;
                vm.totalStatistics = response.info.statistics;
                vm.topPlayers = response.info.topPlayers;
                vm.news = response.info.news;
                vm.isStatsLoading = false;
            });
        };

        vm.bootSystem = function () {
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_PARTNER_SYSTEM');
            // auto select first game
            vm.gameId = $scope.main._user.games[0].id;
            // auto select current year
            var date = new Date();
            for (var i = vm.startYear; i <= date.getFullYear(); i++) {
                vm.years.push(i.toString());
            }
            vm.selectedYear = vm.years[vm.years.length-1];

            vm.getInfo();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

})();
(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('MemberRegisterController', MemberRegisterController);

    /** @ngInject */
    function MemberRegisterController(ApiService, $state, toastr,$rootScope,$filter) {
        var vm = this;
        vm.userInfo = {
            identity: "",
            password: ""
        };

        vm.memberCardId = "";
        vm.memberCardPassword = "";


        vm.firstName = "";
        vm.lastName = "";
        vm.email = "";
        vm.phoneNumber = "";

        vm.stepCount = 1;
        vm.doNextStep = function () {
            ApiService.call('memberRegisterStepOne', {id: vm.memberCardId, password: vm.memberCardPassword}, function (response) {
                if (response.MemberStatus == "OK") {
                    vm.stepCount = 2;
                } else {
                    toastr.error('Problem');
                }

            });

        };

        vm.doRegister = function () {
            if (vm.firstName == "") {
                toastr.error('Please provide your Firstname');
            } else {
                if (vm.lastName == "") {
                    toastr.error('Please provide your Lastname');
                } else {
                    if (vm.email == "") {
                        toastr.error('Please provide your email address');
                    } else {
                        if (vm.phoneNumber == "") {
                            toastr.error('Please provide your phone number');
                        } else {
                            ApiService.call('memberRegister', {id: vm.memberCardId, password: vm.memberCardPassword, name: vm.firstName, lastName: vm.lastName, email: vm.email, phone: vm.phoneNumber}, function (response) {
                                vm.stepCount = 3;
                            });
                        }
                    }
                }
            }

        };

        $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_MEMBER_REGISTER');
    }
})();

(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($rootScope, $scope, EVENTS, $interval, $cookies, ApiService, $state, $filter, NotificationService, TabService, ACTIONS, toastr) {
    var vm = this;

    /* DEFINING COMMON COMPONENTS */

    // defining filter object
    function Filter() {
      this.visible = true;
      this.enabled = true;
      this.value = null;
      this.settings = {};
      this.options = [];
      this.events = {};

      this.setVisible = function (visible) {
        this.visible = visible;
      };

      this.setEnabled = function (enabled) {
        this.enabled = enabled;
      };

      this.setValue = function (value) {
        this.value = value;
        if (this.events.onSelectionChanged != undefined) {
          this.events.onSelectionChanged(value);
        }
      };

      this.setSettings = function (settings) {
        this.settings = settings;
      };

      this.setEvents = function (events) {
        this.events = events;
      };

      this.setOptions = function (options) {
        this.options = options;
      }

    }

    // define filters object
    function Filters() {
      var tempThis = this;
      this.visible = true;
      this.setVisible = function (visible) {
        this.visible = visible;
      };
      // date range filter
      this.dateRange = new Filter();
      this.dateRange.setValue({
        startDate: moment().utc().startOf('day'),
        endDate: moment().utc().endOf('day')
      });

      this.dateRange.setSettings({
        locale: {
          applyClass: 'btn-green',
          applyLabel: 'Apply',
          fromLabel: 'From',
          format: 'DD/MM/YYYY HH:mm',
          toLabel: 'To',
          cancelLabel: 'Cancel',
          customRangeLabel: 'Custom range',
          opens: 'center',
          weekLabel: 'W',
          daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          firstDay: 1,
          separator: " - ",
        },
        showDropdowns: true,
        showWeekNumbers: false,
        showISOWeekNumbers: false,
        timePicker: false,
        timePicker24Hour: false,
        timePickerSeconds: false,
        autoApply: true,
        alwaysShowCalendars: true,
        dateLimit: {
          days: 60
        },
        ranges: {
          'Today': [moment().utc().startOf('day'), moment().utc().endOf('day')],
          'Yesterday': [moment().utc().subtract(1, 'days').startOf('day'), moment().utc().subtract(1, 'days').endOf('day')],
          'Last 7 Days': [moment().utc().subtract(6, 'days').startOf('day'), moment().utc()],
          'Last 30 Days': [moment().utc().subtract(29, 'days').startOf('day'), moment().utc()],
          'This Month': [moment().utc().startOf('month'), moment().utc().endOf('month')],
          'Last Month': [moment().utc().subtract(1, 'month').startOf('month'), moment().utc().subtract(1, 'month').endOf('month')]
        },
        startDate: moment().utc(),
        endDate: moment().utc()
      });

      // game filter
      this.game = new Filter();
      this.game.setValue([]);
      this.game.setSettings({
        enableSearch: true,
        keyboardControls: true,
        template: '<b>{{option.name}}</b>',
        styleActive: true,
        selectedToTop: true,
        clearSearchOnClose: true,
        buttonClasses: "btn-sm-multiple-selection col-sm-12"
      });

      // site filter
      this.site = new Filter();
      this.site.setSettings({
        selectionLimit: 1,
        enableSearch: true,
        keyboardControls: true,
        template: '<b>{{option.domain}}</b>',
        styleActive: true,
        // selectedToTop: true,
        clearSearchOnClose: true,
        // showCheckAll: false,
        showUncheckAll: true,
        closeDropDownOnSelection: true,
        buttonClasses: "btn-sm-multiple-selection col-sm-12"
      });
      this.site.setValue([]);
      this.site.setVisible(false);

      // accounts filter
      this.account = new Filter();

      // view as filter
      this.viewAs = new Filter();
      this.viewAs.setOptions([
        {
          value: 'normal',
          label: $filter('translate')('FILTER_VIEW_AS_NORMAL')
        },
        {
          value: 'platform',
          label: $filter('translate')('FILTER_VIEW_AS_PLATFORM')
        }
      ]);

      this.viewAs.setValue('normal');

      // if viewAs is platform then we need site filter
      this.platforms = new Filter();
      this.platforms.setValue('');

      // owner filter
      this.owner = new Filter();
      this.owner.setValue(ApiService.selectedAccounts);

      this.ownerName = new Filter();
      this.ownerName.setValue('');

      // report type filter
      this.reportType = new Filter();

      // currency exchange filter
      this.currencyExchange = new Filter();
      this.currencyExchange.setValue('enabled');
      this.currencyExchange.setOptions([
        {
          value: 'enabled',
          label: $filter('translate')('FILTER_CURRENCY_SHOW_AS_MINE')
        },
        {
          value: 'disabled',
          label: $filter('translate')('FILTER_CURRENCY_SHOW_AS_ORIGINAL')
        }
      ]);

      // columns filter
      this.columns = new Filter();
      this.columns.setValue([]);
      this.columns.setSettings({
        keyboardControls: true,
        template: '<b>{{option.selectionName}}</b>',
        styleActive: true,
        showCheckAll: true,
        showUncheckAll: true,
        buttonClasses: "btn-sm-multiple-selection col-sm-12"
      });
      this.columns.setEvents({
        onSelectAll: function () {
          // select all columns
          var values = [];
          angular.forEach(tempThis.columns.options, function (value, key) {
            value.active = true;
            values.push({id: value.id});
          });

          tempThis.columns.setValue(values);
        },
        onDeselectAll: function () {
          tempThis.columns.setValue([]);
        },
        onSelectionChanged: function () {
          // affect on table
          var ids = [];
          if (tempThis.columns.value != null && tempThis.columns.value.length > 0) {
            angular.forEach(tempThis.columns.value, function (value, key) {
              ids.push(value.id);
            });
          }

          if (ids.length > 0) {
            angular.forEach(tempThis.columns.options, function (value, key) {
              value.active = ids.indexOf(value.id) > -1;
            });
          }
        }
      });

      // accounts filter
      this.accountsList = new Filter();
      this.accountsList.setValue([]);
      this.accountsList.setSettings({
        keyboardControls: true,
        template: '<b>{{option.username}}</b>',
        styleActive: true,
        showCheckAll: true,
        showUncheckAll: true,
        buttonClasses: "btn-sm-multiple-selection col-sm-12",
        externalIdProp: "id",
        idProp: "id",
      });
      this.accountsList.setEvents({
        onSelectionChanged: function () {
          var selectedAccountsIds = [];
          angular.forEach(vm.filters.accountsList.value, function (user, id) {
            selectedAccountsIds.push(user.id)
          });
          angular.forEach(vm._selectedUser.subAccs, function (user, id) {
            user.isChecked = selectedAccountsIds.indexOf(id) > -1;
          });

          vm.countSelectedAccs(true)
        }
      });

      // search by username filter
      this.username = new Filter();
      this.username.setValue("");
      this.username.setVisible(false);

      // search by email filter
      this.email = new Filter();
      this.email.setValue("");
      this.email.setVisible(false);

      // bet filter
      this.bet = new Filter();
      this.bet.setValue("");
      this.bet.setVisible(false);

      // win filter
      this.win = new Filter();
      this.win.setValue("");
      this.win.setVisible(false);

      // profit filter
      this.profit = new Filter();
      this.profit.setValue("");
      this.profit.setVisible(false);

      // con_id filter
      this.con_id = new Filter();
      this.con_id.setValue("");
      this.con_id.setVisible(false);

      // player_id filter
      this.player_id = new Filter();
      this.player_id.setValue("");
      this.player_id.setVisible(false);

      // sortBy filter
      this.sortBy = new Filter();
      this.sortBy.setValue("created_at");
      this.sortBy.setVisible(false);
      this.sortBy.setOptions([
        {
          value: 'created_at',
          label: $filter('translate')('FILTER_SORT_BY_CREATED_AT')
        },
        {
          value: 'bet',
          label: $filter('translate')('FILTER_SORT_BY_BET')
        },
        {
          value: 'win',
          label: $filter('translate')('FILTER_SORT_BY_WIN')
        },
        {
          value: 'profit',
          label: $filter('translate')('FILTER_SORT_BY_PROFIT')
        },
        {
          value: 'owner_id',
          label: $filter('translate')('FILTER_SORT_BY_OWNER_ID')
        },
        {
          value: 'site_id',
          label: $filter('translate')('FILTER_SORT_BY_SITE_ID')
        },
        {
          value: 'username',
          label: $filter('translate')('FILTER_SORT_BY_USERNAME')
        }
      ]);

      // sortStyle filter
      this.sortStyle = new Filter();
      this.sortStyle.setValue("asc");
      this.sortStyle.setVisible(false);
      this.sortStyle.setOptions([
        {
          value: 'desc',
          label: $filter('translate')('FILTER_SORT_ORDER_DESC')
        },
        {
          value: 'asc',
          label: $filter('translate')('FILTER_SORT_ORDER_ASC')
        }
      ]);

      // queryAccount filter
      this.queryAccount = new Filter();
      this.queryAccount.setValue("");
      this.queryAccount.setVisible(false);

      // search btn click event
      this.applyFilter = function () {
        // console.log("apply filter");
      };

      // set search btn event function
      this.setApplyFilter = function (fn) {
        this.applyFilter = fn;
      }
    }

    /* DEFINING COMMON COMPONENTS FINISH */

    // tab service data
    vm.softSelectedAccountName = "";
    vm.tabData = TabService.data;
    // main active user
    vm._user = {};
    // active user sub accounts
    vm._subAccounts = {};
    // active user
    vm._selectedUser = {};
    // left menu data
    vm._menu = {};
    // system refresh interval function
    vm.updateInterval = undefined;
    // selected account from right menu
    vm._pickedAccount = {};
    // default active right side tab
    vm._selectedRightTab = "accounts";
    // right bar last status
    vm.isRightbarOpened = false;
    // default sub account check status
    vm.checkAllUsers = true;
    // account permissions
    vm._permissions = {};
    // password change model
    vm.changePassword = {
      current: '',
      new: '',
      reNew: ''
    };
    vm.subAccountsCount = 0;
    // flat filter for post request
    vm.flatFilters = {};
    vm.sharedFilters = {};
    // creating filters object
    vm.filters = new Filters();
    // loading animation variable
    vm.loading = false;
    vm.cookieName = 'MAIN_FILTERS';

    vm.advancedSearch = localStorage.getItem('IS_ON_ADVANCED_SEARCH') == "true";

    vm.toggleAdvancedSearch = function (status) {
      vm.advancedSearch = !status;
      localStorage.setItem("IS_ON_ADVANCED_SEARCH", !status);
    };

    // setting loading
    vm.setLoading = function (loading) {
      vm.loading = loading;
    };

    // user default settings
    $rootScope._userSettings = {
      'body': 'default',
      'theme': 'default',
      'language': 'default'
    };

    // user setting saving
    vm.setUserSettings = function (type, value) {
      $rootScope._userSettings[type] = value;

      ApiService.call(ACTIONS.CHANGE_USER_SETTINGS, {settings: $rootScope._userSettings}, (function (response) {

      }));
    };

    // user change password operation
    vm.doChangePassword = function () {
      ApiService.call(ACTIONS.CHANGE_PASSWORD, vm.changePassword, (function (response) {
        // reset change password model
        vm.changePassword = {
          current: '',
          new: '',
          reNew: ''
        };

        // logout user
        vm.doLogout();
      }));
    };

    // user logout operation
    vm.doLogout = function () {
      ApiService.call(ACTIONS.LOGOUT, {}, (function (response) {
        if (typeof response.user === 'undefined') {
          // stoping refresh interval
          vm.cancelInterval();
          // clearing session data
          vm.clearSession();
          $state.go('auth.login');
          return false;
        }
      }));
    };

    // canceling refresh interval
    vm.cancelInterval = function () {
      $interval.cancel(vm.updateInterval);
      vm.updateInterval = undefined;
    };

    // reset session data
    vm.clearSession = function () {
      // Clear logged user and master user
      vm._user = {};
      vm._permissions = {};
      vm._selectedUser = {};
      vm._subAccounts = {};
      vm.filters.accountsList.setOptions([]);
      vm._menu = {};
      // remove session token from cookie
      $cookies.remove('BO_TOKEN');
    };

    vm.clearStorage = function () {
      localStorage.removeItem("REPORT_TURNOVER");
      localStorage.removeItem("REPORT_PLAYER");
      localStorage.removeItem("REPORT_SESSIONS");
      localStorage.removeItem("REPORT_SESSION_ROUNDS");
      localStorage.removeItem("GeneralSharedFilters");
      localStorage.removeItem("GeneralDateRange");
    };

    vm.setAccountListDetails = function () {
      let subAccountsArray = []
      let selectedSubAccountsArray = []
      angular.forEach(vm._selectedUser.subAccs, function (item, id) {
        subAccountsArray.push(item)
        if (item.isChecked)
          selectedSubAccountsArray.push({id: id})
      })
      vm.filters.accountsList.setOptions(subAccountsArray);
      vm.filters.accountsList.setValue(selectedSubAccountsArray);
    }

    vm.loadSelectedAccounts = function () {
      var alreadySelectedIDs = JSON.parse(localStorage.getItem("SELECTED_ACCOUNTS") || "[]")

      if (alreadySelectedIDs && alreadySelectedIDs.length) {
        angular.forEach(vm._selectedUser.subAccs, function (user, userId) {
          vm._selectedUser.subAccs[userId].isChecked = alreadySelectedIDs.indexOf(userId) > -1;
        });
      }
    }

    vm.loopOverAccountAndPickTarget = function (user, id, cb) {

      angular.forEach(user.subAccs, function (u, uid) {
        u.isChecked = uid === id;
      })

      if (user.subAccs && user.subAccs[id] !== void 0) {
        user.subAccs[id].isChecked = true;

        if (vm._selectedUser.id !== user.id) {
          vm.pickAccount(user, function () {
            angular.forEach(vm._selectedUser.subAccs, function (u, uid) {
              u.isChecked = uid === id;
            })

            vm.countSelectedAccs();
            if (cb && typeof cb === "function") cb();
          })

        } else {
          if (cb && typeof cb === "function") cb();
        }

      } else if (user.subAccs) {
        angular.forEach(user.subAccs, function (subUser, subUserID) {
          vm.loopOverAccountAndPickTarget(subUser, id)
        })
      }

    }

    vm.selectOneAccountByID = function (id, cb) {
      vm.loopOverAccountAndPickTarget(vm._selectedUser, id, function () {
        if (cb && typeof cb === "function") cb();
      })

      vm.countSelectedAccs();

    }

    // toggle account check status
    vm.toggleCheckAllUsers = function () {
      angular.forEach(vm._selectedUser.subAccs, function (user, userId) {
        vm._selectedUser.subAccs[userId].isChecked = vm.checkAllUsers;
      });

      vm.countSelectedAccs();
    };

    // count sub accounts
    vm.countSelectedAccs = function (preventSync) {

      vm.subAccountsCount = 0;
      ApiService.selectedAccounts = [];
      angular.forEach(vm._selectedUser.subAccs, function (user, id) {
        vm.subAccountsCount += 1;
        if (user.isChecked) {
          ApiService.selectedAccounts.push(user.id);
        }
      });

      $rootScope.$broadcast(EVENTS.SELECTED_ACCOUNTS_CHANGED, ApiService.selectedAccounts);

      // sync accounts list
      if (!preventSync)
        vm.setAccountListDetails();

      return vm.subAccountsCount;
    };

    // open / close right side bar
    vm.toggleRightBar = function () {
      vm.isRightbarOpened = (!vm.isRightbarOpened);
      vm.countSelectedAccs();
    };

    vm.accountingExcelExport = function (node) {
      var expId = node ? node.id : "overview";
      vm.exportLoadingState = vm.exportLoadingState || [];
      vm.exportLoadingState.push(expId)

      var data = {
        dateRange: {
          startDate: vm.filters.dateRange.value.startDate.toISOString(),
          endDate: vm.filters.dateRange.value.endDate.toISOString(),
        },
        export: "overview"
      };

      if (node && node.id) {
        data.ownerId = node.id;
        data.export = "owner";
      }

      ApiService.call(ACTIONS.ACCOUNTING, data, function (response) {
        if (response.sheet)
          window.open(response.sheet, "blank")

        vm.exportLoadingState.splice(vm.exportLoadingState.indexOf(expId), 1)
      }, function (e) {
        vm.exportLoadingState.splice(vm.exportLoadingState.indexOf(expId), 1)
      });
    }

    vm.convertToCent = function (val) {
      val = val.replace(',', '.');

      if (!isNaN(val))
        val = parseFloat(val) * 100;
      else {
        val = val[0] + (parseFloat(val.substr(1)) * 100);
      }

      return val
    }

    // login as operation
    vm.pickAccount = function (account, cb) {
      if (account === 0) {
        vm._pickedAccount = {};
        ApiService.selectedUser = 0;
      } else {
        vm._pickedAccount = account;
        ApiService.selectedUser = vm._pickedAccount.id;
        if (!account.subAccCount) {
          vm.toggleRightBar();
        }
      }

      ApiService.call(ACTIONS.INIT, {}, function (response) {
        if (response.user) {
          $rootScope.$broadcast(EVENTS.USER_LOGGED, response);
          vm.toggleCheckAllUsers();
        }

        if (cb && typeof cb === "function")
          cb();
      });

    };

    vm.loopOverAccountAndPickTarget = function (user, id, cb) {
      if (!user || !user.id) {
        if (cb && typeof cb === "function") cb();
        return;
      }

      if (user.subAccs && user.subAccs.length)
        angular.forEach(user.subAccs, function (u, uid) {
          u.isChecked = uid === id;
        })

      if (user.subAccs && user.subAccs[id] !== void 0) {
        user.subAccs[id].isChecked = true;

        if (vm._selectedUser && vm._selectedUser.id !== user.id) {
          vm.pickAccount(user, function () {
            angular.forEach(vm._selectedUser.subAccs, function (u, uid) {
              u.isChecked = uid === id;
            })

            vm.countSelectedAccs();

            if (cb && typeof cb === "function") cb();
          })

        } else {
          if (cb && typeof cb === "function") cb();
        }

      } else if (user.subAccs) {
        angular.forEach(user.subAccs, function (subUser, subUserID) {
          vm.loopOverAccountAndPickTarget(subUser, id)
        })
      }

    }

    vm.selectOneAccountByID = function (id, cb) {
      if (!vm._selectedUser) {
        if (cb && typeof cb === "function") cb();
        return;
      }

      vm.loopOverAccountAndPickTarget(vm._selectedUser, id, function () {
        if (cb && typeof cb === "function") cb();
      })

      vm.countSelectedAccs();
    }

    vm.updateInterval = $interval(function () {
      // If there is a user exist
      if ((vm._user.id) && (vm._user.id > 0)) {
        ApiService.call(ACTIONS.UPDATE, {}, (function (response) {
          if (typeof response.user === 'undefined') {
            // stoping refresh interval
            vm.cancelInterval();
            // clearing session data
            vm.clearSession();

            vm.clearStorage();

            $state.go('auth.login');
            return false;
          }
          // vm._user = response.user;
          ApiService.apiPermissions = vm._user.permissions;
        }));
      }
    }, 60000);

    // setting active user after login
    vm.setUser = function (response, broadcast) {
      // set user
      vm._user = response.user;

      // set user settings
      if (vm._user.settings) {
        $rootScope._userSettings = vm._user.settings;
      }

      // set user permissions
      ApiService.apiPermissions = vm._user.permissions;

      // set user sub accounts
      vm._subAccounts = response.user.subAccs;

      // save filters on each user update
      // vm.updateCookiesFilters();

      // set user as selected user if selected user is undefined
      if (typeof response.selectedUser === 'undefined') {
        vm._selectedUser = vm._user;
      } else {
        vm._selectedUser = response.selectedUser;
        if (vm._selectedUser.subAccs.length === 0) {
          // todo info message should be reading from localization file
          NotificationService.showNotification(vm._selectedUser.username, $filter('translate')('SUCCESSFULLY_LOGGED_IN'));
        }

      }

      // load selected accounts
      vm.loadSelectedAccounts();

      // counting sub accounts
      vm.countSelectedAccs();

      // dispatch event that all set
      if (broadcast === true) {
        $rootScope.$broadcast(EVENTS.USER_SET);
      }
    };

    vm.setCookieName = function (cookieName) {
      vm.cookieName = cookieName;
    };

    // sync filters from cookies
    vm.syncFiltersFromCookies = function () {
      vm.advancedSearch = localStorage.getItem('IS_ON_ADVANCED_SEARCH') == "true";
      vm.flatFilters = angular.fromJson(localStorage.getItem(vm.cookieName));
      vm.sharedFilters = angular.fromJson(localStorage.getItem("GeneralSharedFilters"));
      vm.generalDateRage = angular.fromJson(localStorage.getItem("GeneralDateRange"));

      if (vm.flatFilters) {
        angular.forEach(vm.filters, function (filter, key) {
          if (
            typeof filter == 'object' &&
            typeof filter.setVisible == 'function' &&
            filter.visible == true &&
            key != 'owner' &&
            key != 'accountsList'
          ) {
            var flatFilter = vm.flatFilters[key];

            if (key == 'dateRange') {
              filter.setValue({
                startDate: moment.utc(vm.generalDateRage.startDate),
                endDate: moment.utc(vm.generalDateRage.endDate)
              });

            } else {
              filter.setValue(flatFilter);
            }
          }
        });
      }

      if (vm.sharedFilters) {
        angular.forEach(vm.filters, function (filter, key) {
          if (
            typeof filter == 'object' &&
            typeof filter.setVisible == 'function' &&
            filter.visible == true &&
            key != 'owner' &&
            key != 'accountsLıst'
          ) {
            if (["game", "site", "owner", "currencyExchange",
              "username", "email", "win", "profit", "bet",
              "con_id", "player_id", "sortBy", "sortStyle", "queryAccount"].indexOf(key) > -1) {

              if (key === "username" || key === "email")
                filter.setValue((vm.sharedFilters[key] || []).join(""));
              else
                filter.setValue(vm.sharedFilters[key])
            }

          }
        });
      }

      if (!vm.sharedFilters || !vm.flatFilters) {
        vm.updateCookiesFilters();
      }
    };

    // update filters
    vm.updateCookiesFilters = function (from) {
      vm.flatFilters = {
        dateRange: vm.filters.dateRange.value,
        viewAs: vm.filters.viewAs.value,
        reportType: vm.filters.reportType.value,
        columns: vm.filters.columns.value,
        accountsList: vm.filters.accountsList.value,
      };

      vm.sharedFilters = {
        game: vm.filters.game.value || [],
        owner: vm.filters.owner.value,
        site: vm.filters.site.value,
        currencyExchange: vm.filters.currencyExchange.value
      };

      if (vm.filters.win.value)
        vm.sharedFilters.win = vm.filters.win.value;
      if (vm.filters.bet.value)
        vm.sharedFilters.bet = vm.filters.bet.value;
      if (vm.filters.profit.value)
        vm.sharedFilters.profit = vm.filters.profit.value;
      if (vm.filters.email.value)
        vm.sharedFilters.email = vm.filters.email.value.split(",");
      if (vm.filters.username.value)
        vm.sharedFilters.username = vm.filters.username.value.split(",");

      if (vm.filters.con_id.value) {
        vm.sharedFilters.con_id = vm.filters.con_id.value.toString().split(",");
      }

      if (vm.filters.player_id.value)
        vm.sharedFilters.player_id = vm.filters.player_id.value;

      if (vm.filters.sortBy.value)
        vm.sharedFilters.sortBy = vm.filters.sortBy.value;
      if (vm.filters.sortStyle.value)
        vm.sharedFilters.sortStyle = vm.filters.sortStyle.value;
      if (vm.filters.queryAccount.value)
        vm.sharedFilters.queryAccount = vm.filters.queryAccount.value;

      localStorage.setItem(vm.cookieName, angular.toJson(vm.flatFilters));
      localStorage.setItem("GeneralSharedFilters", angular.toJson(vm.sharedFilters));
      localStorage.setItem("GeneralDateRange", angular.toJson(vm.flatFilters.dateRange));
    };

    vm.filterResetFn = $rootScope.$on(EVENTS.ROUTE_CHANGE_START, function (event, toState, toParams, fromState, fromParams, options) {
      // reset filters
      vm.filters.owner.setValue(ApiService.selectedAccounts);

      if (vm.filters != null || vm.filters != undefined) {

        vm.toggleFilters(true, true);
        vm.filters.setVisible(true);
        vm.filters.site.setVisible(false);
      }
    });

    vm.toggleFilters = function (visible, enable) {
      angular.forEach(vm.filters, function (filter, key) {

        if (typeof filter == 'object') {
          if (typeof filter.setVisible == 'function') {
            filter.setVisible(visible);
          }

          if (typeof filter.setEnabled == 'function') {
            filter.setEnabled(enable);
          }
        }
      });
    };

    vm.accountChangeFn = $rootScope.$on(EVENTS.SELECTED_ACCOUNTS_CHANGED, function (event, accounts) {
      vm.filters.owner.setValue(accounts);
      localStorage.setItem("SELECTED_ACCOUNTS", angular.toJson(accounts));
    });

    /* COMMON METHODS */

    // finding site
    vm.findSite = function (siteId) {
      var site = null;
      angular.forEach($scope.main._user.sites, function (value, key) {
        if (value != null && value != 'undefined' && value.hasOwnProperty('id') && siteId === value.id) {
          site = angular.copy(value);
        }
      });

      return site;

    };

    vm.goBack = function () {
      window.history.back();
    };

    // boot system
    vm.bootFn = $rootScope.$on(EVENTS.USER_LOGGED, function (event, response) {
      // setting user
      vm.setUser(response, true);
      // console.log('here', response);
      if ((typeof response.password_recovery !== "undefined") && (response.password_recovery)) {
        vm._selectedRightTab = 'profile';
        vm.toggleRightBar();
        toastr.error('Please change your password immediately due to first login after password recovery.');
      }


      // setting menu
      if (response.menu) {
        vm._menu = response.menu;
      }
    });

    // destroy system bootFn
    $scope.$on('$destroy', vm.bootFn);

    // destroy filterResetFn
    $scope.$on('$destroy', vm.filterResetFn);

    // destroy accountChangeFn
    $scope.$on('$destroy', vm.accountChangeFn);
  }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(ApiService, $state, ACTIONS, $filter, $rootScope) {
        var vm = this;

        // user object for login
        vm.userInfo = {
            identity: '',
            password: ''
        };

        $rootScope.pageTitle = "Login";

        // execute login action
        vm.doLogin = function () {

            function secondLoginCall() {
                ApiService.call(ACTIONS.LOGIN, vm.userInfo, function (response) {

                    if (response.user) {
                        /* Clear object */
                        vm.userInfo = {
                            identity: '',
                            password: ''
                        };

                        if (response.user.account_type == 1) {
                            $state.go('management.partnerSystem');
                        } else {
                            $state.go('management.dashboard');
                        }

                    }
                });
            }

            ApiService.call(ACTIONS.LOGIN, vm.userInfo, function (response) {
                if (response.token)
                    secondLoginCall();

            });

        };

        // $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_LOGIN');

    }

})();

(function () {
    "use strict";

    angular
        .module("bbackoffice")
        .controller("LanguageTranslationController", LanguageTranslationController)
        .controller("LanguageTranslationImportController", LanguageTranslationImportController);

    /** @ngInject */
    function LanguageTranslationController($rootScope,$filter,ApiService) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('language_translation_access');

        vm.bootSystem = function () {
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_LANGUAGE_TRANSLATION');
        };

        vm.bootSystem();
    }

    function LanguageTranslationImportController(ApiService,Upload,ACTIONS) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('language_translation_import_access');

        vm.file={};

        vm.submit = function() {
            // if (vm.form.file.$valid && vm.file)
            {
                vm.upload(vm.file);
            }
        };

        vm.upload = function (file) {
            ApiService.injectToken();
            Upload.upload({
                url: ApiService.apiUrl + '/' + ApiService.postData.token,
                data: {file: file, process: 'importLanguageTranslation',action:ACTIONS.LANGUAGE}
            }).then(function (resp) {
                console.log(resp);
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };

        vm.bootSystem = function () {

        };

        vm.bootSystem();
    }

})();
(function() {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($scope,$filter,$rootScope,ApiService,ACTIONS,EVENTS,$interval) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('dashboard_access');

        vm.news = [];
        vm.statisticDateRange='today';
        vm.isStatsLoading = false;
        vm.statisticDateRanges = [
            {
                title: "TODAY",
                value:'today',
                isSelected: true
            },
            {
                title: "YESTERDAY",
                value:'yesterday',
                isSelected: false
            },
            {
                title: "THIS WEEK",
                value:'thisWeek',
                isSelected: false
            },

            {
                title: "THIS MONTH",
                value:'thisMonth',
                isSelected: false
            }
        ];
        vm.changeStats = function(statKey) {
            for (var i in vm.statisticDateRanges) {
                vm.statisticDateRanges[i].isSelected = (i == statKey);
            }
            vm.statisticDateRange = vm.statisticDateRanges[statKey].value;
            vm.getTotalStatistics();
        };
        vm.totalStatistics = [];
        vm.topTenGames = [];
        vm.topPlayers = [];

        vm.getNews = function () {
            ApiService.call(ACTIONS.DASHBOARD,{moduleName:'news'},function (response) {
                vm.news = response.news;
            });
        };

        vm.getTotalStatistics = function () {
            vm.isStatsLoading = true;
            var ownerIds = [];
            ApiService.call(ACTIONS.DASHBOARD,{moduleName:'totalStatistics',dateRange:vm.statisticDateRange, owner:ApiService.selectedAccounts},function (response) {
                vm.totalStatistics = response.totalStatistics;
                vm.isStatsLoading = false;
            });
        };

        vm.getTopTens = function () {
            ApiService.call(ACTIONS.DASHBOARD,{moduleName:'topTenGames', owner:ApiService.selectedAccounts},function (response) {
                vm.topTenGames = response.topTenGames;
            });
        };

        vm.getTopPlayers = function () {
            ApiService.call(ACTIONS.DASHBOARD,{moduleName:'topPlayers', owner:ApiService.selectedAccounts},function (response) {
                vm.topPlayers = response.topPlayers;
            });
        };

        vm.getRoadMap = function () {

        };

        vm.refreshModules = function () {
            vm.getNews();
            vm.getTotalStatistics();
            vm.getTopTens();
            vm.getTopPlayers();
            vm.getRoadMap();
        };

        vm.bootSystem = function () {
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_DASHBOARD');

            vm.refreshModules();

            // refresh modules every 10 seconds
            vm.refreshInterval = $interval(vm.refreshModules,30000);
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
        $scope.$on('$destroy', function () {
            $interval.cancel(vm.refreshInterval);
            vm.refreshInterval = undefined;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('AuthController', AuthController);

    /** @ngInject */
    function AuthController($state) {
        var vm = this;

        console.log("AUTH");

        // $state.go('auth.login',{},{reload:true});
    }

})();
(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .controller('ApiLogsController', ApiLogsController)
    .controller('ApiLogDetailController', ApiLogDetailController);

  /** @ngInject */
  function ApiLogsController(ApiService, ACTIONS, ngTreetableParams, $scope, $rootScope, EVENTS, $stateParams, $state, $filter) {
    var vm = this;

    // checking user permission
    ApiService.checkPermission('api_logs_access');

    vm.records = null;
    vm.extraData = {
      limit: 20,
      page: 1
    };

    vm.expandedRecords = new ngTreetableParams({
      getTemplate: function (node) {
        return 'tree_node';
      },
      options: {
        onNodeExpand: function () {
          // console.log('A node was expanded!');
        }
      }
    });

    vm.setExpandedRecords = function (newVal) {
      if (newVal != null || newVal != undefined) {
        vm.expandedRecords.getNodes = function (parent) {
          return parent ? parent.subAccs : newVal;
        };
      } else {
        vm.expandedRecords.getNodes = function (parent) {
          return [];
        };
      }
      vm.expandedRecords.refresh();
    };

    vm.beforeApplyBtn = function () {
      $scope.main.updateCookiesFilters();
    };

    vm.getRecords = function () {
      $scope.main.setLoading(true);
      var merged = angular.merge($scope.main.flatFilters, vm.extraData);

      merged.game = $scope.main.sharedFilters.game || [];
      merged.owner = $scope.main.sharedFilters.owner;
      merged.site = $scope.main.sharedFilters.site || [];
      merged.currencyExchange = $scope.main.sharedFilters.currencyExchange;

      merged.filter = $scope.main.sharedFilters;

      delete merged.filter.accountsList;
      delete merged.filter.game;
      delete merged.filter.owner;
      delete merged.filter.site;
      delete merged.filter.currencyExchange;

      merged.filter = $scope.main.sharedFilters;

      // convert to cent
      if (merged.filter.bet) {
        merged.filter.bet = $scope.main.convertToCent(merged.filter.bet)
      }

      // convert to cent
      if (merged.filter.win) {
        merged.filter.win = $scope.main.convertToCent(merged.filter.win)
      }

      // convert to cent
      if (merged.filter.profit) {
        merged.filter.profit = $scope.main.convertToCent(merged.filter.profit)
      }

      if (merged.filter.sortBy)
        merged.sortBy = merged.filter.sortBy;
      if (merged.filter.sortStyle)
        merged.sortStyle = merged.filter.sortStyle;

      delete merged.filter.sortBy;
      delete merged.filter.sortStyle;

      ApiService.call(ACTIONS.API_LOGS, merged, function (response) {
        vm.records = response.records;
        $scope.main.setLoading(false);
      });
    };

    vm.getFirstPage = function () {
      vm.beforeApplyBtn();
      $state.go('management.api-logs', {page: 1}, {reload: true})
    };

    // system boot function
    vm.bootSystem = function () {
      console.log("API LOGS");
      $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_API_LOGS');
      // customize filters
      $scope.main.toggleFilters(false, false);
      $scope.main.filters.dateRange.setVisible(true);
      $scope.main.filters.dateRange.setEnabled(true);
      $scope.main.filters.site.setVisible(true);
      $scope.main.filters.site.setEnabled(true);

      // search button click event
      $scope.main.filters.setApplyFilter(vm.getFirstPage);

      // setting cookie name
      $scope.main.setCookieName('API_LOGS_FILTERS');

      // getting api logs filter
      $scope.main.syncFiltersFromCookies();

      // watch record list and refresh table
      $scope.$watch('apiLogs.records.list', function (newVal, oldVal) {
        vm.setExpandedRecords(newVal);
      }, true);

      if ($stateParams.page != null) {
        vm.extraData.page = $stateParams.page;
      } else {
        vm.extraData.page = 1;
      }

      vm.getRecords();
    };

    vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
      console.log("USER SET");
      // booting system
      vm.bootSystem();
    });

    // destroy system bootFn
    $scope.$on('$destroy', vm.bootFn);
  }

  function ApiLogDetailController(ApiService, $stateParams, ACTIONS, EVENTS, $rootScope, $scope, $filter) {
    var vm = this;

    // checking user permission
    ApiService.checkPermission('api_logs_detail_access');

    vm.record = {};

    vm.getApiLogDetail = function (apiLogId) {
      ApiService.call(ACTIONS.API_LOGS, {apiLogId: apiLogId}, function (response) {
        vm.record = response.record;
        vm.record.request_data = angular.fromJson(vm.record.request_data);
        vm.record.response_data = angular.fromJson(vm.record.response_data);
      });
    };

    vm.bootSystem = function () {
      console.log("API LOG DETAIL");
      $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_API_LOG_DETAIL');

      if ($stateParams.apiLogId != null) {
        vm.getApiLogDetail($stateParams.apiLogId);
      }
    };

    vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
      // booting system
      vm.bootSystem();
    });

    // destroy system bootFn
    $scope.$on('$destroy', vm.bootFn);
  }

})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .controller('ApiDocsController', ApiDocsController);

    function ApiDocsController(ApiService, ACTIONS, EVENTS, $rootScope, $scope,$filter) {
        var vm = this;

        // checking user permission
        ApiService.checkPermission('customer_api_docs_access');

        vm.docs = null;
        vm.apiTypes = [
            $filter('translate')('API_TYPE_CUSTOMER'),
            $filter('translate')('API_TYPE_SEAMLESS')
        ];
        vm.apiType = $filter('translate')('API_TYPE_CUSTOMER');
        vm.method = null;
        vm.methodKey = null;
        vm.site = null;
        vm.activeTab = {
            title: '',
            content: ''
        };
        vm.editor = null;

        vm.getCustomerApiLogsBySiteId = function () {
            $scope.main.setLoading(true);
            ApiService.call(ACTIONS.API_DOCS, {site: vm.site,apiType:vm.apiType}, function (response) {
                vm.docs = response.docs;

                if (vm.docs.methods != undefined) {
                    for (var first in vm.docs.methods) break;
                    vm.changeMethod(first);
                }

                $scope.main.setLoading(false);
            });
        };

        vm.changeMethod = function (methodKey) {
            angular.forEach(vm.docs.methods, function (value, key) {
                if (key == methodKey) {
                    vm.methodKey = key;
                    vm.method = value;
                    vm.changeTabContent(vm.method.codes.languages[0]);
                }
            });
        };

        vm.changeTabContent = function (lang) {
            vm.activeTab.title = lang;
            angular.forEach(vm.method.codes.examples, function (value, key) {
                if (lang == key) {
                    vm.activeTab.content = value;
                }
            });

            if (vm.editor != null) {
                vm.editor.setValue(vm.activeTab.content);
            }
        };

        vm.aceLoaded = function (_editor) {
            // Options
            vm.editor = _editor;
            vm.editor.getSession().setMode('ace/mode/' + vm.activeTab.title);
            vm.editor.setValue(vm.activeTab.content);
            vm.editor.setReadOnly(true);
        };

        vm.aceChanged = function (e) {
            // console.log(vm.editor.getValue());
        };

        vm.bootSystem = function () {
            console.log("CUSTOMER API DOCS");
            $rootScope.pageTitle = $filter('translate')('PAGE_TITLE_API_DOCS');

            vm.site = $scope.main._user.sites[0].id;

            vm.getCustomerApiLogsBySiteId();
        };

        vm.bootFn = $rootScope.$on(EVENTS.USER_SET, function (event, params) {
            // booting system
            vm.bootSystem();
        });

        // destroy system bootFn
        $scope.$on('$destroy', vm.bootFn);
    }

})();
(function() {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('sidebar', SidebarDirective);

    /** @ngInject */
    function SidebarDirective() {
        return {
            restrict: 'EA',
            controller: SidebarController,
            controllerAs: 'sidebar',
            bindToController: true,
            link: function(scope, element, attrs) {
                var $sidebar = $(element);
                $sidebar.sidebar($sidebar.data());

                // Bind events
                // Toggle sub menus
                $('body').on('click', '.sidebar-menu a', function(e) {

                    if ($(this).parent().children('.sub-menu') === false) {
                        return;
                    }
                    var el = $(this);
                    var parent = $(this).parent().parent();
                    var li = $(this).parent();
                    var sub = $(this).parent().children('.sub-menu');

                    if(li.hasClass("active open")){
                        el.children('.arrow').removeClass("active open");
                        sub.slideUp(200, function() {
                            li.removeClass("active open");
                        });

                    }else{
                        parent.children('li.open').children('.sub-menu').slideUp(200);
                        parent.children('li.open').children('a').children('.arrow').removeClass('active open');
                        parent.children('li.open').removeClass("open active");
                        el.children('.arrow').addClass("active open");
                        sub.slideDown(200, function() {
                            li.addClass("active open");

                        });
                    }
                });

            }
        }
    }

    function SidebarController() {
        //var vm = this;
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('selectBox', selectBoxDirective);

    /** @ngInject */
    function selectBoxDirective($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (!window.SelectFx) return;
                var newElement = angular.element('<div class="cs-wrapper"></div>');
                // element.wrap($compile(newElement)(scope));
                new SelectFx(element[0]);
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('rightTabs', rightTabsDirective);

    /** @ngInject */
    function rightTabsDirective($parse) {
        return {
            link: function (scope, element, attrs) {
                var slide = attrs.slide;
                var onShown = $parse(attrs.onShown);
                // Sliding effect for tabs
                $(element).on('show.bs.tab', function (e) {
                    e = $(e.target).parent().find('a[data-toggle=tab]');

                    var hrefCurrent = e.attr('href');

                    if ($(hrefCurrent).is('.slide-left, .slide-right')) {
                        $(hrefCurrent).addClass('sliding');

                        setTimeout(function () {
                            $(hrefCurrent).removeClass('sliding');
                        }, 100);
                    }
                });

                $(element).on('shown.bs.tab', {
                    onShown: onShown
                }, function (e) {
                    if (e.data.onShown) {
                        e.data.onShown(scope);
                    }
                });

                $(element).click(function (e) {
                    e.preventDefault();
                    $(element).tab('show');
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('rightSettingsTab', RightSettingsTabDirective);

    /** @ngInject */
    function RightSettingsTabDirective() {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/views/partials/right-settings-tab.html'
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('rightProfileTab', RightProfileTabDirective);

    /** @ngInject */
    function RightProfileTabDirective() {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/views/partials/right-profile-tab.html'
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('rightBar', RightBarDirective);

    /** @ngInject */
    function RightBarDirective() {
        return {
            restrict: 'A',
            replace: true,
            link: function (scope, element, attrs) {
                var $quickview = $(element);
                $quickview.quickview($quickview.data())

            },
            templateUrl: 'app/views/partials/right-bar.html'
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('rightAccountsTab', RightAccountsTabDirective);

    /** @ngInject */
    function RightAccountsTabDirective() {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/views/partials/right-accounts-tab.html'
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('rightAccountsTabList', RightAccountsTabListDirective);

    /** @ngInject */
    function RightAccountsTabListDirective() {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/views/partials/right-accounts-tab-list.html'
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('rightAccountsTabContainer', RightAccountsTabContainerDirective);

    /** @ngInject */
    function RightAccountsTabContainerDirective() {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/views/partials/right-accounts-tab-container.html'
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('ngEnter', NgEnter);

    /** @ngInject */
    function NgEnter() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if(event.which === 13) {
                    scope.$apply(function(){
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('includeReplace', IncludeReplaceDirective);

    /** @ngInject */
    function IncludeReplaceDirective() {
        return {
            require: 'ngInclude',
            restrict: 'A',
            link: function(scope, el, attrs) {
                el.replaceWith(el.children());
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .directive('formGroup', formGroupDirective);

    /** @ngInject */
    function formGroupDirective() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                $(element).on('click', function () {
                    $(this).find(':input').focus();
                });

                $('body').on('focus', '.form-group.form-group-default :input', function () {
                    $('.form-group.form-group-default').removeClass('focused');
                    $(this).parents('.form-group').addClass('focused');
                });

                $('body').on('blur', '.form-group.form-group-default :input', function () {
                    $(this).parents('.form-group').removeClass('focused');
                    if ($(this).val()) {
                        $(this).closest('.form-group').find('label').addClass('fade');
                    } else {
                        $(this).closest('.form-group').find('label').removeClass('fade');
                    }
                });

                $(element).find('.checkbox, .radio').hover(function () {
                    $(this).parents('.form-group').addClass('focused');
                }, function () {
                    $(this).parents('.form-group').removeClass('focused');
                });
            }
        }
    }
})();

(function() {
    "use strict";

    angular.module('ngTreetable', [])

    /**
     * @ngdoc service
     */
        .factory('ngTreetableParams', ['$log', function($log) {
            var params = function(baseConfiguration) {
                var self = this;

                /**
                 * @ngdoc method
                 * @param {<any>} parent A parent node to fetch children of, or null if fetching root nodes.
                 */
                this.getNodes = function(parent) {}

                /**
                 * @ngdoc method
                 * @param {<any>} node A node returned from getNodes
                 */
                this.getTemplate = function(node) {}

                /**
                 * @ngdoc property
                 */
                this.options = {};

                /**
                 * @ngdoc method
                 */
                this.refresh = function() {}


                if (angular.isObject(baseConfiguration)) {
                    angular.forEach(baseConfiguration, function(val, key) {
                        if (['getNodes', 'getTemplate', 'options'].indexOf(key) > -1) {
                            self[key] = val;
                        } else {
                            $log.warn('ngTreetableParams - Ignoring unexpected property "' + key + '".');
                        }
                    });
                }

            }
            return params;
        }])

        .controller('TreetableController', ['$scope', '$element', '$compile', '$templateCache', '$q', '$http', function($scope, $element, $compile, $templateCache, $q, $http) {

            var params = $scope.ttParams;
            var table = $element;

            $scope.compileElement = function(node, parentId, parentNode) {
                var tpl = params.getTemplate(node);

                var templatePromise = $http.get(params.getTemplate(node), {cache: $templateCache}).then(function(result) {
                    return result.data;
                });

                return templatePromise.then(function(template) {
                    var template_scope = $scope.$parent.$new();
                    angular.extend(template_scope, {
                        node: node,
                        parentNode: parentNode
                    });
                    template_scope._ttParentId = parentId;
                    return $compile(template)(template_scope).get(0);
                })

            }

            /**
             * Expands the given node.
             * @param parentElement the parent node element, or null for the root
             * @param shouldExpand whether all descendants of `parentElement` should also be expanded
             */
            $scope.addChildren = function(parentElement, shouldExpand) {
                var parentNode = parentElement ? parentElement.scope().node : null;
                var parentId = parentElement ? parentElement.data('ttId') : null;

                if (parentElement) {
                    parentElement.scope().loading = true;
                }

                $q.when(params.getNodes(parentNode)).then(function(data) {
                    var elementPromises = [];
                    angular.forEach(data, function(node) {
                        elementPromises.push($scope.compileElement(node, parentId, parentNode));
                    });

                    $q.all(elementPromises).then(function(newElements) {
                        var parentTtNode = parentId != null ? table.treetable("node", parentId) : null;

                        $element.treetable('loadBranch', parentTtNode, newElements);

                        if (shouldExpand) {
                            angular.forEach(newElements, function(el) {
                                $scope.addChildren($(el), shouldExpand);
                            });
                        }

                        if (parentElement) {
                            parentElement.scope().loading = false;
                        }
                    });

                });
            }

            /**
             * Callback for onNodeExpand to add nodes.
             */
            $scope.onNodeExpand = function() {
                if (this.row.scope().loading) return; // make sure we're not already loading
                table.treetable('unloadBranch', this); // make sure we don't double-load
                $scope.addChildren(this.row, $scope.shouldExpand());
            }

            /**
             * Callback for onNodeCollapse to remove nodes.
             */
            $scope.onNodeCollapse = function() {
                if (this.row.scope().loading) return; // make sure we're not already loading
                table.treetable('unloadBranch', this);
            }

            /**
             * Rebuilds the entire table.
             */
            $scope.refresh = function() {
                if(table.data('treetable') != undefined){
                    var rootNodes = table.data('treetable').nodes;
                    while (rootNodes.length > 0) {
                        table.treetable('removeNode', rootNodes[0].id);
                    }
                    $scope.addChildren(null, $scope.shouldExpand());
                }
            }

            // attach to params for convenience
            params.refresh = $scope.refresh;


            /**
             * Build options for the internal treetable library.
             */
            $scope.getOptions = function() {
                var opts = angular.extend({
                    expandable: true,
                    onNodeExpand: $scope.onNodeExpand,
                    onNodeCollapse: $scope.onNodeCollapse
                }, params.options);

                if (params.options) {
                    // Inject required event handlers before custom ones
                    angular.forEach(['onNodeCollapse', 'onNodeExpand'], function(event) {
                        if (params.options[event]) {
                            opts[event] = function() {
                                $scope[event].apply(this, arguments);
                                params.options[event].apply(this, arguments);
                            }
                        }
                    });
                }

                return opts;
            }

            $scope.shouldExpand = function() {
                return $scope.options.initialState === 'expanded';
            }

            $scope.options = $scope.getOptions();
            table.treetable($scope.options);
            $scope.addChildren(null, $scope.shouldExpand());

        }])

        .directive('ttTable', [function() {
            return {
                restrict: 'AC',
                scope: {
                    ttParams: '='
                },
                controller: 'TreetableController'
            }
        }])

        .directive('ttNode', [function() {
            var ttNodeCounter = 0;
            return {
                restrict: 'AC',
                scope: {
                    isBranch: '=',
                    parent: '='
                },
                link: function(scope, element, attrs) {
                    var branch = angular.isDefined(scope.isBranch) ? scope.isBranch : true;

                    // Look for a parent set by the tt-tree directive if one isn't explicitly set
                    var parent = angular.isDefined(scope.parent) ? scope.parent : scope.$parent._ttParentId;

                    element.attr('data-tt-id', ttNodeCounter++);
                    element.attr('data-tt-branch', branch);
                    element.attr('data-tt-parent-id', parent);
                }
            }

        }]);

})();
(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $state, $stateParams, ApiService, EVENTS, ACTIONS) {

        // getting last state and state params
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.redirectRoute = {
            state: {
                name: 'management.dashboard'
            },
            params: {}
        };

        // listening route change
        $rootScope.$on(EVENTS.ROUTE_CHANGE_SUCCESS, function (event, toState, toParams) {

            ApiService.call(ACTIONS.INIT, {}, function (response) {

                // this code for redirect to page that user wanted to go after login success
                if (toState.name !== 'auth' && toState.name !== 'auth.login') {
                    $rootScope.redirectRoute.state = toState;
                    $rootScope.redirectRoute.params = toParams;

                }

                if (!response.user) {
                    if ((toState.authentication === true) || (toState.name === '') || (toState.name === 'auth')) {
                        $state.go('auth.login', {}, {location: 'replace'});
                    }

                } else if (response.user) {
                    if (response.user.account_type == 1) {
                        $state.go('management.partnerSystem', $rootScope.redirectRoute.params, {location: 'replace'});
                    } else {
                        if ($rootScope.redirectRoute.state.name == 'auth' || $rootScope.redirectRoute.state.name == 'auth.login') {
                            $state.go('management.dashboard', $rootScope.redirectRoute.params, {location: 'replace'});
                        } else {
                            $state.go($rootScope.redirectRoute.state.name, $rootScope.redirectRoute.params, {location: 'replace'});
                        }
                    }
                    $rootScope.$broadcast(EVENTS.USER_LOGGED, response);
                }
            });


        });

        $log.debug('runBlock end');
    }

})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {

        var _isMobileBrowser = (function () {
            var check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
            })(navigator.userAgent || navigator.vendor || window.opera);
            return !check;
        })();

        $stateProvider
            .state('auth', {
                url: '/',
                templateUrl: 'app/views/auth/auth.html',
                controller: 'AuthController',
                controllerAs: 'auth',
                authentication: false

            })
            .state('auth.login', {
                url: 'login',
                templateUrl: 'app/views/auth/login.html',
                controller: 'LoginController',
                controllerAs: 'login',
                parent: 'auth',
                authentication: false
            })
            /*.state('auth.member-register', {
                url: 'member-register',
                templateUrl: 'app/views/controllers/member-register.html',
                controller: 'MemberRegisterController',
                controllerAs: 'memberRegister',
                parent: 'auth',
                authentication: false
            })*/
            /*.state('auth.mobile', {
                url: 'mobile',
                templateUrl: 'app/views/controllers/mobile.html',
                controller: 'LoginController',
                controllerAs: 'login',
                parent: 'auth',
                authentication: false
            })*/
            .state('management', {
                url: '/management',
                templateUrl: 'app/views/layouts/default.html',
                controller: 'MainController',
                controllerAs: 'main',
                authentication: true
            })
            .state('management.dashboard', {
                url: '/dashboard',
                templateUrl: 'app/views/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'dashboard',
                parent: 'management',
                authentication: true
            })
            .state('management.apiDocs', {
                url: '/customer-api-docs',
                templateUrl: 'app/views/api-docs/api-docs.html',
                controller: 'ApiDocsController',
                controllerAs: 'apiDocs',
                parent: 'management',
                authentication: true
            })
            .state('management.siteGames', {
                url: '/site-games',
                templateUrl: 'app/views/siteGames/site-games.html',
                controller: 'SiteGamesController',
                controllerAs: 'siteGames',
                parent: 'management',
                authentication: true
            })
            .state('management.apiLogs', {
                url: '/api-logs/:page',
                templateUrl: 'app/views/api-logs/api-logs.html',
                controller: 'ApiLogsController',
                controllerAs: 'apiLogs',
                parent: 'management',
                params: {
                    page: null
                },
                authentication: true
            })
            .state('management.apiLogsDetail', {
                url: '/api-logs-detail/:apiLogId',
                templateUrl: 'app/views/api-logs/detail.html',
                controller: 'ApiLogDetailController',
                controllerAs: 'apiLogDetail',
                parent: 'management',
                params: {
                    apiLogId: null
                },
                authentication: true
            })
            .state('management.report', {
                url: '/report',
                templateUrl: 'app/views/reports/report.html',
                controller: 'ReportController',
                controllerAs: 'report',
                parent: 'management',
                authentication: true
            })
            .state('management.report.account', {
                url: '/turnover',
                templateUrl: 'app/views/reports/turnover.html',
                controller: 'TurnoverReportController',
                controllerAs: 'turnoverReport',
                parent: 'management.report',
                authentication: true
            })
            .state('management.report.macaw', {
                url: '/turnover-macaw/:page',
                templateUrl: 'app/views/reports/turnover-macaw.html',
                controller: 'TurnoverMacawReportController',
                controllerAs: 'turnoverMacawReport',
                parent: 'management.report',
                params: {
                    page: '1'
                },
                authentication: true
            })
            .state('management.report.player', {
                url: '/player/:accountId/:accountName/:page',
                templateUrl: 'app/views/reports/player.html',
                controller: 'PlayerReportController',
                controllerAs: 'playerReport',
                parent: 'management.report',
                params: {
                    accountId: null,
                    accountName: null,
                    page: '1'
                },
                authentication: true
            })
            .state('management.report.session', {
                url: '/session/:playerId/:page',
                templateUrl: 'app/views/reports/session.html',
                controller: 'SessionReportController',
                controllerAs: 'sessionReport',
                parent: 'management.report',
                authentication: true,
                params: {
                    playerId: null,
                    page: '1'
                }
            })
            .state('management.report.sessionRounds', {
                url: '/session-rounds/:conId/:page',
                templateUrl: 'app/views/reports/session-rounds.html',
                controller: 'SessionRoundsReportController',
                controllerAs: 'sessionRoundsReport',
                parent: 'management.report',
                authentication: true,
                params: {
                    conId: 'all',
                    page: '1'
                }
            })
            .state('management.report.sessionRoundDetail', {
                url: '/session-round-detial/:gameId/:roundId',
                templateUrl: 'app/views/reports/session-round-detail.html',
                controller: 'SessionRoundDetailReportController',
                controllerAs: 'sessionRoundDetailReport',
                parent: 'management.report',
                authentication: true,
                params: {
                    gameId: null,
                    roundId: null
                }
            })
            .state('management.seamlessWallet', {
                url: '/seamless-wallet',
                templateUrl: 'app/views/seamless-wallet/seamless-wallet.html',
                controller: 'SeamlessWalletController',
                controllerAs: 'seamlessWallet',
                parent: 'management',
                authentication: true
            })
            .state('management.seamlessWallet.generator', {
                url: '/generator',
                templateUrl: 'app/views/seamless-wallet/generator.html',
                controller: 'SeamlessWalletGeneratorController',
                controllerAs: 'seamlessWalletGenerator',
                parent: 'management.seamlessWallet',
                authentication: true
            })
            .state('management.seamlessWallet.test', {
                url: '/test',
                templateUrl: 'app/views/seamless-wallet/test.html',
                controller: 'SeamlessWalletTestController',
                controllerAs: 'seamlessWalletTest',
                parent: 'management.seamlessWallet',
                authentication: true
            })
            .state('management.partnerSystem', {
                url: '/partner-system',
                templateUrl: 'app/views/partner-system/partners.html',
                controller: 'PartnerSystemController',
                controllerAs: 'partnerSystem',
                parent: 'management',
                authentication: true
            })
            .state('management.players', {
                url: '/players',
                templateUrl: 'app/views/players/players.html',
                controller: 'PlayersController',
                controllerAs: 'players',
                parent: 'management',
                authentication: true
            })
            .state('management.players.list', {
                url: '/list/:page',
                templateUrl: 'app/views/players/list.html',
                controller: 'PlayersListController',
                controllerAs: 'playersList',
                parent: 'management.players',
                authentication: true,
                params: {
                    page: '1'
                }
            })
            .state('management.players.create', {
                url: '/create',
                templateUrl: 'app/views/players/create.html',
                controller: 'PlayersCreateController',
                controllerAs: 'playersCreate',
                parent: 'management.players',
                authentication: true
            })
            .state('management.players.edit', {
                url: '/edit/:id',
                templateUrl: 'app/views/players/edit.html',
                controller: 'PlayersEditController',
                controllerAs: 'playersEdit',
                parent: 'management.players',
                authentication: true,
                params: {
                    id: null
                }
            })
            .state('management.productHub', {
                url: '/product-hub',
                templateUrl: 'app/views/product-hub/product-hub.html',
                controller: 'ProductHubController',
                controllerAs: 'productHub',
                parent: 'management',
                authentication: true
            })
            .state('management.productHub.news', {
                url: '/news',
                templateUrl: 'app/views/product-hub/news.html',
                controller: 'ProductHubNewsController',
                controllerAs: 'productHubNews',
                parent: 'management.productHub',
                authentication: true
            })
            .state('management.productHub.news.list', {
                url: '/list/:page',
                templateUrl: 'app/views/product-hub/news-list.html',
                controller: 'ProductHubNewsListController',
                controllerAs: 'productHubNewsList',
                parent: 'management.productHub.news',
                authentication: true,
                params: {
                    page: '1'
                }
            })
            .state('management.productHub.roadmap', {
                url: '/roadmap',
                templateUrl: 'app/views/product-hub/roadmap.html',
                controller: 'ProductHubRoadmapController',
                controllerAs: 'productHubRoadmap',
                parent: 'management.productHub',
                authentication: true
            })
            .state('management.productHub.roadmap.list', {
                url: '/list/:page',
                templateUrl: 'app/views/product-hub/roadmap-list.html',
                controller: 'ProductHubRoadmapListController',
                controllerAs: 'productHubRoadmapList',
                parent: 'management.productHub.roadmap',
                authentication: true,
                params: {
                    page: '1'
                }
            })
            .state('management.productHub.mediaPack', {
                url: '/media-pack',
                templateUrl: 'app/views/product-hub/media-pack.html',
                controller: 'ProductHubMediaPackController',
                controllerAs: 'productHubMediaPack',
                parent: 'management.productHub',
                authentication: true
            })
            .state('management.productHub.mediaPack.list', {
                url: '/list/:page',
                templateUrl: 'app/views/product-hub/media-pack-list.html',
                controller: 'ProductHubMediaPackListController',
                controllerAs: 'productHubMediaPackList',
                parent: 'management.productHub.mediaPack',
                authentication: true,
                params: {
                    page: '1'
                }
            })
            .state('management.productHub.demoArea', {
                url: '/demo-area',
                templateUrl: 'app/views/product-hub/demo-area.html',
                controller: 'ProductHubDemoAreaController',
                controllerAs: 'productHubDemoArea',
                parent: 'management.productHub',
                authentication: true
            })
            .state('management.language', {
                url: '/language',
                templateUrl: 'app/views/language/language.html',
                controller: 'LanguageTranslationController',
                controllerAs: 'languageTranslation',
                parent: 'management',
                authentication: true
            })
            .state('management.language.import', {
                url: '/import',
                templateUrl: 'app/views/language/import.html',
                controller: 'LanguageTranslationImportController',
                controllerAs: 'languageTranslationImport',
                parent: 'management.language',
                authentication: true
            })
        ;
        $urlRouterProvider.otherwise('login');

    }

})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .filter('range', RangeFilter);

    /** @ngInject */
    function RangeFilter(){
        return function(input, start,end) {
            start = parseInt(start);
            end = parseInt(end);

            for (var i=start; i<=end; i++) {
                input.push(i);
            }

            return input;
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .factory('page', PageFactory);

    /** @ngInject */
    function PageFactory() {
        var title = 'Spinmatic Entertainment';
        return {
            title: function() { return title; },
            setTitle: function(newTitle) { title = newTitle }
        };
    }

})();

/* global malarkey:false, moment:false */
var env = {};

// Import variables if present (from env.js)
if(window){
  Object.assign(env, window.__env);
}

(function () {
  'use strict';

  angular
    .module('bbackoffice')
    .constant('EVENTS', {
      ROUTE_CHANGE_SUCCESS: '$stateChangeSuccess',
      ROUTE_CHANGE_START: '$stateChangeStart',
      USER_LOGGED: 'userLogged',
      USER_SET: 'userSet',
      SELECTED_ACCOUNTS_CHANGED: 'selectedAccountsChanged'
    })
    .constant('ACTIONS', {
      LOGIN: 'login',
      LOGOUT: 'logout',
      INIT: 'init',
      CHANGE_USER_SETTINGS: 'changeUserSettings',
      CHANGE_PASSWORD: 'changePassword',
      UPDATE: 'update',
      REPORT: 'report',
      DASHBOARD: 'dashboard',
      API_LOGS: 'apiLogs',
      API_DOCS: 'apiDocs',
      LIST_SITE_GAMES: 'listSiteGames',
      TOGGLE_SITE_GAME_STATUS: 'toggleSiteGameStatus',
      SEAMLESS_WALLET_INTEGRATION: 'seamlessWalletIntegration',
      LANGUAGE: 'language',
      PLAYERS: 'players',
      TEST: 'test',
      PARTNER_SYSTEM: 'partnerSystem',
      SYSTEM_COUNTRIES: 'systemCountries',
      SYSTEM_LANGUAGES: 'systemLanguages',
      ACCOUNTS: 'accounts',
      SITES: 'sites',
      NEWS: 'news',
      ROADMAP: 'roadmap',
      MEDIA_PACK: 'mediaPack',
      ACCOUNTING: 'accounting',
    })
    .constant('ENV', env)

})();

(function () {
    'use strict';

    angular
        .module('bbackoffice')
        .config(config)
        // .config(dateRangePickerConfig)
        .config(toastrConfig)
        .config(translation);

    /** @ngInject */
    function config($logProvider, ENV) {
        // Enable log
        moment.tz.setDefault('UTC');
        $logProvider.debugEnabled(ENV.enableDebug);
    }

    // function dateRangePickerConfig(dateRangePickerConfig) {
    //     angular.extend(dateRangePickerConfig, );
    // }

    function toastrConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            autoDismiss: true,
            containerId: 'toast-container',
            maxOpened: 2,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: true,
            target: 'body',
            timeOut: 1000
        });
    }

    function translation($translateProvider) {
        // angular-language
        $translateProvider.useStaticFilesLoader({
            prefix: 'assets/languages/',
            suffix: '.json'
        });
        $translateProvider.useLocalStorage();
        $translateProvider.preferredLanguage('EN');
        $translateProvider.useSanitizeValueStrategy(null);
    }


})();

angular.module("bbackoffice").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/api-logs/api-logs.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><!--FILTERS START--><div ng-include src=\"\'app/views/partials/filters.html\'\" include-replace></div><!--FILTERS FINISH--></div><div class=clearfix></div><div class=\"col-lg-12 col-md-12\"><!--REPORT START--><div id=exportThis><script type=text/ng-template id=tree_node><tr tt-node is-branch=\"node.subAccIds.length>0\">\n\n                        <td class=\"v-align-middle semi-bold\">\n                            {{ node.id }}\n                        </td>\n\n                        <td class=\"v-align-middle semi-bold\">\n                            {{ node.site.domain }}\n                        </td>\n\n                        <td class=\"v-align-middle semi-bold\">\n                            {{ node.action }}\n                        </td>\n\n                        <td class=\"v-align-middle semi-bold\">\n                            {{ node.ip_address }}\n                        </td>\n\n                        <td class=\"v-align-middle\">\n                            {{ node.created_at}}\n                        </td>\n\n                        <td class=\"v-align-middle\">\n                            <a ui-sref=\"management.apiLogsDetail({apiLogId:node.id})\" ui-sref-opts=\"{reload: true}\" class=\"btn btn-info btn-sm\">\n                                <i class=\"fa fa-eye\"></i>\n                            </a>\n                        </td>\n\n                    </tr></script><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'API_LOGS_LIST_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ng-if=!main.loading><!--PLAYER LIST--><table tt-table tt-params=apiLogs.expandedRecords class=\"table table-hover table-condensed table-detailed\"><thead><tr><th>{{ \'FILTER_COLUMNS_ID_TITLE\' | translate }}</th><th>{{ \'FILTER_COLUMNS_SITE_TITLE\' | translate }}</th><th>{{ \'FILTER_COLUMNS_ACTION_TITLE\' | translate }}</th><th>{{ \'FILTER_COLUMNS_IP_ADDRESS_TITLE\' | translate }}</th><th>{{ \'FILTER_COLUMNS_CREATED_AT_TITLE\' | translate }}</th><th>#</th></tr></thead><tbody></tbody></table><span class=\"label label-default\">{{ \'PAGINATION_TOTAL_RECORDS\' | translate }} : {{ apiLogs.records.totalResults }}</span> <span class=\"label label-default\">{{ \'PAGINATION_TOTAL_PAGES\' | translate }} : {{ apiLogs.records.totalPages }}</span><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"apiLogs.records.page>1\"><a ui-sref=management.apiLogs({page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"apiLogs.records.page>1\"><a ui-sref=management.apiLogs({page:(apiLogs.records.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':apiLogs.records.page==pageNum}\" ng-repeat=\"pageNum in [] | range:apiLogs.records.start:apiLogs.records.end\"><a ui-sref=management.apiLogs({page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"apiLogs.records.page<apiLogs.records.totalPages\"><a ui-sref=management.apiLogs({page:(apiLogs.records.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"apiLogs.records.page<apiLogs.records.totalPages\"><a ui-sref=management.apiLogs({page:apiLogs.records.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav><!--SESSION LIST--></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div></div><!--REPORT FINISH--></div><div class=clearfix></div></div></div>");
$templateCache.put("app/views/api-logs/detail.html","<div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p class=text-center data-ng-bind-html=\"\'API_LOGS_DETAIL_DESC\' | translate:\'{apiLogId:\'+apiLogDetail.record.id+\'}\' | htmlSafe\"></p></div></div><div class=panel-body><div class=row><div class=col-md-12><table class=\"table table-striped\"><tr><td>{{ \'FILTER_COLUMNS_ID_TITLE\' | translate }}</td><td>{{ apiLogDetail.record.id }}</td></tr><tr><td>{{ \'FILTER_COLUMNS_SITE_TITLE\' | translate }}</td><td><span class=label ng-class=\"{\'label-success\':apiLogDetail.record.site.status==1,\'label-error\':apiLogDetail.record.site.status==0}\">{{ apiLogDetail.record.site.domain }}</span></td></tr><tr><td>{{ \'FILTER_COLUMNS_ACTION_TITLE\' | translate }}</td><td>{{ apiLogDetail.record.action }}</td></tr><tr><td>{{ \'FILTER_COLUMNS_IP_ADDRESS_TITLE\' | translate }}</td><td>{{ apiLogDetail.record.ip_address }}</td></tr><tr><td>{{ \'FILTER_COLUMNS_CREATED_AT_TITLE\' | translate }}</td><td>{{ apiLogDetail.record.created_at}}</td></tr></table></div><div class=clearfix></div><div class=col-md-6><h4>{{ \'FILTER_COLUMNS_REQUEST_TITLE\' | translate }}</h4><json-formatter class=json-formatter-dark open json=apiLogDetail.record.request_data></json-formatter></div><div class=col-md-6><h4>{{ \'FILTER_COLUMNS_RESPONSE_TITLE\' | translate }}</h4><json-formatter class=json-formatter-dark open json=apiLogDetail.record.response_data></json-formatter></div><div class=clearfix></div></div></div></div>");
$templateCache.put("app/views/auth/auth.html","<div ui-view></div>");
$templateCache.put("app/views/auth/login.html","<div class=login-wrapper><!-- START Login Background Pic Wrapper--><div class=bg-pic><!-- START Background Pic--> <img src=assets/img/backoffice_bg.jpg data-src=assets/img/backoffice_bg.jpg data-src-retina=assets/img/backoffice_bg.jpg alt=\"\" class=lazy></div><!-- END Login Background Pic Wrapper--><!-- START Login Right Container--><div class=\"login-container bg-white\"><div class=\"p-l-50 m-l-20 p-r-50 m-r-20 p-t-50 m-t-30 sm-p-l-15 sm-p-r-15 sm-p-t-40\"><img src=assets/img/logo.png alt=logo data-src=assets/img/logo.png data-src-retina=assets/img/logo.png><p class=p-t-35>{{ \'LOGIN_HEADER\' | translate }}</p><!-- START Login Form --><form id=form-login class=p-t-15 role=form ng-submit=login.doLogin()><!-- START Form Control--><div class=\"form-group form-group-default\"><label>{{ \'LOGIN_USERNAME\' | translate }}</label><div class=controls><input type=text name=username placeholder=\"{{ \'LOGIN_USERNAME_PLACEHOLDER\' | translate }}\" class=form-control ng-model=login.userInfo.identity required></div></div><!-- END Form Control--><!-- START Form Control--><div class=\"form-group form-group-default\"><label>{{ \'LOGIN_PASSWORD\' | translate }}</label><div class=controls><input type=password class=form-control name=password ng-model=login.userInfo.password placeholder=\"{{ \'LOGIN_PASSWORD_PLACEHOLDER\' | translate }}\" required></div></div><!-- START Form Control--><div class=row><div class=\"col-md-6 no-padding sm-p-l-10\"><div class=checkbox><input type=checkbox value=1 id=checkbox1><label for=checkbox1>{{ \'LOGIN_KEEP_ME_SIGNED_IN\' | translate }}</label></div></div><!--<div class=\"col-md-6 d-flex align-items-center justify-content-end\">--><!--<a href=\"#\" class=\"text-info small\">Help? Contact Support</a>--><!--</div>--></div><!-- END Form Control--> <button class=\"btn btn-primary btn-cons m-t-10\" type=submit ng-hide=login.loginProgress>{{ \'LOGIN_SIGN_IN_BTN\' | translate }}</button></form><!--END Login Form--></div></div><!-- END Login Right Container--></div>");
$templateCache.put("app/views/auth/member-register.html","<div class=\"register-container full-height sm-p-t-30\"><div class=\"d-flex justify-content-center flex-column full-height\" ng-if=\"memberRegister.stepCount == 1\"><img src=assets/img/logo.png alt=logo><h3>Please type codes in Membership card</h3><form id=form-register class=p-t-15 role=form><div class=row><div class=col-md-12><div class=\"form-group form-group-default\"><label>Member ID</label><input type=text name=uname placeholder=\"SM - XXXXXXX\" class=form-control ng-model=memberRegister.memberCardId required></div></div></div><div class=row><div class=col-md-12><div class=\"form-group form-group-default\"><label>Password</label><input type=password name=pass placeholder=\"\" class=form-control ng-model=memberRegister.memberCardPassword required></div></div></div><button class=\"btn btn-primary btn-cons m-t-10 pull-right\" type=submit ng-click=memberRegister.doNextStep()>Next Step ></button></form><div class=col-md-12><br><h3>Quick How To</h3><div class=row><img src=assets/img/SM_MemberID.png style=\"width: 100%\"></div><div class=row><img src=assets/img/SM_Member2.png style=\"width: 100%\"></div></div></div><div class=\"d-flex justify-content-center flex-column full-height\" ng-if=\"memberRegister.stepCount == 2\"><img src=assets/img/logo.png alt=logo><h3>One more step</h3><form id=form-register2 class=p-t-15 role=form><div class=row><div class=col-md-6><div class=\"form-group form-group-default\"><label>First Name</label><input type=text name=fname class=form-control ng-model=memberRegister.firstName required></div></div><div class=col-md-6><div class=\"form-group form-group-default\"><label>Last Names</label><input type=text name=lname class=form-control ng-model=memberRegister.lastName required></div></div></div><div class=row><div class=col-md-12><div class=\"form-group form-group-default\"><label>Phone Number</label><input type=text name=uname ng-model=memberRegister.phoneNumber placeholder=\"\" class=form-control required></div></div></div><div class=row><div class=col-md-12><div class=\"form-group form-group-default\"><label>Email</label><input type=email name=email ng-model=memberRegister.email placeholder=\"We will send loging details to you\" class=form-control required></div></div></div><button class=\"btn btn-primary btn-cons m-t-10 pull-right\" type=submit ng-click=memberRegister.doRegister()>Become a Member</button></form></div><div class=\"d-flex justify-content-center flex-column full-height\" ng-if=\"memberRegister.stepCount == 3\"><img src=assets/img/logo.png alt=logo><h3>You have successfully registered.<br>Our team will be in contact with you shortly.</h3></div></div>");
$templateCache.put("app/views/api-docs/api-docs.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><div class=\"panel panel-transparent\"><div class=panel-body><form name=personal id=form-personal role=form novalidate><div class=row><!--SITE FILTER START--><div class=col-sm-3><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-globe\"></i>{{ \'FILTER_PLATFORMS\' | translate }}</label><select class=\"cs-select cs-skin-slide\" ng-model=apiDocs.site data-init-plugin=cs-select><option value={{site.id}} ng-repeat=\"site in main._user.sites\">{{ site.domain }}</option></select></div></div><!--SITE FILTER FINISH--><!--API FILTER START--><div class=col-sm-3><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-terminal\"></i>{{ \'FILTER_API_TYPE\' | translate }}</label><select class=\"cs-select cs-skin-slide\" ng-model=apiDocs.apiType data-init-plugin=cs-select><option value=\"{{ apiType }}\" ng-repeat=\"apiType in apiDocs.apiTypes\">{{ apiType }}</option></select></div></div><!--API FILTER FINISH--><div class=col-sm-3><div class=\"btn-group btn-group-justified\"><div class=btn-group><button type=button class=\"btn btn-info\" ng-click=apiDocs.getCustomerApiLogsBySiteId()><span class=\"p-t-5 p-b-5\"><i class=\"fa fa-15\" ng-class=\"{\'fa-spinner\': main.loading, \'fa-search\': !main.loading}\"></i></span><br><span class=\"fs-11 font-montserrat text-uppercase\">{{ \'FILTER_SEARCH_BTN\' | translate }}</span></button></div></div></div><div class=clearfix></div></div></form></div></div></div><div class=clearfix></div><div class=\"col-lg-12 col-md-12\"><!--CUSTOMER DOCS START--><div class=\"panel panel-transparent\"><div class=panel-body><div class=row ng-if=!main.loading><div class=col-md-9><div class=row><div class=col-md-12><b>{{ \'CUSTOMER_API_DOCS_BASE_API_URL\' | translate }}</b> : {{ apiDocs.docs.baseApiUrl }}<br><b>{{ \'CUSTOMER_API_DOCS_SITE_ID\' | translate }}</b> : {{ apiDocs.docs.site.id }}<br><b>{{ \'CUSTOMER_API_DOCS_SITE_DOMAIN\' | translate }}</b> : {{ apiDocs.docs.site.domain }}<br><b>{{ \'CUSTOMER_API_DOCS_SITE_PRIVATE_KEY\' | translate }}</b> : {{ apiDocs.docs.site.privateKey }}<br><b>{{ \'CUSTOMER_API_DOCS_SITE_PUBLIC_KEY\' | translate }}</b> : {{ apiDocs.docs.site.publicKey }}<br><b>{{ \'CUSTOMER_API_DOCS_SITE_ACCESS_KEY\' | translate }}</b> : {{ apiDocs.docs.site.accessKey }}<br><hr></div><div class=clearfix></div><div class=col-md-12><h3>{{ apiDocs.method.title | translate }}</h3><p>{{ apiDocs.method.description | translate }}</p></div><div class=clearfix></div><div class=col-md-12><h5>{{ \'CUSTOMER_API_DOCS_REQUEST_TITLE\' | translate }}</h5><table class=\"table table-responsive\"><thead><tr><th>{{ \'CUSTOMER_API_DOCS_REQUEST_PARAM_NAME\' | translate }}</th><th>{{ \'CUSTOMER_API_DOCS_REQUEST_PARAM_VALUE\' | translate }}</th><th>{{ \'CUSTOMER_API_DOCS_REQUEST_PARAM_TYPE\' | translate }}</th><th>{{ \'CUSTOMER_API_DOCS_REQUEST_PARAM_REQUIRED\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"param in apiDocs.method.requestParams\"><td>{{ param.paramName | translate }}</td><td><p>{{ param.paramValue | translate }}</p></td><td><p ng-repeat=\"(key,pType) in param.paramType\">{{ pType | translate }}({{ param.paramTypeLong[key] }})</p></td><td><i class=fa ng-class=\"{\'fa-check text-success\':param.paramRequired,\'fa-times text-danger\':!param.paramRequired}\"></i></td></tr></tbody></table></div><div class=clearfix></div><!--<div class=\"col-md-12\">--><!--<h5>{{ \'CUSTOMER_API_DOCS_RESPONSE_TITLE\' | translate }}</h5>--><!--<table class=\"table table-responsive\">--><!--<thead>--><!--<tr>--><!--<th>{{ \'CUSTOMER_API_DOCS_RESPONSE_PARAM_NAME\' | translate }}</th>--><!--<th>{{ \'CUSTOMER_API_DOCS_RESPONSE_PARAM_VALUE\' | translate }}</th>--><!--<th>{{ \'CUSTOMER_API_DOCS_RESPONSE_PARAM_TYPE\' | translate }}</th>--><!--<th>{{ \'CUSTOMER_API_DOCS_RESPONSE_PARAM_REQUIRED\' | translate }}</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat=\"param in apiDocs.method.responseParams\">--><!--<td>{{ param.paramName | translate }}</td>--><!--<td><p>{{ param.paramValue | translate }}</p></td>--><!--<td>--><!--<p ng-repeat=\"(key,pType) in param.paramType\">{{ pType | translate }}({{ param.paramTypeLong[key] }})</p>--><!--</td>--><!--<td>--><!--<i class=\"fa\" ng-class=\"{\'fa-check text-success\':param.paramRequired,\'fa-times text-danger\':!param.paramRequired}\"></i>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--<div class=\"clearfix\"></div>--><!--<div class=\"col-md-12\">--><!--<h5>{{ \'CUSTOMER_API_DOCS_EXAMPLE_CODE_TITLE\' | translate }}</h5>--><!--</div>--><!--<div class=\"clearfix\"></div>--><!--<div class=\"col-md-12\">--><!--<div class=\"card card-borderless\">--><!--<ul class=\"nav nav-tabs nav-tabs-simple\" role=\"tablist\" data-init-reponsive-tabs=\"dropdownfx\">--><!--<li class=\"nav-item\" ng-repeat=\"langTitle in apiDocs.method.codes.languages\">--><!--<a ng-class=\"{\'active\':apiDocs.activeTab.title==langTitle}\"--><!--data-toggle=\"tab\" role=\"tab\" data-target=\"#tab{{langTitle}}\" href=\"#\"--><!--ng-click=\"apiDocs.changeTabContent(langTitle)\">{{ langTitle }}</a>--><!--</li>--><!--</ul>--><!--</div>--><!--</div>--><!--<div class=\"clearfix\"></div>--><!--<div class=\"col-md-12\">--><!--<div class=\"card card-borderless\">--><!--<div class=\"tab-content\">--><!--<div class=\"tab-pane active\">--><!--<div class=\"row column-seperation\">--><!--<code>{{ apiDocs.activeTab.content }}</code>--><!--<div ui-ace=\"{--><!--useWrapMode : true,--><!--showGutter: false,--><!--theme:\'twilight\',--><!--mode: apiDocs.activeTab.title,--><!--firstLineNumber: 5,--><!--onLoad: apiDocs.aceLoaded,--><!--onChange: apiDocs.aceChanged--><!--}\"></div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"clearfix\"></div>--></div></div><div class=col-md-3><h4>{{ \'FILTER_METHODS\' | translate }}</h4><div class=list-group><button type=button class=list-group-item ng-class=\"{ \'active\': key == apiDocs.methodKey }\" ng-repeat=\"(key,method) in apiDocs.docs.methods\" ng-click=apiDocs.changeMethod(key)>{{ key }}</button></div></div><div class=clearfix></div></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div><!--CUSTOMER DOCS FINISH--></div><div class=clearfix></div></div></div>");
$templateCache.put("app/views/layouts/default.html","<!-- BEGIN SIDEBAR --><div ng-include src=\" \'app/views/partials/sidebar.html\' \" include-replace></div><!-- END SIDEBAR --><!-- START PAGE-CONTAINER --><div class=page-container><!-- START PAGE HEADER WRAPPER --><div ng-include=\" \'app/views/partials/header.html\' \"></div><!-- END PAGE HEADER WRAPPER --><!-- START PAGE CONTENT WRAPPER --><div class=page-content-wrapper><!-- START PAGE CONTENT --><div class=\"content full-height full-width\"><div ng-include=\" \'app/views/partials/navigator.html\' \"></div><div ui-view></div></div><!-- END PAGE CONTENT --><div ng-include=\" \'app/views/partials/footer.html\'\"></div></div><!-- END PAGE CONTENT WRAPPER --></div><!-- END PAGE CONTAINER --><!--START QUICKVIEW --><div right-bar></div><!-- END QUICKVIEW--><!-- START OVERLAY --><div ng-include src=\" \'app/views/partials/quick-search.html\' \" include-replace></div><!-- END OVERLAY -->");
$templateCache.put("app/views/language/import.html","<div class=row><div class=col-md-12><form class=form-inline name=form><label for=file>{{ \'LANGUAGE_TRANSLATION_IMPORT_SELECT_FILE\' | translate }}</label><input id=file type=file class=form-control ngf-select ng-model=languageTranslationImport.file name=file ngf-accept=\"\'.json\'\" ngf-max-size=10MB> <button class=\"btn btn-lg btn-default\" type=button ng-click=languageTranslationImport.submit()>{{ \'LANGUAGE_TRANSLATION_IMPORT_SUBMIT\' | translate }}</button></form></div><div class=clearfix></div><div class=col-md-12>{{languageTranslationImport.file}}<!--<json-formatter class=\"json-formatter-dark\" open=\"1\" json=\"languageTranslationImport.file\"></json-formatter>--></div><div class=clearfix></div></div>");
$templateCache.put("app/views/language/language.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><!--LANGUAGE TRANSLATION START--><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'LANGUAGE_TRANSLATION_TITLE_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ui-view></div></div></div><!--LANGUAGE TRANSLATION FINISH--></div><div class=clearfix></div></div></div>");
$templateCache.put("app/views/partials/filter-view-as.html","<div class=row ng-show=main.filters.visible><div class=col-sm-3 ng-if=main.filters.reportType.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-money\"></i>{{ \'FILTER_REPORT_TYPE\' | translate }}</label><select ng-disabled=!main.filters.reportType.enabled class=full-width data-init-plugin=select2 ng-model=main.filters.reportType.value ng-change=main.filters.reportType.events.valueChange(main.filters.reportType.value)><option value={{optionObj.value}} ng-repeat=\"optionObj in main.filters.reportType.options\">{{ optionObj.label }}</option></select></div></div><div class=col-sm-3 ng-if=main.filters.platforms.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-globe\"></i>{{ \'FILTER_PLATFORMS\' | translate }}</label><select ng-disabled=!main.filters.platforms.enabled class=full-width data-init-plugin=select2 ng-model=main.filters.platforms.value ng-change=report.setRecords(report.siteRecords.sites[main.filters.platforms.value])><option value={{key}} ng-repeat=\"(key,value) in report.siteRecords.sites\">{{ value.info.domain }}</option></select></div></div></div>");
$templateCache.put("app/views/partials/filters.html","<div class=\"panel panel-transparent\" ng-show=main.filters.visible><div class=panel-body><form name=personal id=form-personal role=form novalidate><div class=row><!--DATE RANGE FILTER--><div class=col-sm-3 ng-if=main.filters.dateRange.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-calendar\"></i>{{ \'FILTER_DATE_RANGE\' | translate }}</label><input ng-disabled=!main.filters.dateRange.enabled class=\"form-control date-picker\" type=text date-range-picker options=main.filters.dateRange.settings ng-model=main.filters.dateRange.value></div></div><!--GAME FILTER--><div class=col-sm-3 ng-if=main.filters.game.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-gamepad\"></i>{{ \'FILTER_GAMES\' | translate }}</label><fieldset ng-dropdown-multiselect=\"\" options=main._user.games ng-disabled=!main.filters.game.enabled selected-model=main.filters.game.value extra-settings=main.filters.game.settings></fieldset></div></div><!--PLATFORMS--><div class=col-sm-3 ng-if=main.filters.site.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-sitemap\"></i>{{ \'FILTER_PLATFORMS\' | translate }}</label><fieldset ng-dropdown-multiselect=\"\" options=main._user.sites ng-disabled=!main.filters.site.enabled selected-model=main.filters.site.value extra-settings=main.filters.site.settings events=main.filters.site.events></fieldset></div></div><!--ACCOUNTS--><div class=col-sm-3 ng-if=main.filters.account.visible><fieldset ng-if=main.filters.account.enabled form-group class=\"form-group form-group-default form-group-default-select\" ng-click=main.toggleRightBar();><label><i class=\"fa fa-user\"></i>{{ \'FILTER_CHANGE_ACCOUNT\' | translate }}</label>{{ main._selectedUser.username}}</fieldset><fieldset ng-if=!main.filters.account.enabled form-group class=\"form-group form-group-default form-group-default-select\" ng-click=main.goBack()><label><i class=\"fa fa-user\"></i>{{ \'FILTER_CHANGE_ACCOUNT\' | translate }}</label>Selected Account: {{main.softSelectedAccountName}}</fieldset></div><div class=col-sm-3 ng-if=main.filters.accountsList.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-th\"></i>{{ \'FILTER_SUB_ACCOUNTS\' | translate }}</label><fieldset ng-dropdown-multiselect=\"\" ng-disabled=!main.filters.accountsList.enabled options=main.filters.accountsList.options selected-model=main.filters.accountsList.value extra-settings=main.filters.accountsList.settings events=main.filters.accountsList.events></fieldset></div></div><div class=clearfix></div><!--VIEW AS--><!--<div class=\"col-sm-3\" ng-if=\"main.filters.viewAs.visible\">--><!--<div form-group class=\"form-group form-group-default form-group-default-select\">--><!--<label><i class=\"fa fa-window-restore\"></i>{{ \'FILTER_VIEW_AS\' | translate }}</label>--><!--<select ng-disabled=\"!main.filters.viewAs.enabled\" class=\"full-width\" data-init-plugin=\"select2\" ng-model=\"main.filters.viewAs.value\">--><!--<option value=\"{{optionObj.value}}\" ng-repeat=\"optionObj in main.filters.viewAs.options\">{{ optionObj.label }}</option>--><!--</select>--><!--</div>--><!--</div>--><!--COLUMNS--><div class=col-sm-3 ng-if=main.filters.columns.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-th\"></i>{{ \'FILTER_SHOW_COLUMNS\' | translate }}</label><fieldset ng-dropdown-multiselect=\"\" ng-disabled=!main.filters.columns.enabled options=main.filters.columns.options selected-model=main.filters.columns.value extra-settings=main.filters.columns.settings events=main.filters.columns.events></fieldset></div></div><!--CURRENCY CHANGE--><div class=col-sm-3 ng-if=main.filters.currencyExchange.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-money\"></i>{{ \'FILTER_CURRENCY_CONVERSION\' | translate }}</label><select ng-disabled=!main.filters.currencyExchange.enabled class=full-width data-init-plugin=select2 ng-model=main.filters.currencyExchange.value><option value={{optionObj.value}} ng-repeat=\"optionObj in main.filters.currencyExchange.options\">{{ optionObj.label }}</option></select></div></div><!--ACCOUNT QUERY FILTER--><div class=col-sm-3 ng-if=main.filters.queryAccount.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-user\"></i>{{ \'FILTER_QUERY_ACCOUNTS\' | translate }}</label><input ng-disabled=!main.filters.queryAccount.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.queryAccount.value placeholder=\"Search in accounts\"></div></div><!--SORT BY CHANGE--><div class=col-sm-3 ng-if=main.filters.sortBy.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-sort\"></i>{{ \'FILTER_SORT_BY\' | translate }}</label><select ng-disabled=!main.filters.sortBy.enabled class=full-width data-init-plugin=select2 ng-model=main.filters.sortBy.value><option value={{optionObj.value}} ng-repeat=\"optionObj in main.filters.sortBy.options\">{{ optionObj.label }}</option></select></div></div><!--SORT STYLE CHANGE--><div class=col-sm-3 ng-if=main.filters.sortStyle.visible><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-sort-asc\"></i>{{ \'FILTER_SORT_ORDER\' | translate }}</label><select ng-disabled=!main.filters.sortStyle.enabled class=full-width data-init-plugin=select2 ng-model=main.filters.sortStyle.value><option value={{optionObj.value}} ng-repeat=\"optionObj in main.filters.sortStyle.options\">{{ optionObj.label }}</option></select></div></div><div class=clearfix></div><!--USERNAME FILTER--><div class=col-sm-3 ng-if=main.filters.username.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-user\"></i>{{ \'FILTER_USERNAME\' | translate }}</label><input ng-disabled=!main.filters.username.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.username.value placeholder=\"Separate with comma (,)\"></div></div><!--EMAIL FILTER--><div class=col-sm-3 ng-if=main.filters.email.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-envelope\"></i>{{ \'FILTER_EMAIL\' | translate }}</label><input ng-disabled=!main.filters.email.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.email.value placeholder=\"Separate with comma (,)\"></div></div><!--BET FILTER--><div class=col-sm-3 ng-if=main.filters.bet.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-database\"></i>{{ \'FILTER_BET\' | translate }}</label><input ng-disabled=!main.filters.bet.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.bet.value placeholder=\"like: >500 or <1000\"></div></div><!--WIN FILTER--><div class=col-sm-3 ng-if=main.filters.win.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-dollar\"></i>{{ \'FILTER_WIN\' | translate }}</label><input ng-disabled=!main.filters.win.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.win.value placeholder=\"like: >500 or =750\"></div></div><!--PROFIT FILTER--><div class=col-sm-3 ng-if=main.filters.profit.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-check-square\"></i>{{ \'FILTER_PROFIT\' | translate }}</label><input ng-disabled=!main.filters.profit.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.profit.value placeholder=\"like: =500 or <100\"></div></div><!--CON_ID FILTER--><div class=col-sm-3 ng-if=main.filters.con_id.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-check-square\"></i>{{ \'FILTER_CON_ID\' | translate }}</label><input ng-disabled=!main.filters.con_id.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.con_id.value placeholder=\"Enter connection id\"></div></div><!--PLAYER_ID FILTER--><div class=col-sm-3 ng-if=main.filters.player_id.visible><div form-group class=\"form-group form-group-default\"><label><i class=\"fa fa-check-square\"></i>{{ \'FILTER_PLAYER_ID\' | translate }}</label><input ng-disabled=!main.filters.player_id.enabled class=\"form-control date-picker\" type=text ng-model=main.filters.player_id.value placeholder=\"Enter player id\"></div></div><div class=clearfix></div><!--APPLY SEARCH--><div class=\"col-sm-2 pull-right filters-action-btns\"><button type=button ng-click=main.accountingExcelExport() class=\"btn btn-success btn-sm m-r-5\" ng-disabled=\"main.exportLoadingState.indexOf(\'overview\') > -1\" ng-if=\"main.cookieName === \'REPORT_TURNOVER\'\"><i class=\"fa fa-file-excel\" ng-class=\"{\'fa-spinner\': main.exportLoadingState.indexOf(\'overview\') > -1}\"></i></button> <button type=button class=\"btn btn-info full-width\" ng-click=main.filters.applyFilter() ng-disabled=main.loading><span class=\"p-t-5 p-b-5\"><i class=\"fa fa-15\" ng-class=\"{\'fa-spinner\': main.loading, \'fa-search\': !main.loading}\"></i></span><br><span class=\"fs-11 font-montserrat text-uppercase\">{{ \'FILTER_SEARCH_BTN\' | translate }}</span></button></div><!--<div class=\"clearfix\"></div>--></div></form></div></div>");
$templateCache.put("app/views/partials/footer.html","<!-- START FOOTER --><div class=\"container-fluid container-fixed-lg footer\"><div class=\"copyright sm-text-center\"><p class=\"small no-margin pull-left sm-pull-reset\"><span class=hint-text>{{ \'FOOTER_COPYRIGHT\' | translate:\'{year:2020}\'}}</span> <span class=font-montserrat>{{ \'FOOTER_SPINMATIC_ENTERTAINMENT\' | translate }}</span>. <span class=hint-text>{{ \'FOOTER_ALL_RIGHTS_RESERVER\' | translate }}</span></p><p class=\"small no-margin pull-right sm-pull-reset\"><a href=https://www.spinmatic.com>{{ \'FOOTER_HAND_CRAFTED\' | translate }}</a> <span class=hint-text>&amp; {{ \'FOOTER_MADE_WITH_LOVE\' | translate:\"{version:\'1.4.86 121120211711+3\'}\" }}</span></p><div class=clearfix></div></div></div><!-- END FOOTER -->");
$templateCache.put("app/views/partials/header.html","<!-- START HEADER --><div class=header><!-- START MOBILE CONTROLS --><!-- LEFT SIDE --><div class=\"pull-left full-height visible-sm visible-xs\"><!-- START ACTION BAR --><div class=sm-action-bar><a href=\"\" class=\"btn-link toggle-sidebar\" data-toggle=sidebar><span class=\"icon-set fa fa-bars\"></span></a></div><!-- END ACTION BAR --></div><!-- END MOBILE CONTROLS --><div style=\"padding-left: 20px\"><div class=\"brand inline\"><img src=assets/img/logo.png alt=logo data-src=assets/img/logo.png data-src-retina=assets/img/logo_2x.png></div></div><div class=\"d-flex align-items-center\"><a data-toggle=quickview data-toggle-element=#quickview><div class=\"pull-left p-r-10 fs-14 font-heading hidden-md-down\"><span class=bold>{{main._user.firstname}} {{main._user.lastname}}</span> <span ng-if=\"(main._selectedUser.id != main._user.id)\" class=\"block text-master hint-text fs-12 text-center\"><i class=\"fa fa-user\"></i> {{main._selectedUser.username}}</span></div></a><a style=\"vertical-align: middle\" class=\"header-icon pg pg-alt_menu btn-link m-l-10 sm-no-margin d-inline-block\" ng-click=main.toggleRightBar();></a></div><!-- END HEADER --></div>");
$templateCache.put("app/views/partials/navigator.html","<!-- START JUMBOTRON --><div class=jumbotron data-pages=parallax><div class=\"container-fluid container-fixed-lg sm-p-l-0 sm-p-r-0\"><div class=inner><!--<tabs data=\"main.tabData\" type=\"pills\" template-url=\"ui-router-tabs-custom-ui-view-template.html\"></tabs>--></div></div></div><!-- END JUMBOTRON -->");
$templateCache.put("app/views/partials/quick-search.html","<!--&lt;!&ndash; START OVERLAY &ndash;&gt;--><!--<div ng-controller=\"SearchCtrl\" class=\"overlay\" style=\"display: none\" pg-search>--><!--&lt;!&ndash; BEGIN Overlay Content !&ndash;&gt;--><!--<div class=\"overlay-content has-results m-t-20\">--><!--&lt;!&ndash; BEGIN Overlay Header !&ndash;&gt;--><!--<div class=\"container-fluid\">--><!--&lt;!&ndash; BEGIN Overlay Logo !&ndash;&gt;--><!--<img class=\"overlay-brand\" src=\"assets/img/logo.png\" alt=\"logo\" data-src=\"assets/img/logo.png\" ui-jq=\"unveil\" data-src-retina=\"assets/img/logo_2x.png\" width=\"78\" height=\"22\">--><!--&lt;!&ndash; END Overlay Logo !&ndash;&gt;--><!--&lt;!&ndash; BEGIN Overlay Close !&ndash;&gt;--><!--<a href=\"\" class=\"close-icon-light overlay-close text-black fs-16\" data-search=\"closeButton\">--><!--<i class=\"pg-close\"></i>--><!--</a>--><!--&lt;!&ndash; END Overlay Close !&ndash;&gt;--><!--</div>--><!--&lt;!&ndash; END Overlay Header !&ndash;&gt;--><!--<div class=\"container-fluid\">--><!--&lt;!&ndash; BEGIN Overlay Controls !&ndash;&gt;--><!--<input data-search=\"searchField\" id=\"overlay-search\" class=\"no-border overlay-search bg-transparent\" placeholder=\"Search...\" autocomplete=\"off\" spellcheck=\"false\" ng-model=\"search.query\" ng-change=\"liveSearch()\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { default: 500, blur: 0 } }\">--><!--<br>--><!--<div class=\"inline-block\">--><!--<div class=\"checkbox right\">--><!--<input id=\"checkboxn\" type=\"checkbox\" value=\"1\" checked=\"checked\">--><!--<label for=\"checkboxn\"><i class=\"fa fa-search\"></i> Search within page</label>--><!--</div>--><!--</div>--><!--<div class=\"inline-block m-l-10\">--><!--<p class=\"fs-13\">Press enter to search</p>--><!--</div>--><!--&lt;!&ndash; END Overlay Controls !&ndash;&gt;--><!--</div>--><!--&lt;!&ndash; BEGIN Overlay Search Results, This part is for demo purpose, you can add anything you like !&ndash;&gt;--><!--<div class=\"container-fluid\">--><!--<span>--><!--<strong>suggestions :</strong>--><!--</span>--><!--<span id=\"overlay-suggestions\">{{search.query}}</span>--><!--<br>--><!--<div class=\"search-results m-t-40\">--><!--<p class=\"bold\">Pages Search Results</p>--><!--<div class=\"row\">--><!--<div class=\"col-md-6\">--><!--&lt;!&ndash; BEGIN Search Result Item !&ndash;&gt;--><!--<div class=\"\">--><!--&lt;!&ndash; BEGIN Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"thumbnail-wrapper d48 circular bg-success text-white inline m-t-10\">--><!--<div>--><!--<img width=\"50\" height=\"50\" src=\"assets/img/profiles/avatar.jpg\" data-src=\"assets/img/profiles/avatar.jpg\" ui-jq=\"unveil\" data-src-retina=\"assets/img/profiles/avatar2x.jpg\" alt=\"\">--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"p-l-10 inline p-t-5\">--><!--<h5 class=\"m-b-5\"><span class=\"semi-bold result-name\">{{search.query}}</span> on pages</h5>--><!--<p class=\"hint-text\">via john smith</p>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item !&ndash;&gt;--><!--&lt;!&ndash; BEGIN Search Result Item !&ndash;&gt;--><!--<div class=\"\">--><!--&lt;!&ndash; BEGIN Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"thumbnail-wrapper d48 circular bg-success text-white inline m-t-10\">--><!--<div>T</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"p-l-10 inline p-t-5\">--><!--<h5 class=\"m-b-5\"><span class=\"semi-bold result-name\">{{search.query}}</span> related topics</h5>--><!--<p class=\"hint-text\">via pages</p>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item !&ndash;&gt;--><!--&lt;!&ndash; BEGIN Search Result Item !&ndash;&gt;--><!--<div class=\"\">--><!--&lt;!&ndash; BEGIN Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"thumbnail-wrapper d48 circular bg-success text-white inline m-t-10\">--><!--<div><i class=\"fa fa-headphones large-text \"></i>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"p-l-10 inline p-t-5\">--><!--<h5 class=\"m-b-5\"><span class=\"semi-bold result-name\">{{search.query}}</span> music</h5>--><!--<p class=\"hint-text\">via pagesmix</p>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item !&ndash;&gt;--><!--</div>--><!--<div class=\"col-md-6\">--><!--&lt;!&ndash; BEGIN Search Result Item !&ndash;&gt;--><!--<div class=\"\">--><!--&lt;!&ndash; BEGIN Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"thumbnail-wrapper d48 circular bg-info text-white inline m-t-10\">--><!--<div><i class=\"fa fa-facebook large-text \"></i>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"p-l-10 inline p-t-5\">--><!--<h5 class=\"m-b-5\"><span class=\"semi-bold result-name\">{{search.query}}</span> on facebook</h5>--><!--<p class=\"hint-text\">via facebook</p>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item !&ndash;&gt;--><!--&lt;!&ndash; BEGIN Search Result Item !&ndash;&gt;--><!--<div class=\"\">--><!--&lt;!&ndash; BEGIN Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"thumbnail-wrapper d48 circular bg-complete text-white inline m-t-10\">--><!--<div><i class=\"fa fa-twitter large-text \"></i>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"p-l-10 inline p-t-5\">--><!--<h5 class=\"m-b-5\">Tweats on<span class=\"semi-bold result-name\">{{search.query}}</span></h5>--><!--<p class=\"hint-text\">via twitter</p>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item !&ndash;&gt;--><!--&lt;!&ndash; BEGIN Search Result Item !&ndash;&gt;--><!--<div class=\"\">--><!--&lt;!&ndash; BEGIN Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"thumbnail-wrapper d48 circular text-white bg-danger inline m-t-10\">--><!--<div><i class=\"fa fa-google-plus large-text \"></i>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item Thumbnail !&ndash;&gt;--><!--<div class=\"p-l-10 inline p-t-5\">--><!--<h5 class=\"m-b-5\">Circles on<span class=\"semi-bold result-name\">{{search.query}}</span></h5>--><!--<p class=\"hint-text\">via google plus</p>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Search Result Item !&ndash;&gt;--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--&lt;!&ndash; END Overlay Search Results !&ndash;&gt;--><!--</div>--><!--&lt;!&ndash; END Overlay Content !&ndash;&gt;--><!--</div>--> <!--&lt;!&ndash; END OVERLAY &ndash;&gt;-->");
$templateCache.put("app/views/partials/right-accounts-tab-container.html","<div class=\"view bg-white\"><!-- BEGIN View Header !--><div class=\"navbar navbar-default\"><div class=navbar-inner><a data-toggle-element=#quickview data-toggle=quickview><div class=view-heading><div class=fs-11>{{ \'TABS_ACCOUNTS_LOGGED_AS\' | translate:main._selectedUser }}</div></div><a ng-if=\"(main._selectedUser.id != main._user.id)\" ng-click=\"main.pickAccount(0); main.toggleRightBar();\" class=\"link text-master inline action p-r-10 pull-right\"><i class=\"pg pg-power inline action p-r-10 pull-right link text-master\"></i></a></a></div></div><!-- END View Header !--><div right-accounts-tab-list></div></div>");
$templateCache.put("app/views/partials/right-accounts-tab-list.html","<div data-init-list-view=ioslist class=\"list-view pickBorered no-top-border\"><div ng-if=!main._selectedUser.subAccCount class=text-center><h3>{{ \'TABS_ACCOUNTS_NOT_FOUND\' | translate }}</h3></div><div ng-if=main._selectedUser.subAccCount class=list-view-group-container><!--        <div class=\"list-view-group-header text-uppercase checkbox check-primary\">--><!--            <input type=\"checkbox\" id=\"checkAllUsers\" ng-model=\"main.checkAllUsers\" ng-click=\"main.toggleCheckAllUsers();\">--><!--            <label for=\"checkAllUsers\">{{ \'TABS_ACCOUNTS_HEADER\' | translate }}</label>--><!--        </div>--><ul><!-- BEGIN Chat User List Item  !--><li class=\"chat-user-list clearfix\" ng-repeat=\"user in main._selectedUser.subAccs\"><!--                <div class=\"checkbox check-primary\">--><!--                    <input type=\"checkbox\" value=\"1\" id=\"check_{{user.id}}\" ng-model=\"user.isChecked\" ng-click=\"main.countSelectedAccs();\">--><!--                    <label for=\"check_{{user.id}}\"></label>--><!--                </div>--> <a ng-click=main.pickAccount(user);><p class=\"p-l-10 col-xs-height col-middle col-xs-12\"><span class=text-master>{{user.username}}</span> <span ng-if=\"user.subAccCount > 0\" class=\"block text-master hint-text fs-12\">{{ \'TABS_ACCOUNTS_SUB_ACCOUNT_COUNT\' | translate:user }}</span></p><i ng-if=\"user.subAccCount > 0\" class=\"pg-arrow_right inline action p-r-10 pull-right link text-master\"></i></a></li><!-- END Chat User List Item  !--></ul></div></div>");
$templateCache.put("app/views/partials/right-accounts-tab.html","<div class=\"tab-pane fade in no-padding\" id=quickview-chat ng-class=\"{\'active\': (main._selectedRightTab == \'accounts\')}\"><div class=\"view-port clearfix\" id=accounts><div right-accounts-tab-container></div></div></div>");
$templateCache.put("app/views/partials/right-bar.html","<!--START QUICKVIEW --><div id=quickview class=quickview-wrapper ng-class=\"{\'open\': main.isRightbarOpened}\" data-pages=quickview><!-- Nav tabs --><ul class=\"nav nav-tabs\"><li ng-class=\"{\'active\': (main._selectedRightTab == \'settings\')}\"><a data-toggle=tab ng-click=\"main._selectedRightTab = \'settings\'\">{{ \'TABS_SETTINGS_TITLE\' | translate }}</a></li><li ng-class=\"{\'active\': (main._selectedRightTab == \'profile\')}\"><a data-toggle=tab ng-click=\"main._selectedRightTab = \'profile\'\">{{ \'TABS_PROFILE_TITLE\' | translate }}</a></li><li ng-class=\"{\'active\': (main._selectedRightTab == \'accounts\')}\"><a data-toggle=tab ng-click=\"main._selectedRightTab = \'accounts\'\">{{ \'TABS_ACCOUNTS_TITLE\' | translate }}</a></li></ul><a class=\"btn-link quickview-toggle\" ng-click=main.toggleRightBar();><i class=pg-close></i></a><!-- Tab panes --><div class=tab-content><div right-settings-tab></div><div right-profile-tab></div><div right-accounts-tab></div></div></div><!-- END QUICKVIEW-->");
$templateCache.put("app/views/partials/right-profile-tab.html","<div class=\"tab-pane fade in no-padding\" id=quickview-profile ng-class=\"{\'active\': (main._selectedRightTab == \'profile\')}\"><div class=\"view-port clearfix\" id=profile><!-- BEGIN View Header !--><div class=\"navbar navbar-default\"><div class=navbar-inner><a data-toggle-element=#quickview data-toggle=quickview><div class=view-heading><div class=fs-11>{{main._user.firstname}} {{main._user.lastname}}</div>#{{main._user.id}} - {{main._user.username}}</div></a><a ng-click=main.doLogout() class=\"link text-master inline action p-r-10 pull-right\"><i class=\"pg pg-power inline action p-r-10 pull-right link text-master\"></i></a></div></div><!-- END View Header !--><div ui-jq=ioslist class=\"list-view boreded no-top-border\"><!-- BEGIN List Group !--><div class=list-view-group-container><!-- BEGIN List Group Header!--><div class=\"list-view-group-header text-uppercase\">{{ \'TABS_PROFILE_HEADER\' | translate }}</div><div class=\"col-md-12 m-t-10\"><div form-group class=\"form-group form-group-default disabled\"><label>{{ \'TABS_PROFILE_EMAIL\' | translate }}</label><input type=email class=form-control value={{main._user.email}} disabled></div><div class=\"form-group form-group-default required\"><label>{{ \'TABS_PROFILE_CURRENT_PASSWORD\' | translate }}</label><input type=password ng-model=main.changePassword.current class=form-control required></div><div ng-if=main.changePassword.current.length class=\"form-group form-group-default required\"><label>{{ \'TABS_PROFILE_NEW_PASSWORD\' | translate }}</label><input type=password ng-model=main.changePassword.new class=form-control required></div><div ng-if=main.changePassword.new.length class=\"form-group form-group-default required\"><label>{{ \'TABS_PROFILE_RE_NEW_PASSWORD\' | translate }}</label><input type=password ng-model=main.changePassword.reNew class=form-control required></div><button ng-if=main.changePassword.reNew.length ng-click=main.doChangePassword() class=\"btn btn-primary btn-cons m-b-10 pull-right\" type=button><span class=lighter>{{ \'TABS_PROFILE_CHANGE_PASSWORD_BTN\' | translate }}</span></button></div></div><!-- END List Group !--><div class=list-view-group-container><!-- BEGIN List Group Header!--><div class=\"list-view-group-header text-uppercase\">{{ \'TABS_PROFILE_MY_PLATFORMS_HEADER\' | translate }}</div><!-- END List Group Header!--><ul><!-- BEGIN List Group Item!--><li class=alert-list ng-repeat=\"(siteId, platform) in main._user.sites track by $index\"><!-- BEGIN Alert Item Set Animation using data-view-animation !--> <a class=\"p-t-10 p-b-10\"><p class=\"col-xs-height col-middle\"><span class=\"text-complete fs-10\"><i class=\"fa fa-circle\"></i></span></p><p class=\"p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12\"><span class=\"text-master link\">#{{siteId}}<br></span><span class=text-master>{{platform.domain}}</span></p></a><!-- END Alert Item!--></li><!-- END List Group Item!--></ul></div><div class=list-view-group-container><!-- BEGIN List Group Header!--><div class=\"list-view-group-header text-uppercase\">{{ \'TABS_PROFILE_LAST_ACTIVITIES_HEADER\' | translate }}</div><!-- END List Group Header!--><ul><!-- BEGIN List Group Item!--><li class=alert-list ng-repeat=\"activity in main._user.lastLogins\"><!-- BEGIN Alert Item Set Animation using data-view-animation !--> <a class=\"p-t-10 p-b-10\"><p class=\"col-xs-height col-middle\"><span class=\"text-danger fs-10\"><i class=\"fa fa-circle\"></i></span></p><p class=\"p-l-10 col-xs-height col-middle col-xs-12 overflow-ellipsis fs-12\"><span class=\"text-master link\">{{activity.date}}<br></span><span class=text-master>{{activity.ip}}</span></p></a><!-- END Alert Item!--></li><!-- END List Group Item!--></ul></div><!-- END List Group !--></div></div></div>");
$templateCache.put("app/views/partials/right-settings-tab.html","<div class=\"tab-pane builder\" ng-class=\"{\'active\': (main._selectedRightTab == \'settings\')}\" id=tabLayouts><div class=\"scrollable full-height\"><div class=\"p-l-10 p-r-50\"><h5 class=semi-bold>{{ \'TABS_SETTINGS_HEADER\' | translate }}</h5><div class=\"row p-b-35\"><div class=col-xs-6><a class=\"btn-toggle-layout fs-12\" ng-class=\"{\'active\':_userSettings.body == \'default\'}\" ng-click=\"main.setUserSettings(\'body\', \'default\');\"><img alt=\"Menu divided icon\" class=m-b-15 src=assets/img/menu_divided_con.png width=126 height=95> <span class=\"text-dark m-t-5\">{{ \'TABS_SETTINGS_QUICK_MENU_DEFAULT_LAYOUT\' | translate }}</span></a></div><div class=col-xs-6><a class=\"btn-toggle-layout fs-12\" ng-class=\"{\'active\':_userSettings.body == \'menuBelow\'}\" ng-click=\"main.setUserSettings(\'body\', \'menuBelow\');\"><img alt=\"Full header icon\" class=m-b-15 src=assets/img/full_header_con.png width=126 height=95> <span class=\"text-dark m-t-5\">{{ \'TABS_SETTINGS_QUICK_MENU_CONDENSED_LAYOUT\' | translate }}</span></a></div></div><div class=\"row p-b-10\"><div class=col-xs-6><a class=\"btn-toggle-layout fs-12\" ng-class=\"{\'active\':_userSettings.body == \'menuPinned\'}\" ng-click=\"main.setUserSettings(\'body\', \'menuPinned\');\"><img alt=\"Menu divided\" class=m-b-15 src=assets/img/menu_divided.png width=126 height=95> <span class=\"text-dark m-t-5\">{{ \'TABS_SETTINGS_FIXED_QUICK_MENU_DEFAULT_LAYOUT\' | translate }}</span></a></div><div class=col-xs-6><a class=\"btn-toggle-layout fs-12\" ng-class=\"{\'active\':_userSettings.body == \'menuPinnedBelow\'}\" ng-click=\"main.setUserSettings(\'body\', \'menuPinnedBelow\');\"><img alt=\"Full header\" class=m-b-15 src=assets/img/full_header.png width=126 height=95> <span class=\"text-dark m-t-5\">{{ \'TABS_SETTINGS_PINNED_QUICK_MENU_DEFAULT_LAYOUT\' | translate }}</span></a></div></div></div><!--<div class=\"p-l-10 p-r-50\">--><!--<h5 class=\"semi-bold\">--><!--Color Options--><!--</h5>--><!--<a href=\"\" class=\"btn-toggle-theme b-a b-grey theme-selector m-b-30\" ng-class=\"{\'active\':_userSettings.theme == \'default\'}\" ng-click=\"main.setUserSettings(\'theme\', \'default\');\">--><!--<img alt=\"Theme default\" src=\"assets/img/theme_default.png\" class=\"image-responsive-height\">--><!--<div class=\"p-l-15 p-r-20 p-b-10 p-t-10\">--><!--<p class=\"no-margin\">--><!--<span class=\"block font-montserrat text-uppercase fs-12 bold\">Default</span>--><!--<span class=\"fs-11\">pages default color palette</span>--><!--</p>--><!--</div>--><!--</a>--><!--<a href=\"\" class=\"btn-toggle-theme b-a b-grey theme-selector m-b-30\" ng-class=\"{\'active\':_userSettings.theme == \'corporate\'}\" ng-click=\"main.setUserSettings(\'theme\', \'corporate\');\">--><!--<img alt=\"Theme corporate\" src=\"assets/img/theme_corporate.png\" class=\"image-responsive-height\">--><!--<div class=\"p-l-15 p-r-20 p-b-10 p-t-10\">--><!--<p class=\"no-margin\">--><!--<span class=\"block font-montserrat text-uppercase fs-12 bold\">Corporate</span>--><!--<span class=\"fs-11\">give your an a profesional look</span>--><!--</p>--><!--</div>--><!--</a>--><!--<a href=\"\" class=\"btn-toggle-theme b-a b-grey theme-selector m-b-30\" ng-class=\"{\'active\':_userSettings.theme == \'retro\'}\" ng-click=\"main.setUserSettings(\'theme\', \'retro\');\">--><!--<img alt=\"Theme retro\" src=\"assets/img/theme_retro.png\" class=\"image-responsive-height\">--><!--<div class=\"p-l-15 p-r-20 p-b-10 p-t-10\">--><!--<p class=\"no-margin\">--><!--<span class=\"block font-montserrat text-uppercase fs-12 bold\">Retro</span>--><!--<span class=\"fs-11\">calm color palette</span>--><!--</p>--><!--</div>--><!--</a>--><!--<a href=\"\" class=\"btn-toggle-theme b-a b-grey theme-selector m-b-30\" ng-class=\"{\'active\':_userSettings.theme == \'unlax\'}\" ng-click=\"main.setUserSettings(\'theme\', \'unlax\');\">--><!--<img alt=\"Theme unlax\" src=\"assets/img/theme_unlax.png\" class=\"image-responsive-height\">--><!--<div class=\"p-l-15 p-r-20 p-b-10 p-t-10\">--><!--<p class=\"no-margin\">--><!--<span class=\"block font-montserrat text-uppercase fs-12 bold\">Unlax</span>--><!--<span class=\"fs-11\">calm color palette</span>--><!--</p>--><!--</div>--><!--</a>--><!--<a href=\"\" class=\"btn-toggle-theme b-a b-grey theme-selector m-b-30\" ng-class=\"{\'active\':_userSettings.theme == \'vibes\'}\" ng-click=\"main.setUserSettings(\'theme\', \'vibes\');\">--><!--<img alt=\"Thmeme vibes\" src=\"assets/img/theme_vibes.png\" class=\"image-responsive-height\">--><!--<div class=\"p-l-15 p-r-20 p-b-10 p-t-10\">--><!--<p class=\"no-margin\">--><!--<span class=\"block font-montserrat text-uppercase fs-12 bold\">Vibes</span>--><!--<span class=\"fs-11\">calm color palette</span>--><!--</p>--><!--</div>--><!--</a>--><!--<a href=\"\" class=\"btn-toggle-theme b-a b-grey theme-selector m-b-30\" ng-class=\"{\'active\':_userSettings.theme == \'abstract\'}\" ng-click=\"main.setUserSettings(\'theme\', \'abstract\');\">--><!--<img alt=\"Theme abstract\" src=\"assets/img/theme_abstract.png\" class=\"image-responsive-height\">--><!--<div class=\"p-l-15 p-r-20 p-b-10 p-t-10\">--><!--<p class=\"no-margin\">--><!--<span class=\"block font-montserrat text-uppercase fs-12 bold\">Abstract</span>--><!--<span class=\"fs-11\">calm color palette</span>--><!--</p>--><!--</div>--><!--</a>--><!--</div>--></div></div>");
$templateCache.put("app/views/partials/session-history-report-session.html","<table class=\"table table-hover table-condensed table-detailed\" id=turnoverTable ui-jq=dataTable ui-options=options><thead><tr><th ng-repeat=\"column in sessionReport.columnOptions[sessionReport.filterOptions.viewAs]\" ng-show=column.active>{{column.columnName}}</th><th>#</th></tr></thead><tbody><tr ng-repeat=\"session in sessionReport.listView track by $index \"><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][0].active class=\"v-align-middle semi-bold\">{{session.con_id}}</td><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][1].active class=\"v-align-middle semi-bold\">{{main._user.games[session.game_id].name}}</td><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][2].active class=\"v-align-middle semi-bold\">{{session.player.username}}</td><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][3].active class=v-align-middle>{{session.bet | currencyFix:player.currency}}</td><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][4].active class=v-align-middle>{{session.win | currencyFix:player.currency}}</td><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][5].active class=v-align-middle>{{session.fpp | currencyFix:player.currency}}</td><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][6].active class=v-align-middle>{{session.jackpot | currencyFix:player.currency}}</td><td ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][7].active class=v-align-middle ng-bind-html=\"player.profit | currencyFix:player.currency:true\"></td><td class=v-align-middle><button ui-sref=\"management.report.sessionRounds({conId: session.con_id, playerId: session.player_id})\" class=\"btn btn-info btn-cons\" type=button><i class=\"fa fa-search\"></i> <span class=bold>Details</span></button></td></tr></tbody><tfoot class=bg-info-lighter><tr><th class=p-l-20>TOTAL</th><th class=p-l-20 ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][1].active></th><th class=p-l-20 ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][2].active></th><th class=p-l-20 ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][3].active>{{sessionReport.data.totals.bet | currencyFix:main._user.currency}}</th><th class=p-l-20 ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][4].active>{{sessionReport.data.totals.win | currencyFix:main._user.currency}}</th><th class=p-l-20 ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][5].active>{{sessionReport.data.totals.fpp | currencyFix:main._user.currency}}</th><th class=p-l-20 ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][6].active>{{sessionReport.data.totals.jackpot | currencyFix:main._user.currency}}</th><th class=p-l-20 ng-show=sessionReport.columnOptions[sessionReport.filterOptions.viewAs][7].active ng-bind-html=\"sessionReport.data.totals.profit | currencyFix:main._user.currency:true\"></th><th class=p-l-20></th></tr></tfoot></table>");
$templateCache.put("app/views/partials/sidebar.html","<!-- BEGIN SIDEBAR --><div class=page-sidebar data-pages=sidebar sidebar ng-show=\"main._user.account_type==0\"><div id=appMenu class=\"sidebar-overlay-slide from-top\"></div><!-- BEGIN SIDEBAR HEADER --><div class=sidebar-header><img src=assets/img/spinmatic_white.png alt=logo class=brand data-src=assets/img/spinmatic_white.png ui-jq=unveil data-src-retina=assets/img/spinmatic_white.png><!--<div class=\"sidebar-header-controls\">--><!--<button type=\"button\" class=\"btn btn-xs sidebar-slide-toggle btn-link m-l-20\" data-pages-toggle=\"#appMenu\"><i class=\"fa fa-angle-down fs-16\"></i>--><!--</button>--><!--<button type=\"button\" class=\"btn btn-link visible-lg-inline\" data-toggle-pin=\"sidebar\"><i class=\"fa fs-12\"></i>--><!--</button>--><!--</div>--></div><!-- END SIDEBAR HEADER --><!-- BEGIN SIDEBAR MENU --><div class=sidebar-menu><script type=text/ng-template id=sidebar-item.html><a ng-if=\"!sideItem.subLinks\" ui-sref=\"{{ sideItem.uiSref }}\" class=\"detailed\">\n                <span class=\"title\">{{ sideItem.title | translate }}</span>\n                <span class=\"details\" data-ng-bind-html=\"sideItem.desc | translate | htmlSafe\"></span>\n            </a>\n\n            <a href=\"javascript:;\" ng-if=\"sideItem.subLinks\">\n                <span class=\"title\">{{ sideItem.title | translate }}</span>\n                <span class=\" arrow\"></span>\n            </a>\n\n            <span class=\"icon-thumbnail\"><i class=\"{{ sideItem.iconClass }}\"></i></span>\n\n            <ul ng-if=\"sideItem.subLinks\" class=\"sub-menu\">\n                <li ng-repeat=\"sideItem in sideItem.subLinks\" ui-sref-active=\"active\" ng-include=\"\'sidebar-item.html\'\"></li>\n            </ul></script><ul class=menu-items><li ng-repeat=\"sideItem in main._menu\" class=\"{{ sideItem.class }}\" ui-sref-active=active ng-include=\"\'sidebar-item.html\'\"></li></ul><div class=clearfix></div></div><!-- END SIDEBAR MENU --></div><!-- END SIDEBAR -->");
$templateCache.put("app/views/players/create.html","<div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'PLAYERS_CREATE_DESC\' | translate | htmlSafe\"></p><p><button type=button class=\"btn btn-info btn-xs\" ng-click=players.goBack()><i class=\"fa fa-backward\"></i></button></p></div></div><div class=panel-body><div class=row><div class=col-md-6><div class=form-group><label for=firstname>{{ \'PLAYERS_CREATE_FORM_FIRSTNAME\' | translate }}</label><input id=firstname class=form-control type=text ng-model=playersCreate.player.firstname></div><div class=form-group><label for=lastname>{{ \'PLAYERS_CREATE_FORM_LASTNAME\' | translate }}</label><input id=lastname class=form-control type=text ng-model=playersCreate.player.lastname></div><div class=form-group><label for=username>{{ \'PLAYERS_CREATE_FORM_USERNAME\' | translate }}</label><input id=username class=form-control type=text ng-model=playersCreate.player.username></div><div class=form-group><label for=email>{{ \'PLAYERS_CREATE_FORM_EMAIL\' | translate }}</label><input id=email class=form-control type=email ng-model=playersCreate.player.email></div><div class=form-group><label for=externalId>{{ \'PLAYERS_CREATE_FORM_EXTERNAL_ID\' | translate }}</label><input id=externalId class=form-control type=text ng-model=playersCreate.player.external_id></div><div class=form-group><label for=status>{{ \'PLAYERS_CREATE_FORM_STATUS\' | translate }}</label><input id=status type=checkbox class=js-switch ui-switch ng-model=playersCreate.player.status></div></div><div class=col-md-6><div class=form-group><label for=language>{{ \'PLAYERS_CREATE_FORM_LANGUAGE\' | translate }}</label><select id=language class=form-control ng-model=playersCreate.player.language><option value=\"{{ item.name }}\" ng-repeat=\"item in playersCreate.languages\">{{ item.description }}</option></select></div><div class=form-group><label for=country>{{ \'PLAYERS_CREATE_FORM_COUNTRY\' | translate }}</label><select id=country class=form-control ng-model=playersCreate.player.country><option value=\"{{ item.name }}\" ng-repeat=\"item in playersCreate.countries\">{{ item.description }}</option></select></div><div class=form-group><label for=site>{{ \'PLAYERS_CREATE_FORM_SITE\' | translate }}</label><select id=site class=form-control ng-model=playersCreate.player.site_id disabled><option value=\"{{ item.id }}\" ng-repeat=\"item in playersCreate.sites\">{{ item.domain }}</option></select></div><div class=form-group><label for=owner>{{ \'PLAYERS_CREATE_FORM_OWNER\' | translate }}</label><select id=owner class=form-control ng-model=playersCreate.player.owner_id ng-change=playersCreate.ownerChanged()><option value=\"{{ item.id }}\" ng-repeat=\"item in playersCreate.owners\">{{ item.username }}</option></select></div><div class=form-group><label for=password>{{ \'PLAYERS_CREATE_FORM_PASSWORD\' | translate }}</label><input id=password class=form-control type=password ng-model=playersCreate.player.password></div><div class=form-group><label for=passwordCompare>{{ \'PLAYERS_CREATE_FORM_PASSWORD_COMPARE\' | translate }}</label><input id=passwordCompare class=form-control type=password ng-model=playersCreate.player.passwordCompare></div></div><div class=clearfix></div><button class=\"btn btn-info pull-right\" ng-click=playersCreate.savePlayer()>{{ \'PLAYERS_CREATE_FORM_SUBMIT_BTN\' | translate }}</button></div></div></div>");
$templateCache.put("app/views/players/edit.html","<div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'PLAYERS_EDIT_DESC\' | translate | htmlSafe\"></p><p><button type=button class=\"btn btn-info btn-xs\" ng-click=players.goBack()><i class=\"fa fa-backward\"></i></button></p></div></div><div class=panel-body><div class=row><div class=col-md-6><div class=form-group><label for=firstname>{{ \'PLAYERS_EDIT_FORM_FIRSTNAME\' | translate }}</label><input id=firstname class=form-control type=text ng-model=playersEdit.player.firstname></div><div class=form-group><label for=lastname>{{ \'PLAYERS_EDIT_FORM_LASTNAME\' | translate }}</label><input id=lastname class=form-control type=text ng-model=playersEdit.player.lastname></div><div class=form-group><label for=username>{{ \'PLAYERS_EDIT_FORM_USERNAME\' | translate }}</label><input id=username class=form-control type=text ng-model=playersEdit.player.username></div><div class=form-group><label for=email>{{ \'PLAYERS_EDIT_FORM_EMAIL\' | translate }}</label><input id=email class=form-control type=email ng-model=playersEdit.player.email></div><div class=form-group><label for=externalId>{{ \'PLAYERS_EDIT_FORM_EXTERNAL_ID\' | translate }}</label><input id=externalId class=form-control type=text ng-model=playersEdit.player.external_id></div><div class=form-group><label for=status>{{ \'PLAYERS_EDIT_FORM_STATUS\' | translate }}</label><input id=status type=checkbox class=js-switch ui-switch ng-model=playersEdit.player.status ng-checked=\"playersEdit.player.status==true\"></div></div><div class=col-md-6><div class=form-group><label for=language>{{ \'PLAYERS_EDIT_FORM_LANGUAGE\' | translate }}</label><select id=language class=form-control ng-model=playersEdit.player.language><option value=\"{{ item.name }}\" ng-repeat=\"item in playersEdit.languages\">{{ item.description }}</option></select></div><div class=form-group><label for=country>{{ \'PLAYERS_EDIT_FORM_COUNTRY\' | translate }}</label><select id=country class=form-control ng-model=playersEdit.player.country><option value=\"{{ item.name }}\" ng-repeat=\"item in playersEdit.countries\">{{ item.description }}</option></select></div><div class=form-group><label for=site>{{ \'PLAYERS_EDIT_FORM_SITE\' | translate }}</label><select id=site class=form-control ng-model=playersEdit.player.site_id disabled><option value=\"{{ item.id }}\" ng-repeat=\"item in playersEdit.sites\">{{ item.domain }}</option></select></div><div class=form-group><label for=owner>{{ \'PLAYERS_EDIT_FORM_OWNER\' | translate }}</label><select id=owner class=form-control ng-model=playersEdit.player.owner_id ng-change=playersEdit.ownerChanged() disabled><option value=\"{{ item.id }}\" ng-repeat=\"item in playersEdit.owners\">{{ item.username }}</option></select></div><div class=form-group><label for=password>{{ \'PLAYERS_EDIT_FORM_PASSWORD\' | translate }}</label><input id=password class=form-control type=password ng-model=playersEdit.player.password></div><div class=form-group><label for=passwordCompare>{{ \'PLAYERS_EDIT_FORM_PASSWORD_COMPARE\' | translate }}</label><input id=passwordCompare class=form-control type=password ng-model=playersEdit.player.passwordCompare></div></div><div class=clearfix></div><button class=\"btn btn-info pull-right\" ng-click=playersEdit.savePlayer()>{{ \'PLAYERS_EDIT_FORM_SUBMIT_BTN\' | translate }}</button></div></div></div>");
$templateCache.put("app/views/players/list.html","<div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'PLAYERS_LIST_DESC\' | translate | htmlSafe\"></p><p class=pull-right><a ui-sref=management.players.create class=\"btn btn-success btn-xs\"><i class=\"fa fa-plus\"></i></a></p></div></div><div class=panel-body><table class=\"table table-bordered table-responsive\"><tr><th>{{ \'PLAYERS_LIST_COLUMN_USERNAME\' | translate }}</th><th>{{ \'PLAYERS_LIST_COLUMN_FULL_NAME\' | translate }}</th><th>{{ \'PLAYERS_LIST_COLUMN_EMAIL\' | translate }}</th><th>{{ \'PLAYERS_LIST_COLUMN_OWNER\' | translate }}</th><th>{{ \'PLAYERS_LIST_COLUMN_SITE\' | translate }}</th><th>{{ \'PLAYERS_LIST_COLUMN_BALANCE\' | translate }}</th><!--<th>#</th>--></tr><tr ng-repeat=\"player in playersList.list.records\" ng-class=\"{\'danger\':player.status == 0}\"><td>{{ player.username }}</td><td>{{ player.firstName }} {{ player.lastName }}</td><td>{{ player.email }}</td><td>{{ player.owner.username }}</td><td>{{ player.site.domain }}</td><td>{{ player.balance | currencyFix:player.currency }}</td><!--<td>--><!--<a ui-sref=\"management.players.edit({id:player.id})\" class=\"btn btn-info btn-sm\">--><!--<i class=\"fa fa-edit\"></i>--><!--</a>--><!--</td>--></tr></table><span class=\"label label-default\">{{ \'PLAYERS_LIST_RECORDS\' | translate }} : {{ playersList.list.totalResults }}</span> <span class=\"label label-default\">{{ \'PLAYERS_LIST_PAGES\' | translate }} : {{ playersList.list.totalPages }}</span><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"playersList.list.page>1\"><a ui-sref=management.players.list({page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"playersList.list.page>1\"><a ui-sref=management.players.list({page:(playersList.list.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':playersList.list.page==pageNum}\" ng-repeat=\"pageNum in [] | range:playersList.list.start:playersList.list.end\"><a ui-sref=management.players.list({page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"playersList.list.page<playersList.list.totalPages\"><a ui-sref=management.players.list({page:(playersList.list.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"playersList.list.page<playersList.list.totalPages\"><a ui-sref=management.players.list({page:playersList.list.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div></div>");
$templateCache.put("app/views/players/players.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><!--PLAYERS START--><div ui-view></div><!--PLAYERS FINISH--></div><div class=clearfix></div></div></div>");
$templateCache.put("app/views/partner-system/commission-chart.html","<div class=\"card card-transparent flex-row\"><ul class=\"nav nav-tabs nav-tabs-simple nav-tabs-left\" id=tab-3><li ng-repeat=\"(statKey, statType) in partnerSystem.statisticDateRanges\" class=nav-item><a ng-class=\"{\'active\': statType.isSelected}\" ng-click=partnerSystem.changeStats(statKey);>{{statType.title}}</a></li></ul><div class=tab-content><div class=\"tab-pane active\" id=spinStats><div class=row><div class=\"col-lg-4 m-b-10 no-padding-right\"><div class=\"widget-9 card no-border bg-complete-light no-margin widget-loader-bar\"><div class=\"full-height d-flex flex-column\"><div class=card-header><div class=\"card-title text-white\"><span class=\"font-montserrat fs-11 all-caps\">{{ \'DASHBOARD_TOTAL_STATISTICS_TOTAL_BET\' | translate }}</span></div></div><div class=\"card-block text-center\" ng-show=partnerSystem.isStatsLoading><h1 class=\"no-margin p-b-5 text-white\"><i class=\"fa fa-spinner fa-spin\"></i></h1></div><div class=card-block ng-hide=partnerSystem.isStatsLoading><h3 class=\"no-margin p-b-5 text-white\">{{ partnerSystem.totalStatistics.totalBet.amount | currencyFix:main._user.currency }}</h3><span class=\"small hint-text text-white\" ng-if=\"partnerSystem.totalStatistics.totalBet.amount > 0\"><b>Average: </b>{{ (partnerSystem.totalStatistics.totalBet.amount / partnerSystem.totalStatistics.totalBet.count) | currencyFix:main._user.currency }}</span></div></div></div></div><div class=\"col-lg-4 m-b-10 no-padding-right\"><div class=\"widget-9 card no-border bg-danger-light no-margin widget-loader-bar\"><div class=\"full-height d-flex flex-column\"><div class=card-header><div class=\"card-title text-white\"><span class=\"font-montserrat fs-11 all-caps\">{{ \'DASHBOARD_TOTAL_STATISTICS_TOTAL_WIN\' | translate }}</span></div></div><div class=\"card-block text-center\" ng-show=partnerSystem.isStatsLoading><h1 class=\"no-margin p-b-5 text-white\"><i class=\"fa fa-spinner fa-spin\"></i></h1></div><div class=card-block ng-hide=partnerSystem.isStatsLoading><h3 class=\"no-margin p-b-5 text-white\">{{ partnerSystem.totalStatistics.totalWin.amount | currencyFix:main._user.currency }}</h3><span class=\"small hint-text text-white\" ng-if=\"partnerSystem.totalStatistics.totalWin.amount > 0\"><b>Average: </b>{{ (partnerSystem.totalStatistics.totalWin.amount / partnerSystem.totalStatistics.totalWin.count) | currencyFix:main._user.currency }}</span></div></div></div></div><div class=\"col-lg-4 m-b-10 no-padding-right\"><div class=\"widget-9 card no-border bg-white no-margin widget-loader-bar\"><div class=\"full-height d-flex flex-column\"><div class=card-header><div class=\"card-title text-black\"><span class=\"font-montserrat fs-11 all-caps\">{{ \'DASHBOARD_TOTAL_STATISTICS_TOTAL_PROFIT\' | translate }}</span></div></div><div class=\"card-block text-center\" ng-show=partnerSystem.isStatsLoading><h1 class=\"no-margin p-b-5 text-black\"><i class=\"fa fa-spinner fa-spin\"></i></h1></div><div class=card-block ng-hide=partnerSystem.isStatsLoading><h3 class=\"no-margin p-b-5 text-black\"><span ng-class=\"{\'text-danger\':partnerSystem.totalStatistics.totalWin.amount>partnerSystem.totalStatistics.totalBet.amount,\n                                \'text-success\':partnerSystem.totalStatistics.totalBet.amount>partnerSystem.totalStatistics.totalWin.amount}\">{{ partnerSystem.totalStatistics.totalProfit | currencyFix:main._user.currency }}</span></h3><span class=\"small hint-text\" ng-if=\"partnerSystem.totalStatistics.totalBet.count > 0\"><b>Round count :</b>{{partnerSystem.totalStatistics.totalBet.count | numberFix:main._user.currency}}</span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/views/partner-system/news.html","<div class=\"card card-transparent\"><div class=card-header><div class=card-title>{{ \'DASHBOARD_NEWS_TITLE\' | translate }}</div></div><div class=card-block><div class=row><div class=col-md-12 ng-repeat=\"news in partnerSystem.news\" ng-if=\"partnerSystem.news.length>0\"><div class=\"card social-card share share-other\" style=\"width: 100%\"><div class=card-description><p><a href={{news.link}}>{{news.title}}</a></p></div><div class=card-content ng-if=\"news.image != null\"><img alt={{news.title}} ng-src={{news.image}}></div><div class=card-description><div data-ng-bind-html=news.description></div></div><div class=\"card-footer clearfix\"><div class=time><i class=\"fa fa-calendar\"></i> {{news.created_at}}</div></div><div class=\"card-header clearfix last\" ng-if=\"news.link != null\"><a href={{news.link}} target=_blank>{{ \'DASHBOARD_NEWS_READ_MORE\' | translate }}</a></div></div></div><div class=col-md-12 ng-if=\"partnerSystem.news.length==0\"><p>There are no news at the moment</p></div></div></div></div>");
$templateCache.put("app/views/partner-system/partners.html","<div class=\"container-fluid padding-25 sm-padding-10\"><div class=row><div class=col-md-9><div class=row><div class=\"col-md-12 no-padding\"><div ng-include src=\"\'app/views/partner-system/commission-chart.html\'\" include-replace></div></div></div><div class=row><div class=\"col-md-6 no-padding\"><div ng-include src=\"\'app/views/partner-system/payment-history.html\'\" include-replace></div></div><div class=\"col-md-6 no-padding\"><div ng-include src=\"\'app/views/partner-system/top-players.html\'\" include-replace></div></div></div></div><div class=col-md-3><div class=row><div class=\"col-md-12 no-padding\"><div ng-include src=\"\'app/views/partner-system/news.html\'\" include-replace></div></div></div></div></div></div>");
$templateCache.put("app/views/partner-system/payment-history.html","<div class=\"card card-transparent\"><div class=card-header><div class=card-title><div class=row><div class=col-md-12>{{ \'PARTNER_SYSTEM_HISTORY_TITLE\' | translate }}</div><div class=clearfix></div><div class=col-md-6><select data-init-plugin=cs-select ng-model=partnerSystem.selectedYear ng-change=partnerSystem.getInfo()><option ng-repeat=\"year in partnerSystem.years\">{{ year }}</option></select></div><div class=col-md-6><select class=pull-right data-init-plugin=cs-select ng-model=partnerSystem.gameId ng-change=partnerSystem.getInfo()><option value=\"{{ game.id }}\" ng-repeat=\"game in main._user.games\">{{ game.name }}</option></select></div><div class=clearfix></div></div></div></div><div class=card-block><div class=row><div class=col-md-12 ng-if=\"partnerSystem.info.history.length>0\"><table class=\"table table-bordered table-responsive\"><tr><th>{{ \'PARTNER_SYSTEM_HISTORY_COLUMN_PERIOD\' | translate }}</th><th>{{ \'PARTNER_SYSTEM_HISTORY_COLUMN_AMOUNT\' | translate }}</th><th>{{ \'PARTNER_SYSTEM_HISTORY_COLUMN_STATUS\' | translate }}</th></tr><tr ng-repeat=\"payment in partnerSystem.info.history\"><td>{{ payment.period }}</td><td>{{ payment.amount | currencyFix:main._user.currency }}</td><td><span ng-if=\"payment.status==0\" class=text-warning>{{ \'PARTNER_SYSTEM_HISTORY_STATUS_NOT_PAID\' | translate }}</span> <span ng-if=\"payment.status==1\" class=text-info>{{ \'PARTNER_SYSTEM_HISTORY_STATUS_PAID\' | translate }}</span> <span ng-if=\"payment.status==2\" class=text-success>{{ \'PARTNER_SYSTEM_HISTORY_STATUS_PAID_CONFIRMED\' | translate }}</span> <span ng-if=\"payment.status==3\" class=text-danger>{{ \'PARTNER_SYSTEM_HISTORY_STATUS_PAID_NOT_CONFIRMED\' | translate }}</span></td></tr></table></div><div class=col-md-12 ng-if=\"partnerSystem.info.history.length==0\"><p>{{ \'PARTNER_SYSTEM_HISTORY_NO_RECORD\' | translate }}</p></div></div></div></div>");
$templateCache.put("app/views/partner-system/top-players.html","<div class=\"card card-transparent\"><div class=card-header><div class=card-title>Top Players</div></div><div class=card-block><table class=\"table table-bordered table-responsive\"><tr><th>Player</th><th>Platform</th><th>Bet</th><th>Win</th><th>Profit</th></tr><tr ng-repeat=\"player in partnerSystem.topPlayers\"><td>{{player.username}}</td><td>{{player.siteId}}</td><td>{{player.bet | currencyFix:player.currency}}</td><td>{{player.win | currencyFix:player.currency}}</td><td ng-bind-html=\"player.profit | currencyFix:player.currency:true\"></td></tr></table><!--<canvas id=\"bar\" class=\"chart chart-bar\"--><!--chart-data=\"dashboard.topPlayers.data\" chart-labels=\"dashboard.topPlayers.labels\" chart-series=\"dashboard.topPlayers.series\">--><!--</canvas>--></div></div>");
$templateCache.put("app/views/product-hub/demo-area.html","<!--DEMO AREA START--><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'PRODUCT_HUB_DEMO_AREA_LIST_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div class=row ng-repeat=\"games in productHubDemoArea.list.records | chunkBy:4\"><div class=col-md-3 ng-repeat=\"game in games\"><div class=\"card social-card share share-other col1\" data-social=item><div class=card-content ng-if=\"game.image != null\"><img alt=\"{{ game.name }}\" ng-src=\"{{ game.image }}\"></div><div class=card-description><p><b>{{ \'PRODUCT_HUB_DEMO_AREA_LIST_BACKEND_VERSION\' | translate }} </b>: {{ game.version }}</p><p><b>{{ \'PRODUCT_HUB_DEMO_AREA_LIST_CLIENT_VERSION\' | translate }} </b>: {{ game.client_version }}</p></div><div class=\"card-header clearfix last\"><h5>{{ game.name }}</h5><!--<a ng-href=\"{{ productHubDemoArea.demoURL + \'/\' + game.id }}\" target=\"_blank\" class=\"btn btn-default btn-sm btn-block\">\n                                <i class=\"fa fa-gamepad\"></i> {{ \'PRODUCT_HUB_DEMO_AREA_LIST_PLAY_BTN\' | translate }}\n                            </a>--> <button type=button class=\"btn btn-default btn-sm btn-block\" ng-click=productHubDemoArea.playGame(game)><i class=\"fa fa-gamepad\"></i> {{ \'PRODUCT_HUB_DEMO_AREA_LIST_PLAY_BTN\' | translate }}</button></div></div></div></div><div class=row><div class=col-md-12><span class=\"label label-default\">{{ \'PRODUCT_HUB_DEMO_AREA_LIST_RECORDS\' | translate }} : {{ productHubDemoArea.list.totalResults }}</span> <span class=\"label label-default\">{{ \'PRODUCT_HUB_DEMO_AREA_LIST_PAGES\' | translate }} : {{ productHubDemoArea.list.totalPages }}</span></div><div class=clearfix></div><div class=col-md-12><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"productHubDemoArea.list.page>1\"><a ui-sref=management.productHub.news.list({page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"productHubDemoArea.list.page>1\"><a ui-sref=management.productHub.news.list({page:(productHubDemoArea.list.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':productHubDemoArea.list.page==pageNum}\" ng-repeat=\"pageNum in [] | range:productHubDemoArea.list.start:productHubDemoArea.list.end\"><a ui-sref=management.productHub.news.list({page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"productHubDemoArea.list.page<productHubDemoArea.list.totalPages\"><a ui-sref=management.productHub.news.list({page:(productHubDemoArea.list.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"productHubDemoArea.list.page<productHubDemoArea.list.totalPages\"><a ui-sref=management.productHub.news.list({page:productHubDemoArea.list.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div></div></div></div><script type=text/ng-template id=demoPlayModal.html><div class=\"modal-header clearfix text-left\">\n            <h5>{{ demoAreaGamePlay.game.name }} <small>{{ demoAreaGamePlay.game.version }} | {{ demoAreaGamePlay.game.client_version }}</small></h5>\n        </div>\n        <div class=\"modal-body\">\n            <iframe ng-src=\"{{ demoAreaGamePlay.trustSrc(demoAreaGamePlay.iframeUrl) }}\" style=\"width: 100%;height:-webkit-fill-available\"></iframe>\n        </div>\n        <div class=\"modal-footer\">\n\n        </div></script><!--DEMO AREA FINISH-->");
$templateCache.put("app/views/product-hub/media-pack-list.html","<div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'PRODUCT_HUB_MEDIA_PACK_LIST_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div class=row><div class=col-md-12><table class=\"table table-responsive table-bordered\"><tr><th>{{ \'PRODUCT_HUB_MEDIA_PACK_LIST_COLUMN_FILE_TYPE\' | translate }}</th><th>{{ \'PRODUCT_HUB_MEDIA_PACK_LIST_COLUMN_TITLE\' | translate }}</th><th>{{ \'PRODUCT_HUB_MEDIA_PACK_LIST_COLUMN_DESCRIPTION\' | translate }}</th><th>{{ \'PRODUCT_HUB_MEDIA_PACK_LIST_COLUMN_DATE\' | translate }}</th><th>{{ \'PRODUCT_HUB_MEDIA_PACK_LIST_COLUMN_LINK\' | translate }}</th></tr><tr ng-repeat=\"item in productHubMediaPackList.list.records\"><td><span><i class=\"fa fa-2x {{ item.icon }}\"></i><br>{{ item.extension }}</span></td><td>{{ item.title }}</td><td>{{ item.description }}</td><td>{{ item.date }}</td><td><a ng-href=\"{{ item.link }}\" download class=\"btn btn-default btn-sm\"><i class=\"fa fa-download\"></i> {{ \'PRODUCT_HUB_MEDIA_PACK_LIST_DOWNLOAD_BTN\' | translate }}</a></td></tr></table></div><div class=clearfix></div><div class=col-md-12><span class=\"label label-default\">{{ \'PRODUCT_HUB_MEDIA_PACK_LIST_RECORDS\' | translate }} : {{ productHubMediaPackList.list.totalResults }}</span> <span class=\"label label-default\">{{ \'PRODUCT_HUB_MEDIA_PACK_LIST_PAGES\' | translate }} : {{ productHubMediaPackList.list.totalPages }}</span></div><div class=clearfix></div><div class=col-md-12><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"productHubMediaPackList.list.page>1\"><a ui-sref=management.productHub.news.list({page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"productHubMediaPackList.list.page>1\"><a ui-sref=management.productHub.news.list({page:(productHubMediaPackList.list.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':productHubMediaPackList.list.page==pageNum}\" ng-repeat=\"pageNum in [] | range:productHubMediaPackList.list.start:productHubMediaPackList.list.end\"><a ui-sref=management.productHub.news.list({page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"productHubMediaPackList.list.page<productHubMediaPackList.list.totalPages\"><a ui-sref=management.productHub.news.list({page:(productHubMediaPackList.list.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"productHubMediaPackList.list.page<productHubMediaPackList.list.totalPages\"><a ui-sref=management.productHub.news.list({page:productHubMediaPackList.list.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/views/product-hub/media-pack.html","<!--MEDIA PACK START--><div ui-view></div><!--MEDIA PACK FINISH-->");
$templateCache.put("app/views/product-hub/news-list.html","<div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'PRODUCT_HUB_NEWS_LIST_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div class=row><div class=col-md-12 ng-repeat=\"item in productHubNewsList.list.records\"><div data-pages=card class=\"card card-default\"><div class=card-header><div class=card-title><h3>{{ item.title }}</h3></div></div><div class=card-block style=\"display: block\"><div class=row><div ng-if=\"item.image != null\" class=col-md-3><img alt={{item.title}} ng-src={{item.image}} style=\"width: 100%\"></div><div ng-class=\"{\'col-md-9\':item.image != null,\'col-md-12\':item.image == null}\"><p data-ng-bind-html=item.description></p><a href=\"{{ item.link }}\" ng-if=\"item.link != null\" class=\"btn btn-default btn-sm pull-right\" target=_blank>{{ \'PRODUCT_HUB_NEWS_LIST_READ_MORE\' | translate }} <i class=\"fa fa-angle-right\"></i></a></div></div></div></div></div><div class=clearfix></div><div class=col-md-12><span class=\"label label-default\">{{ \'PRODUCT_HUB_NEWS_LIST_RECORDS\' | translate }} : {{ productHubNewsList.list.totalResults }}</span> <span class=\"label label-default\">{{ \'PRODUCT_HUB_NEWS_LIST_PAGES\' | translate }} : {{ productHubNewsList.list.totalPages }}</span></div><div class=clearfix></div><div class=col-md-12><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"productHubNewsList.list.page>1\"><a ui-sref=management.productHub.news.list({page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"productHubNewsList.list.page>1\"><a ui-sref=management.productHub.news.list({page:(productHubNewsList.list.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':productHubNewsList.list.page==pageNum}\" ng-repeat=\"pageNum in [] | range:productHubNewsList.list.start:productHubNewsList.list.end\"><a ui-sref=management.productHub.news.list({page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"productHubNewsList.list.page<productHubNewsList.list.totalPages\"><a ui-sref=management.productHub.news.list({page:(productHubNewsList.list.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"productHubNewsList.list.page<productHubNewsList.list.totalPages\"><a ui-sref=management.productHub.news.list({page:productHubNewsList.list.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/views/product-hub/news.html","<!--NEWS START--><div ui-view></div><!--NEWS FINISH-->");
$templateCache.put("app/views/product-hub/product-hub.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><!--PRODUCT HUB START--><div ui-view></div><!--PRODUCT HUB FINISH--></div><div class=clearfix></div></div></div>");
$templateCache.put("app/views/product-hub/roadmap-list.html","<div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'PRODUCT_HUB_ROADMAP_LIST_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div class=row><div class=col-md-12><table class=\"table table-responsive table-bordered\"><tr><th>{{ \'PRODUCT_HUB_ROADMAP_LIST_COLUMN_TITLE\' | translate }}</th><th>{{ \'PRODUCT_HUB_ROADMAP_LIST_COLUMN_DESCRIPTION\' | translate }}</th><th>{{ \'PRODUCT_HUB_ROADMAP_LIST_COLUMN_TYPE\' | translate }}</th><th>{{ \'PRODUCT_HUB_ROADMAP_LIST_COLUMN_DATE\' | translate }}</th></tr><tr ng-repeat=\"item in productHubRoadmapList.list.records\"><td>{{ item.title }}</td><td>{{ item.description }}</td><td>{{ item.type }}</td><td>{{ item.date }}</td></tr></table></div><div class=clearfix></div><div class=col-md-12><span class=\"label label-default\">{{ \'PRODUCT_HUB_ROADMAP_LIST_RECORDS\' | translate }} : {{ productHubRoadmapList.list.totalResults }}</span> <span class=\"label label-default\">{{ \'PRODUCT_HUB_ROADMAP_LIST_PAGES\' | translate }} : {{ productHubRoadmapList.list.totalPages }}</span></div><div class=clearfix></div><div class=col-md-12><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"productHubRoadmapList.list.page>1\"><a ui-sref=management.productHub.news.list({page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"productHubRoadmapList.list.page>1\"><a ui-sref=management.productHub.news.list({page:(productHubRoadmapList.list.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':productHubRoadmapList.list.page==pageNum}\" ng-repeat=\"pageNum in [] | range:productHubRoadmapList.list.start:productHubRoadmapList.list.end\"><a ui-sref=management.productHub.news.list({page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"productHubRoadmapList.list.page<productHubRoadmapList.list.totalPages\"><a ui-sref=management.productHub.news.list({page:(productHubRoadmapList.list.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"productHubRoadmapList.list.page<productHubRoadmapList.list.totalPages\"><a ui-sref=management.productHub.news.list({page:productHubRoadmapList.list.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div></div></div></div>");
$templateCache.put("app/views/product-hub/roadmap.html","<!--ROADMAP START--><div ui-view></div><!--ROADMAP FINISH-->");
$templateCache.put("app/views/dashboard/dashboard.html","<div class=\"container-fluid padding-25 sm-padding-10\"><div class=row><div class=col-md-9><div class=row><div class=\"col-md-12 no-padding\"><div ng-include src=\"\'app/views/dashboard/total-statistics.html\'\" include-replace></div></div></div><div class=row><div class=\"col-md-6 no-padding\"><div ng-include src=\"\'app/views/dashboard/top-ten-games.html\'\" include-replace></div></div><div class=\"col-md-6 no-padding\"><div ng-include src=\"\'app/views/dashboard/top-players.html\'\" include-replace></div></div></div></div><div class=col-md-3><div class=row><div class=\"col-md-12 no-padding\"><div ng-include src=\"\'app/views/dashboard/news.html\'\" include-replace></div></div></div></div></div></div>");
$templateCache.put("app/views/dashboard/news.html","<div class=\"card card-transparent\"><div class=card-header><div class=card-title>{{ \'DASHBOARD_NEWS_TITLE\' | translate }}</div></div><div class=card-block><div class=row><div class=col-md-12 ng-repeat=\"news in dashboard.news\" ng-if=\"dashboard.news.length>0\"><div class=\"card social-card share share-other\" style=\"width: 100%\"><div class=card-description><p><a href={{news.link}}>{{news.title}}</a></p></div><div class=card-content ng-if=\"news.image != null\"><img alt={{news.title}} ng-src={{news.image}}></div><div class=card-description><div data-ng-bind-html=news.description></div></div><div class=\"card-footer clearfix\"><div class=time><i class=\"fa fa-calendar\"></i> {{news.created_at}}</div></div><div class=\"card-header clearfix last\" ng-if=\"news.link != null\"><a href={{news.link}} target=_blank>{{ \'DASHBOARD_NEWS_READ_MORE\' | translate }}</a></div></div></div><div class=col-md-12 ng-if=\"dashboard.news.length==0\"><p>There are no news at the moment</p></div></div></div></div>");
$templateCache.put("app/views/dashboard/roadmap.html","<div class=\"card card-transparent\"><div class=card-header><div class=card-title>{{ \'DASHBOARD_ROADMAP_TITLE\' | translate }}</div></div><div class=card-block></div></div>");
$templateCache.put("app/views/dashboard/top-players.html","<div class=\"card card-transparent\"><div class=card-header><div class=card-title>Top Winners</div></div><div class=card-block><table class=\"table table-bordered table-responsive\"><tr><th>Player</th><th>Platform</th><th>Bet</th><th>Win</th><th>Profit</th></tr><tr ng-repeat=\"player in dashboard.topPlayers\"><td>{{player.username}}</td><td>{{player.siteId}}</td><td>{{player.bet | currencyFix:player.currency}}</td><td>{{player.win | currencyFix:player.currency}}</td><td ng-bind-html=\"player.profit | currencyFix:player.currency:true\"></td></tr></table></div></div>");
$templateCache.put("app/views/dashboard/top-ten-games.html","<div class=\"card card-transparent\"><div class=card-header><div class=card-title>Top GAMES</div></div><div class=card-block><table class=\"table table-bordered table-responsive\"><tr><th>Game Name</th><th>#</th><th>Rounds</th></tr><tr ng-repeat=\"game in dashboard.topTenGames\"><td>{{game.name}}</td><td>{{game.value}} %</td><td>{{game.rounds | numberFix:main._user.currency}}</td></tr></table></div></div>");
$templateCache.put("app/views/dashboard/total-statistics.html","<div class=\"card card-transparent flex-row\"><ul class=\"nav nav-tabs nav-tabs-simple nav-tabs-left\" id=tab-3><li ng-repeat=\"(statKey, statType) in dashboard.statisticDateRanges\" class=nav-item><a ng-class=\"{\'active\': statType.isSelected}\" ng-click=dashboard.changeStats(statKey);>{{statType.title}}</a></li></ul><div class=tab-content><div class=\"tab-pane active\" id=spinStats><div class=row><div class=\"col-lg-4 m-b-10 no-padding-right\"><div class=\"widget-9 card no-border bg-complete-light no-margin widget-loader-bar\"><div class=\"full-height d-flex flex-column\"><div class=card-header><div class=\"card-title text-white\"><span class=\"font-montserrat fs-11 all-caps\">{{ \'DASHBOARD_TOTAL_STATISTICS_TOTAL_BET\' | translate }}</span></div></div><div class=card-block><h3 class=\"no-margin p-b-5 text-white\">{{ dashboard.totalStatistics.totalBet.amount | currencyFix:main._user.currency }}</h3><span class=\"small hint-text text-white\" ng-if=\"dashboard.totalStatistics.totalBet.amount > 0\"><b>Average: </b>{{ (dashboard.totalStatistics.totalBet.amount / dashboard.totalStatistics.totalBet.count) | currencyFix:main._user.currency }}</span></div></div></div></div><div class=\"col-lg-4 m-b-10 no-padding-right\"><div class=\"widget-9 card no-border bg-danger-light no-margin widget-loader-bar\"><div class=\"full-height d-flex flex-column\"><div class=card-header><div class=\"card-title text-white\"><span class=\"font-montserrat fs-11 all-caps\">{{ \'DASHBOARD_TOTAL_STATISTICS_TOTAL_WIN\' | translate }}</span></div></div><div class=card-block><h3 class=\"no-margin p-b-5 text-white\">{{ dashboard.totalStatistics.totalWin.amount | currencyFix:main._user.currency }}</h3><span class=\"small hint-text text-white\" ng-if=\"dashboard.totalStatistics.totalWin.amount > 0\"><b>Average: </b>{{ (dashboard.totalStatistics.totalWin.amount / dashboard.totalStatistics.totalWin.count) | currencyFix:main._user.currency }}</span></div></div></div></div><div class=\"col-lg-4 m-b-10 no-padding-right\"><div class=\"widget-9 card no-border bg-white no-margin widget-loader-bar\"><div class=\"full-height d-flex flex-column\"><div class=card-header><div class=\"card-title text-black\"><span class=\"font-montserrat fs-11 all-caps\">{{ \'DASHBOARD_TOTAL_STATISTICS_TOTAL_PROFIT\' | translate }}</span></div></div><div class=card-block><h3 class=\"no-margin p-b-5 text-black\"><span ng-class=\"{\'text-danger\':dashboard.totalStatistics.totalWin.amount>dashboard.totalStatistics.totalBet.amount,\n                                \'text-success\':dashboard.totalStatistics.totalBet.amount>dashboard.totalStatistics.totalWin.amount}\">{{ dashboard.totalStatistics.totalProfit | currencyFix:main._user.currency }}</span></h3><span class=\"small hint-text\" ng-if=\"dashboard.totalStatistics.totalBet.count > 0\"><b>Round count :</b>{{dashboard.totalStatistics.totalBet.count | numberFix:main._user.currency}}</span></div></div></div></div></div></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-lg-3\">--><!--<div class=\"widget-9 card no-border bg-primary no-margin widget-loader-bar\">--><!--<div class=\"full-height d-flex flex-column\">--><!--<div class=\"card-header \">--><!--<div class=\"card-title text-black\">--><!--<span class=\"font-montserrat fs-11 all-caps\">Weekly Sales <i class=\"fa fa-chevron-right\"></i>--><!--</span>--><!--</div>--><!--<div class=\"card-controls\">--><!--<ul>--><!--<li><a href=\"#\" class=\"card-refresh text-black\" data-toggle=\"refresh\"><i--><!--class=\"card-icon card-icon-refresh\"></i></a>--><!--</li>--><!--</ul>--><!--</div>--><!--</div>--><!--<div class=\"p-l-20\">--><!--<h3 class=\"no-margin p-b-5 text-white\">$23,000</h3>--><!--<a href=\"#\" class=\"btn-circle-arrow text-white\"><i class=\"pg-arrow_minimize\"></i>--><!--</a>--><!--<span class=\"small hint-text text-white\">65% lower than last month</span>--><!--</div>--><!--<div class=\"mt-auto\">--><!--<div class=\"progress progress-small m-b-20\">--><!--<div class=\"progress-bar progress-bar-white\" style=\"width:45%\"></div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/views/seamless-wallet/generator-tab-content.html","<div class=row style=\"margin: 10px\"><div class=\"col-md-8 col-sm-12\"><div class=row><div class=col-md-12><div class=form-inline><div class=form-group><input type=text ng-model=seamlessWalletGenerator.generator.domain class=\"form-control input-lg\" placeholder=\"{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_DOMAIN\' | translate }}\"></div><div class=form-group><input type=text ng-model=seamlessWalletGenerator.generator.url class=\"form-control input-lg\" placeholder=\"{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_URL\' | translate }}\"></div><button type=button class=\"btn btn-default btn-lg\" ng-disabled=main.loading ng-click=seamlessWalletGenerator.fakePost()><span class=\"p-t-5 p-b-5\"><i class=\"fa fa-15\" ng-class=\"{\'fa-spinner\': main.loading, \'fa-search\': !main.loading}\"></i> </span>{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_TEST_BTN\' | translate }}</button> <button type=button class=\"btn btn-default btn-lg\" ng-click=seamlessWalletGenerator.resetPostParameters()><span class=\"p-t-5 p-b-5\"><i class=\"fa fa-15 fa-trash\"></i> </span>{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_RESET_BTN\' | translate }}</button></div></div><div class=clearfix></div><div class=col-md-12><json-formatter class=json-formatter-dark open json=seamlessWalletGenerator.selectedObj></json-formatter></div><div class=clearfix></div><div class=col-md-12><h3>{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_POSTDATA\' | translate }}</h3><json-formatter open json=seamlessWalletGenerator.postData></json-formatter></div><div class=clearfix></div><div class=col-md-12><h3>{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_REQUESTDATA\' | translate }}</h3><json-formatter open json=seamlessWalletGenerator.requestData></json-formatter></div><div class=clearfix></div></div></div><div class=\"col-md-4 col-sm-12\"><table class=\"table table-hover table-condensed table-detailed\"><tr><th>{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_KEY\' | translate }}</th><th>{{ \'SEAMLESS_WALLET_INTEGRATION_GENERATOR_VALUE\' | translate }}</th><!--<th>#</th>--></tr><tr ng-repeat=\"objKey in seamlessWalletGenerator.selectedObjKeys\"><td><b>{{ objKey }}</b></td><td><!--{{ seamlessWalletGenerator.selectedObj[objKey] }}--> <input class=form-control type=text ng-model=seamlessWalletGenerator.selectedObj[objKey]></td><!--                <td>\n                    <button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"seamlessWalletGenerator.removeParam(objKey)\">\n                        <i class=\"fa fa-trash\"></i>\n                    </button>\n                </td>--></tr><!--<tr>\n                <td>\n                    <input class=\"form-control\" type=\"text\" ng-model=\"seamlessWalletGenerator.newParam.key\" ng-enter=\"seamlessWalletGenerator.addParam()\">\n                </td>\n                <td>\n                    <input class=\"form-control\" type=\"text\" ng-model=\"seamlessWalletGenerator.newParam.value\" ng-enter=\"seamlessWalletGenerator.addParam()\">\n                </td>\n                <td>\n                    <div class=\"text-center\">\n                        <button type=\"button\" class=\"btn btn-success\" ng-click=\"seamlessWalletGenerator.addParam()\">\n                            <i class=\"fa fa-plus\"></i>\n                        </button>\n                    </div>\n                </td>\n            </tr>--></table></div><div class=clearfix></div></div>");
$templateCache.put("app/views/seamless-wallet/generator.html","<div class=row><div class=col-md-12><ul class=\"nav nav-tabs nav-tabs-simple\" role=tablist data-init-reponsive-tabs=dropdownfx><li class=nav-item ng-repeat=\"tab in seamlessWalletGenerator.tabs.values\"><a ng-class=\"{\'active\':$index==seamlessWalletGenerator.tabs.active}\" data-toggle=tab role=tab data-target=\"#tab_{{ $index }}\" href=# ng-click=seamlessWalletGenerator.setActiveTab($index)>{{ tab.title }}</a></li></ul></div><div class=clearfix></div><div class=col-md-12><div class=tab-content><div class=tab-pane ng-class=\"{\'active\':$index==seamlessWalletGenerator.tabs.active}\" id=\"tab_{{ $index }}\" ng-repeat=\"tab in seamlessWalletGenerator.tabs.values\"><div class=\"row column-seperation\"><div ng-include src=tab.htmlUrl include-replace></div></div></div></div></div><div class=clearfix></div><div class=col-md-12></div><div class=clearfix></div></div>");
$templateCache.put("app/views/seamless-wallet/seamless-wallet.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><!--SEAMLESS WALLET INTEGRATION START--><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'SEAMLESS_WALLET_INTEGRATION_TITLE_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ui-view></div></div></div><!--SEAMLESS WALLET INTEGRATION FINISH--></div><div class=clearfix></div></div></div>");
$templateCache.put("app/views/seamless-wallet/test.html","<div class=row><div class=col-md-3><div class=\"form-group form-group-default input-group\"><label>{{ \'SEAMLESS_WALLET_INTEGRATION_TESTER_URL\' | translate }}</label><input type=text ng-model=seamlessWalletTest.tester.url class=form-control placeholder=\"{{ \'SEAMLESS_WALLET_INTEGRATION_TESTER_URL\' | translate }}\"></div></div><div class=col-md-3><div class=\"form-group form-group-default input-group\"><label>{{ \'SEAMLESS_WALLET_INTEGRATION_TESTER_PLAYER\' | translate }}</label><select class=full-width data-init-plugin=select2 ng-model=seamlessWalletTest.tester.playerId><option value=\"{{ player.id }}\" ng-repeat=\"player in seamlessWalletTest.players\">{{ player.username }}</option></select></div></div><div class=col-md-3><div class=\"form-group form-group-default input-group\"><label>{{ \'SEAMLESS_WALLET_INTEGRATION_TESTER_GAME\' | translate }}</label><select class=full-width data-init-plugin=select2 ng-model=seamlessWalletTest.tester.gameId><option value=\"{{ game.id }}\" ng-repeat=\"game in main._user.games\">{{ game.name }}</option></select></div></div><div class=col-md-3><button type=button class=\"btn btn-default btn-lg pull-right\" ng-disabled=main.loading ng-click=seamlessWalletTest.testIt()><span class=\"p-t-5 p-b-5\"><i class=\"fa fa-15\" ng-class=\"{\'fa-spinner\': main.loading, \'fa-search\': !main.loading}\"></i> </span>{{ \'SEAMLESS_WALLET_INTEGRATION_TESTER_TEST_BTN\' | translate }}</button></div><div class=clearfix></div><div class=col-md-12 ng-if=\"seamlessWalletTest.response.result != null\"><span ng-if=seamlessWalletTest.response.result class=\"text-success text-center\">{{ \'SEAMLESS_WALLET_INTEGRATION_TESTER_RESULT_SUCCESS\' | translate }} </span><span ng-if=!seamlessWalletTest.response.result class=\"text-danger text-center\">{{ \'SEAMLESS_WALLET_INTEGRATION_TESTER_RESULT_FAIL\' | translate }}</span></div><div class=clearfix></div><div class=col-md-12><json-formatter class=json-formatter-dark open json=seamlessWalletTest.response></json-formatter></div><div class=clearfix></div></div>");
$templateCache.put("app/views/reports/export-options.html","<!--<div class=\"pull-right\">--><!--<div class=\"btn-group\">--><!--<button class=\"btn btn-xs btn-default\" ng-click=\"report.setView(\'list\')\">--><!--<span><i class=\"fa fa-list\"></i> {{ \'SHOW_LIST\' | translate }}</span>--><!--</button>--><!--<button class=\"btn btn-xs btn-default\" ng-click=\"report.setView(\'graph\')\">--><!--<span><i class=\"fa fa-bar-chart\"></i> {{ \'EXPORT_GRAPH\' | translate }}</span>--><!--</button>--><!--<button class=\"btn btn-xs btn-default\">--><!--<span><i class=\"fa fa-file-pdf-o\"></i> {{ \'EXPORT_PDF\' | translate }}</span>--><!--</button>--><!--<button class=\"btn btn-xs btn-default\">--><!--<span><i class=\"fa fa-file-excel-o\"></i> {{ \'EXPORT_EXCEL\' | translate }}</span>--><!--</button>--><!--</div>--> <!--</div>-->");
$templateCache.put("app/views/reports/player.html","<script type=text/ng-template id=tree_node><tr tt-node is-branch=\"node.subAccIds.length>0\">\n        <td ng-show=\"main.filters.columns.options[0].active\" class=\"v-align-middle semi-bold\">\n            {{node.username}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[1].active\" class=\"v-align-middle\">\n            {{(node.bet/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[2].active\" class=\"v-align-middle\">\n            {{(node.win/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[3].active\" class=\"v-align-middle\">\n            {{(node.fpps/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[4].active\" class=\"v-align-middle\">\n            {{(node.jackpots/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[5].active\" class=\"v-align-middle\" ng-bind-html=\"(node.profit/100) | currencyFix:node.currency:true\"></td>\n\n        <td class=\"v-align-middle\">\n            <a ui-sref=\"management.report.session({playerId:node.id})\" ui-sref-opts=\"{reload: true}\" class=\"btn btn-info btn-sm\">\n                <i class=\"fa fa-search\"></i>\n                <span class=\"bold\">{{ \'REPORT_LIST_PLAYER_DETAILS_BTN\' | translate }}</span>\n                {{node.isOpen}}\n            </a>\n        </td>\n    </tr></script><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><div ng-if=\"report.exportsEnabled == true\" ng-include src=\"\'app/views/reports/export-options.html\'\" include-replace></div><div ng-if=\"main.filters.viewAs.visible==true && main.filters.viewAs.value==\'platform\' && report.siteRecords !== null\" ng-include src=\"\'app/views/partials/filter-view-as.html\'\" include-replace></div><p data-ng-bind-html=\"main.filters.viewAs.value == \'normal\' ? \'REPORT_LIST_PLAYER_DESC\' : \'REPORT_LIST_PLAYER_PLATFORM_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ng-if=!main.loading><!--GRAPH VIEW--><div ng-if=\"report.view == \'graph\'\" style=\"width: 100%\"><nvd3 options=report.graph.options data=report.graph.data config=report.graph.config events=report.graph.events api=report.graph.api on-ready=report.graph.callback></nvd3></div><!--GRAPH VIEW--><!--PLAYER LIST--><div ng-if=\"report.view == \'list\'\"><table tt-table tt-params=report.expandedRecords class=\"table table-hover table-condensed table-detailed\"><thead><tr><th ng-repeat=\"column in main.filters.columns.options\" ng-show=column.active>{{ column.columnName }}</th><th>#</th></tr></thead><tbody></tbody><tfoot class=bg-info-lighter ng-show=report.records><tr><th class=p-l-20>{{ \'REPORT_LIST_PLAYER_TOTAL\' | translate }}</th><th class=p-l-20 ng-show=main.filters.columns.options[1].active>{{(report.records.totals.bet/100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[2].active>{{(report.records.totals.win/100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[3].active>{{(report.records.totals.fpp/100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[4].active>{{(report.records.totals.jackpot/100) | currencyFix:report.currency}}</th><th class=p-l-20 colspan=2 ng-show=main.filters.columns.options[5].active ng-bind-html=\"(report.records.totals.profit/100) | currencyFix:report.currency:true\"></th></tr></tfoot></table><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.player({accountId:playerReport.extraData.accountId,accountName:playerReport.extraData.accountName,page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.player({accountId:playerReport.extraData.accountId,accountName:playerReport.extraData.accountName,page:(report.records.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':report.records.page==pageNum}\" ng-repeat=\"pageNum in [] | range:report.records.start:report.records.end\"><a ui-sref=management.report.player({accountId:playerReport.extraData.accountId,accountName:playerReport.extraData.accountName,page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.player({accountId:playerReport.extraData.accountId,accountName:playerReport.extraData.accountName,page:(report.records.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.player({accountId:playerReport.extraData.accountId,accountName:playerReport.extraData.accountName,page:report.records.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div><!--PLAYER LIST--></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div>");
$templateCache.put("app/views/reports/report.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><!--FILTERS START--><div ng-include src=\"\'app/views/partials/filters.html\'\" include-replace></div><!--FILTERS FINISH--></div><div class=clearfix></div><div class=\"col-lg-12 col-md-12\"><!--REPORT START--><div id=exportThis><div ui-view></div></div><!--REPORT FINISH--></div><div class=clearfix></div></div></div>");
$templateCache.put("app/views/reports/session-round-detail.html","<div class=modal-header><h3>Round Detail of {{sessionRoundDetailReport.roundId}} <button class=\"btn btn-danger pull-right\" ng-click=sessionRoundDetailReport.closeModal()><i class=\"fa fa-times\"></i> Close</button></h3></div><div class=\"modal-body no-padding\"><iframe ng-src=\"{{ sessionRoundDetailReport.iframeUrl }}\" style=\"width: 100%;min-height: 75vh;border:0px\"></iframe></div>");
$templateCache.put("app/views/reports/session-rounds.html","<script type=text/ng-template id=tree_node><tr tt-node is-branch=\"false\">\n    <td ng-show=\"main.filters.columns.options[0].active\">\n      #{{ node.player.id }} - {{ node.player.username }}\n    </td>\n    <td ng-show=\"main.filters.columns.options[1].active\" class=\"v-align-middle semi-bold\">\n      {{ node.con_id }}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[2].active\" class=\"v-align-middle semi-bold\">\n      {{ node.game.name }} #{{node.round}}\n    </td>\n    <td ng-show=\"main.filters.columns.options[3].active\" class=\"v-align-middle semi-bold\">\n      {{ node.site.domain }}\n    </td>\n    <td ng-show=\"main.filters.columns.options[4].active\" class=\"v-align-middle semi-bold\">\n      {{node.client_action}}\n      {{!!node.freeroundavailable ? \" (FR)\" :\"\"}}\n    </td>\n    <td ng-show=\"main.filters.columns.options[5].active\" class=\"v-align-middle\">\n      {{(node.old_credit/100) | currencyFix:node.currency}}\n    </td>\n    <td ng-show=\"main.filters.columns.options[6].active\" class=\"v-align-middle\">\n      {{(node.bet/100) | currencyFix:node.currency}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[7].active\" class=\"v-align-middle\">\n      {{(node.win/100) | currencyFix:node.currency}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[8].active\" class=\"v-align-middle\">\n      {{(node.credit/100) | currencyFix:node.currency}}\n    </td>\n\n\n    <td class=\"v-align-middle\">\n\n      <a ng-click=\"sessionRoundsReport.openModal(node.game.id,node.GameHistoryID);\" class=\"btn btn-info btn-sm\">\n        <i class=\"fa fa-search\"></i>\n        <span class=\"bold\">{{ \'REPORT_LIST_SESSION_DETAILS_BTN\' | translate }}</span>\n        {{node.isOpen}}\n      </a>\n    </td>\n  </tr></script><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><div ng-if=\"report.exportsEnabled == true\" ng-include src=\"\'app/views/reports/export-options.html\'\" include-replace></div><div ng-if=\"main.filters.viewAs.visible==true && main.filters.viewAs.value==\'platform\' && report.siteRecords !== null\" ng-include src=\"\'app/views/partials/filter-view-as.html\'\" include-replace></div><p data-ng-bind-html=\"main.filters.viewAs.value == \'normal\' ? \'REPORT_LIST_SESSION_DETAIL_DESC\' : \'REPORT_LIST_SESSION_DETAIL_PLATFORM_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ng-if=!main.loading><!--GRAPH VIEW--><div ng-if=\"report.view == \'graph\'\" style=\"width: 100%\"><nvd3 options=report.graph.options data=report.graph.data config=report.graph.config events=report.graph.events api=report.graph.api on-ready=report.graph.callback></nvd3></div><!--GRAPH VIEW--><!--SESSION LIST--><div ng-if=\"report.view == \'list\'\"><table tt-table tt-params=report.expandedRecords class=\"table table-hover table-condensed table-detailed\"><thead><tr><th ng-repeat=\"column in main.filters.columns.options\" ng-show=column.active>{{ column.columnName }}</th><th>#</th></tr></thead><tbody></tbody></table><span class=\"label label-default\">{{ \'TOTAL_ROUNDS_COUNT\' | translate }} : {{ report.records.totalCount }}</span> <span class=\"label label-default\">{{ \'PAGINATION_TOTAL_RECORDS\' | translate }} : {{ report.records.totalResults }}</span> <span class=\"label label-default\">{{ \'PAGINATION_TOTAL_PAGES\' | translate }} : {{ report.records.totalPages }}</span><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.sessionRounds({conId:sessionRoundsReport.extraData.conId,page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.sessionRounds({conId:sessionRoundsReport.extraData.conId,page:(report.records.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':report.records.page==pageNum}\" ng-repeat=\"pageNum in [] | range:report.records.start:report.records.end\"><a ui-sref=management.report.sessionRounds({conId:sessionRoundsReport.extraData.conId,page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.sessionRounds({conId:sessionRoundsReport.extraData.conId,page:(report.records.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.sessionRounds({conId:sessionRoundsReport.extraData.conId,page:report.records.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div><!--SESSION LIST--></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div>");
$templateCache.put("app/views/reports/session.html","<script type=text/ng-template id=tree_node><tr tt-node is-branch=\"false\">\n        <td ng-show=\"main.filters.columns.options[0].active\" class=\"v-align-middle semi-bold\">\n            {{node.conId}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[1].active\" class=\"v-align-middle semi-bold\">\n            {{node.playerName}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[2].active\" class=\"v-align-middle semi-bold\">\n            {{node.gameName}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[3].active\" class=\"v-align-middle\">\n            {{(node.bet/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[4].active\" class=\"v-align-middle\">\n            {{(node.win/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[5].active\" class=\"v-align-middle\">\n            {{(node.fpps/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[6].active\" class=\"v-align-middle\">\n            {{(node.jackpots/100) | currencyFix:node.currency}}\n        </td>\n\n        <td ng-show=\"main.filters.columns.options[7].active\" class=\"v-align-middle\" ng-bind-html=\"(node.profit/100) | currencyFix:node.currency:true\"></td>\n\n        <td ng-show=\"main.filters.columns.options[8].active\" class=\"v-align-middle\">\n            {{node.created_at}}\n        </td>\n\n        <td class=\"v-align-middle\">\n            <a ui-sref=\"management.report.sessionRounds({conId:node.conId})\" ui-sref-opts=\"{reload: true}\" class=\"btn btn-info btn-sm\">\n                <i class=\"fa fa-search\"></i>\n                <span class=\"bold\">{{ \'REPORT_LIST_SESSION_DETAILS_BTN\' | translate }}</span>\n                {{node.isOpen}}\n            </a>\n        </td>\n    </tr></script><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><div ng-if=\"report.exportsEnabled == true\" ng-include src=\"\'app/views/reports/export-options.html\'\" include-replace></div><div ng-if=\"main.filters.viewAs.visible==true && main.filters.viewAs.value==\'platform\' && report.siteRecords !== null\" ng-include src=\"\'app/views/partials/filter-view-as.html\'\" include-replace></div><p data-ng-bind-html=\"main.filters.viewAs.value == \'normal\' ? \'REPORT_LIST_SESSION_DESC\' : \'REPORT_LIST_SESSION_PLATFORM_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ng-if=!main.loading><!--GRAPH VIEW--><div ng-if=\"report.view == \'graph\'\" style=\"width: 100%\"><nvd3 options=report.graph.options data=report.graph.data config=report.graph.config events=report.graph.events api=report.graph.api on-ready=report.graph.callback></nvd3></div><!--GRAPH VIEW--><!--SESSION LIST--><div ng-if=\"report.view == \'list\'\"><table tt-table tt-params=report.expandedRecords class=\"table table-hover table-condensed table-detailed\"><thead><tr><th ng-repeat=\"column in main.filters.columns.options\" ng-show=column.active>{{ column.columnName }}</th><th>#</th></tr></thead><tbody></tbody><tfoot class=bg-info-lighter ng-show=report.records><tr><th class=p-l-20 colspan=3>{{ \'REPORT_LIST_SESSION_TOTAL\' | translate }}</th><th class=p-l-20 ng-show=main.filters.columns.options[3].active>{{(report.records.totals.bet/100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[4].active>{{(report.records.totals.win/100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[5].active>{{(report.records.totals.fpp/100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[6].active>{{(report.records.totals.jackpot/100) | currencyFix:report.currency}}</th><th class=p-l-20 colspan=2 ng-show=main.filters.columns.options[7].active ng-bind-html=\"(report.records.totals.profit/100) | currencyFix:report.currency:true\"></th></tr></tfoot></table><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.session({playerId:playerReport.extraData.playerId,page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.session({playerId:playerReport.extraData.playerId,page:(report.records.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':report.records.page==pageNum}\" ng-repeat=\"pageNum in [] | range:report.records.start:report.records.end\"><a ui-sref=management.report.session({playerId:playerReport.extraData.playerId,page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.session({playerId:playerReport.extraData.playerId,page:(report.records.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.session({playerId:playerReport.extraData.playerId,page:report.records.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav></div><!--SESSION LIST--></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div>");
$templateCache.put("app/views/reports/turnover-macaw.html","<script type=text/ng-template id=tree_node></script><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><p data-ng-bind-html=\"\'REPORT_LIST_MACAW_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ng-if=!main.loading><table class=\"table table-hover table-condensed table-detailed\"><thead><tr><th ng-repeat=\"column in main.filters.columns.options\" ng-show=column.active style={{column.styles}}>{{ column.columnName }}</th></tr></thead><tr ng-repeat=\"item in report.records.list\"><td ng-repeat=\"col in main.filters.columns.options\" style={{col.styles}} ng-show=col.active class=\"v-align-middle semi-bold\"><span ng-show=\"([\'bet\', \'win\', \'margin\',\'profit\'].indexOf(col.friendlyName) === -1)\" title=\"{{col.friendlyName ===\'siteName\' ? item[col.friendlyName] : \'\'}}\">{{item[col.friendlyName]}} </span><span ng-show=\"([\'bet\', \'win\', \'margin\',\'profit\'].indexOf(col.friendlyName) > -1)\">{{(item[col.friendlyName]) | currencyFix:\" \"}}</span></td></tr><tbody></tbody></table><nav aria-label=\"Page navigation\" class=text-center><ul class=pagination><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.macaw({page:1}) aria-label=First><span aria-hidden=true><i class=\"glyphicon glyphicon-step-backward\"></i></span></a></li><li ng-show=\"report.records.page>1\"><a ui-sref=management.report.macaw({page:(report.records.page-1)}) aria-label=Previous><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-left\"></i></span></a></li><li ng-class=\"{\'active\':report.records.page==pageNum}\" ng-repeat=\"pageNum in [] | range:report.records.start:report.records.end\"><a ui-sref=management.report.macaw({page:pageNum})>{{ pageNum }}</a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.macaw({page:(report.records.page+1)}) aria-label=Next><span aria-hidden=true><i class=\"glyphicon glyphicon-chevron-right\"></i></span></a></li><li ng-show=\"report.records.page<report.records.totalPages\"><a ui-sref=management.report.macaw({page:report.records.totalPages}) aria-label=Last><span aria-hidden=true><i class=\"glyphicon glyphicon-step-forward\"></i></span></a></li></ul></nav><div class=panel-heading><div class=panel-title><strong>{{\"MACAW_TOTALS\" | translate}}</strong></div></div><table class=\"table table-hover table-condensed table-detailed\"><thead><tr><th ng-repeat=\"column in main.filters.columns.options\" ng-show=column.active style={{column.styles}}>{{ [\'siteId\', \'siteName\'].indexOf(column.friendlyName) > -1 ? \'\' : column.columnName }}</th></tr></thead><tbody><tr ng-repeat=\"item in report.records.totals\" ng-show=!!item.bet><td ng-repeat=\"col in main.filters.columns.options\" ng-show=col.active class=\"v-align-middle semi-bold\"><span ng-show=\"([\'bet\', \'win\', \'margin\',\'profit\'].indexOf(col.friendlyName) === -1)\">{{item[col.friendlyName]}} </span><span ng-show=\"([\'bet\', \'win\', \'margin\',\'profit\'].indexOf(col.friendlyName) > -1)\">{{(item[col.friendlyName]) | currencyFix:\" \"}}</span></td></tr></tbody></table></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div>");
$templateCache.put("app/views/reports/turnover.html","<script type=text/ng-template id=tree_node><tr tt-node is-branch=\"node.subAccIds.length>0\"\n      ng-class=\"{\'isOpened\': node.isOpened, \'isHighlighted\': node.isHighlighted}\">\n    <td ng-show=\"main.filters.columns.options[0].active\" class=\"v-align-middle semi-bold\">\n      {{node.username}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[1].active\" class=\"v-align-middle\">\n      {{(node.deposits / 100) | currencyFix:node.currency}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[2].active\" class=\"v-align-middle\">\n      {{(node.withdraws / 100) | currencyFix:node.currency}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[3].active\" class=\"v-align-middle\">\n      {{(node.freeround_withdraws / 100) | currencyFix:node.currency}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[4].active\" class=\"v-align-middle\">\n      {{node.freeround_count}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[5].active\" class=\"v-align-middle\">\n      {{(!node.rtp || node.rtp == \"-\") ? \"-\" : \"%\" + (node.rtp | number:1) }}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[6].active\" class=\"v-align-middle\">\n      {{(!node.freeround_rtp || node.freeround_rtp == \"-\") ? \"-\" : \"%\" + (node.freeround_rtp) }}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[7].active\" class=\"v-align-middle\">\n      {{(node.jackpots / 100) | currencyFix:node.currency}}\n    </td>\n\n    <td ng-show=\"main.filters.columns.options[8].active\" class=\"v-align-middle\"\n        ng-bind-html=\"(node.profit/100) | currencyFix:node.currency:true\"></td>\n\n\n    <td class=\"v-align-middle\">\n      <button type=\"button\" ng-click=\"main.accountingExcelExport(node)\"\n              class=\"btn btn-success btn-sm excel-export-btn\"\n              ng-disabled=\"main.exportLoadingState.indexOf(node.id) > -1\"\n              ng-if=\"node.is_customer === \'1\'\">\n        <i class=\"fa fa-file-excel\" ng-class=\"{\'fa-spinner\': main.exportLoadingState.indexOf(node.id) > -1}\"></i>\n      </button>\n      <a ui-sref=\"management.report.player({accountId:node.id, accountName:node.username})\"\n         ui-sref-opts=\"{reload: true}\" class=\"btn btn-info btn-sm\">\n        <i class=\"fa fa-search\"></i>\n        <span class=\"bold\">{{ \'REPORT_LIST_ACCOUNT_DETAILS_BTN\' | translate }}</span>\n        {{node.isOpen}}\n      </a>\n    </td>\n  </tr></script><div class=\"panel panel-transparent\"><div class=panel-heading><div class=panel-title><div ng-if=\"main.filters.viewAs.visible==true && main.filters.viewAs.value==\'platform\' && report.siteRecords !== null\" ng-include src=\"\'app/views/partials/filter-view-as.html\'\" include-replace></div><p data-ng-bind-html=\"main.filters.viewAs.value == \'normal\' ? \'REPORT_LIST_ACCOUNT_DESC\' : \'REPORT_LIST_ACCOUNT_PLATFORM_DESC\' | translate | htmlSafe\"></p></div></div><div class=panel-body><div ng-if=!main.loading><!--ACCOUNT LIST--><table tt-table tt-params=report.expandedRecords ng-class=\"{\'filter-accounts\': !!main.filters.queryAccount.value && !!main.filters.queryAccount.enabled}\" class=\"table table-hover table-condensed table-detailed\"><thead><tr><th ng-repeat=\"column in main.filters.columns.options\" ng-show=column.active>{{ column.columnName }}</th><th>#</th></tr></thead><tbody></tbody><tfoot class=bg-info-lighter ng-show=report.records><tr><th class=p-l-20 ng-show=main.filters.columns.options[0].active>{{ \'REPORT_LIST_ACCOUNT_TOTAL\' | translate }}</th><th class=p-l-20 ng-show=main.filters.columns.options[1].active>{{(report.records.totals.deposit / 100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[2].active>{{(report.records.totals.withdraw / 100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[3].active>{{(report.records.totals.freeround_withdraws / 100) | currencyFix:report.currency}}</th><th class=p-l-20 ng-show=main.filters.columns.options[4].active>{{report.records.totals.freeround_count}}</th><th class=p-l-20 ng-show=main.filters.columns.options[5].active>{{\"%\" + (report.records.totals.rtp | number:1)}}</th><th class=p-l-20 ng-show=main.filters.columns.options[6].active>{{report.records.totals.freeround_rtp}}</th><th class=p-l-20 ng-show=main.filters.columns.options[7].active>{{(report.records.totals.jackpot / 100) | currencyFix:report.currency}}</th><th class=p-l-20 colspan=2 ng-show=main.filters.columns.options[8].active ng-bind-html=\"(report.records.totals.profit/100) | currencyFix:report.currency:true\"></th></tr></tfoot></table><!--ACCOUNT LIST--></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div>");
$templateCache.put("app/views/siteGames/site-games.html","<div class=\"container-fluid container-fixed-lg\"><div class=row><div class=\"col-lg-12 col-md-12\"><div class=\"panel panel-transparent\"><div class=panel-body><form name=personal id=form-personal role=form novalidate><div class=row><!--SITE FILTER START--><div class=col-sm-3><div form-group class=\"form-group form-group-default form-group-default-select\"><label><i class=\"fa fa-globe\"></i>{{ \'FILTER_PLATFORMS\' | translate }}</label><select class=\"cs-select cs-skin-slide\" ng-model=siteGames.site data-init-plugin=cs-select><option value={{site.id}} ng-repeat=\"site in main._user.sites\">{{ site.domain }}</option></select></div></div><!--SITE FILTER FINISH--><div class=col-sm-3><div class=\"btn-group btn-group-justified\"><div class=btn-group><button type=button class=\"btn btn-info\" ng-click=siteGames.getSiteGamesBySiteId()><span class=\"p-t-5 p-b-5\"><i class=\"fa fa-15\" ng-class=\"{\'fa-spinner\': main.loading, \'fa-search\': !main.loading}\"></i></span><br><span class=\"fs-11 font-montserrat text-uppercase\">{{ \'FILTER_SEARCH_BTN\' | translate }}</span></button></div></div></div><div class=clearfix></div></div></form></div></div></div><div class=clearfix></div><div class=\"col-lg-12 col-md-12\"><!--CUSTOMER DOCS START--><div class=\"panel panel-transparent\"><div class=panel-body><div class=row ng-if=!main.loading><div class=col-md-12><table class=\"table table-bordered table-responsive\"><thead><tr><th>{{ \'SITE_GAMES_COLUMNS_ID\' | translate }}</th><th>{{ \'SITE_GAMES_COLUMNS_GAME_NAME\' | translate }}</th><th>{{ \'SITE_GAMES_COLUMNS_GAME_FRIENDLY_NAME\' | translate }}</th><th>{{ \'SITE_GAMES_COLUMNS_GAME_VERSION\' | translate }}</th><th>{{ \'SITE_GAMES_COLUMNS_GAME_CLIENT_VERSION\' | translate }}</th><th>{{ \'SITE_GAMES_COLUMNS_GAME_STATUS\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"game in siteGames.list\"><td>{{ game.game_id }}</td><td>{{ game.refGame.name }}</td><td>{{ game.refGame.friendly_name }}</td><td>{{ game.refGame.version }}</td><td>{{ game.refGame.client_version }}</td><td><button type=button class=\"btn btn-sm\" ng-click=siteGames.toggleGameStatus(game) ng-class=\"{\'btn-success\':game.status==1,\'btn-danger\':game.status==0}\"><i class=fa ng-class=\"{\'fa-check\':game.status==1,\'fa-times\':game.status==0}\"></i></button></td></tr></tbody></table></div></div><div class=\"table-responsive text-center\" ng-if=main.loading><h1><i class=\"fa fa-spinner\"></i></h1><h1>{{ \'LIST_LOADING\' | translate }}</h1></div></div></div><!--CUSTOMER DOCS FINISH--></div><div class=clearfix></div></div></div>");}]);